(function () {
  console.log('upsell.js loaded');

  const SUPER_UPSELL_BUILD = 'drawer-catalog-fast-2026-09-15';
  function isSuperUpsellDebug() {
    try {
      return (
        window.__SUPER_UPSELL_DEBUG === true ||
        window.localStorage?.getItem('superUpsellDebug') === '1'
      );
    } catch {
      return window.__SUPER_UPSELL_DEBUG === true;
    }
  }
  function suDebug(...args) {
    if (!isSuperUpsellDebug()) return;
    console.log('[SuperUpsell]', ...args);
  }
  window.__superUpsellDebugDump = function superUpsellDebugDump() {
    const data = window.SUPER_UPSELL_DATA || null;
    const drawer = document.querySelector(
      'cart-drawer, #CartDrawer, cart-drawer-component, theme-drawer#cart-drawer'
    );
    const host = document.querySelector('super-upsell-drawer[data-super-upsell-drawer]');
    const widgets = document.querySelectorAll('[data-upsell-auto-injected^="cart-drawer-"]');
    const dump = {
      build: SUPER_UPSELL_BUILD,
      theme: window.Shopify?.theme || null,
      href: window.location.href,
      pageType: data?.pageType || null,
      offers: Array.isArray(data?.offers) ? data.offers.length : null,
      cartDrawerOffers: Array.isArray(data?.cartDrawerOffers) ? data.cartDrawerOffers.length : null,
      cartDrawerAutoInject: data?.settings?.placements?.cartDrawerAutoInject ??
        data?.widgetSettings?.placements?.cartDrawerAutoInject ??
        null,
      hasCartDrawer: Boolean(drawer),
      drawerTag: drawer?.tagName || null,
      drawerIsEmpty: drawer?.classList?.contains('is-empty') ?? null,
      hasHost: Boolean(host),
      hostParent: host?.parentElement?.tagName || null,
      mountedWidgets: widgets.length,
      cartItemCountHint: document.querySelectorAll('#CartDrawer-CartItems .cart-item, cart-drawer-items .cart-item').length
    };
    console.log('[SuperUpsell dump]', dump);
    return dump;
  };
  suDebug('boot', {
    build: SUPER_UPSELL_BUILD,
    theme: window.Shopify?.theme || null,
    href: window.location.href
  });

  // FBT disabled app-wide until ready
  const ENABLE_FBT = false;

  // v2: old `ab_test_assignment_*` keys were polluted by ?upsell_ab=A/B writing sticky.
  const AB_TEST_STORAGE_PREFIX = 'ab_test_assignment_v2_';
  const AB_TEST_LEGACY_PREFIX = 'ab_test_assignment_';
  /** Page / cart / collection widgets — shared assignment per ruleId. */
  const AB_SURFACE_PAGE = 'page';
  /** Cart drawer only — independent 50/50 per ruleId (separate localStorage key). */
  const AB_SURFACE_DRAWER = 'cart_drawer';

  /** Qorum India — store-specific cart drawer upsell layout (LESSON-084). */
  const QORUM_SHOP_DOMAINS = [
    'qorumindia.myshopify.com',
    'qorum-india.myshopify.com',
    'qorumindia.com',
    "qorum.in",
    'www.qorumindia.com',
    'k5i5us-m4.myshopify.com', // Qorum India live store
    'quick-start-18990d62.myshopify.com' // dev/test store
  ];
  const QORUM_HOSTNAMES = ['www.qorumindia.com', 'qorumindia.com',"qorum.in","www.qorum.in"];
  const QORUM_DRAWER_TITLE_DEFAULT = 'Complete the Look';
  const QORUM_DRAWER_SUBTITLE_DEFAULT = 'Handpicked for your watch';
  /** Left panel width when mounted outside the drawer dialog. */
  const QORUM_EXTERNAL_PANEL_WIDTH = 280;

  function normalizeAbSurface(surface) {
    const raw = String(surface || AB_SURFACE_PAGE).trim().toLowerCase();
    if (raw === AB_SURFACE_DRAWER || raw === 'drawer' || raw === 'cart-drawer') {
      return AB_SURFACE_DRAWER;
    }
    return AB_SURFACE_PAGE;
  }

  function getAbStorageKey(ruleId, abSurface = AB_SURFACE_PAGE) {
    const id = String(ruleId || '').trim();
    if (!id) return null;
    const surface = normalizeAbSurface(abSurface);
    if (surface === AB_SURFACE_DRAWER) {
      return `${AB_TEST_STORAGE_PREFIX}drawer_${id}`;
    }
    return `${AB_TEST_STORAGE_PREFIX}${id}`;
  }

  function readAbUrlOverride(abSurface = AB_SURFACE_PAGE) {
    try {
      const params = new URLSearchParams(window.location.search);
      const surface = normalizeAbSurface(abSurface);
      // Drawer QA: ?upsell_ab_drawer=A|B — page QA: ?upsell_ab=A|B
      const paramName = surface === AB_SURFACE_DRAWER ? 'upsell_ab_drawer' : 'upsell_ab';
      const raw = String(params.get(paramName) || '')
        .trim()
        .toLowerCase();
      if (!raw) return null;
      if (raw === 'a' || raw === 'b') return raw.toUpperCase();
      if (raw === 'random' || raw === 'reset' || raw === 'reroll') return 'REROLL';
      return null;
    } catch {
      return null;
    }
  }

  function rollAbVariant() {
    try {
      const bytes = new Uint8Array(1);
      window.crypto.getRandomValues(bytes);
      return bytes[0] < 128 ? 'A' : 'B';
    } catch {
      return Math.random() < 0.5 ? 'A' : 'B';
    }
  }

  /** Stable A/B assignment for this page load (init + drawer remounts share the same roll). */
  const abVariantSessionCache = Object.create(null);

  function getAbVariantCacheKey(ruleId, abSurface) {
    return `${normalizeAbSurface(abSurface)}:${String(ruleId || '').trim()}`;
  }

  function getAbVariantForRule(ruleId, abSurface = AB_SURFACE_PAGE) {
    const id = String(ruleId || '').trim();
    const surface = normalizeAbSurface(abSurface);
    const storageKey = getAbStorageKey(id, surface);
    const cacheKey = getAbVariantCacheKey(id, surface);
    const urlOverride = readAbUrlOverride(surface);

    // QA: force A/B for this surface only (also write so tracking matches UI)
    if (urlOverride === 'A' || urlOverride === 'B') {
      abVariantSessionCache[cacheKey] = urlOverride;
      if (storageKey) {
        try {
          window.localStorage?.setItem(storageKey, urlOverride);
          if (surface === AB_SURFACE_DRAWER) {
            window.localStorage?.removeItem(`${AB_TEST_LEGACY_PREFIX}drawer_${id}`);
          } else {
            window.localStorage?.removeItem(`${AB_TEST_LEGACY_PREFIX}${id}`);
          }
        } catch {
          /* ignore */
        }
      }
      return urlOverride;
    }

    if (!id) return 'A';

    if (Object.prototype.hasOwnProperty.call(abVariantSessionCache, cacheKey)) {
      return abVariantSessionCache[cacheKey];
    }

    // Fresh 50/50 once per page load per surface+ruleId (remounts reuse same assignment).
    const assigned = rollAbVariant();
    abVariantSessionCache[cacheKey] = assigned;
    try {
      if (storageKey) window.localStorage?.setItem(storageKey, assigned);
      if (surface === AB_SURFACE_DRAWER) {
        window.localStorage?.removeItem(`${AB_TEST_LEGACY_PREFIX}drawer_${id}`);
      } else {
        window.localStorage?.removeItem(`${AB_TEST_LEGACY_PREFIX}${id}`);
      }
    } catch {
      /* ignore */
    }
    return assigned;
  }

  /**
   * Liquid may emit BOTH variant A + B product pools for isABTest rules.
   * Pass `{ abSurface: 'cart_drawer' }` for drawer — independent assignment from page.
   */
  function applyAbTestFilter(offerList, options = {}) {
    const abSurface = normalizeAbSurface(options.abSurface || options.surface);
    const list = Array.isArray(offerList) ? offerList : [];
    const assignmentCache = Object.create(null);
    const selected = [];
    const seenKeys = new Set();

    for (const offer of list) {
      if (!offer || typeof offer !== 'object') continue;

      let keep = true;
      let variantLabel = String(offer.variantLabel || offer.abVariant || 'A').toUpperCase();

      if (offer.isABTest) {
        const ruleId = String(offer.ruleId || '').trim();
        if (ruleId) {
          if (!Object.prototype.hasOwnProperty.call(assignmentCache, ruleId)) {
            assignmentCache[ruleId] = getAbVariantForRule(ruleId, abSurface);
          }
          const assigned = assignmentCache[ruleId];
          const pool = String(offer.abVariant || offer.variantLabel || 'A').toUpperCase();
          keep = pool === assigned;
          variantLabel = assigned;
        } else {
          keep = String(offer.abVariant || 'A').toUpperCase() === 'A';
          variantLabel = 'A';
        }
      }

      if (!keep) continue;

      const dedupeKey = `${offer.handle || offer.id || ''}|${offer.offerType || 'upsells'}|${offer.ruleId || ''}|${abSurface}`;
      if (seenKeys.has(dedupeKey)) continue;
      seenKeys.add(dedupeKey);

      selected.push({
        ...offer,
        variantLabel,
        abVariant: variantLabel,
        abSurface
      });
    }

    return selected;
  }

  window.__superUpsellGetAbVariant = getAbVariantForRule;
  window.__superUpsellApplyAbTestFilter = applyAbTestFilter;

  function filterRuntimeOfferList(offerList, abSurface = AB_SURFACE_PAGE) {
    return applyAbTestFilter(
      (Array.isArray(offerList) ? offerList : []).filter(
        (offer) => ENABLE_FBT || offer.offerType !== 'fbt'
      ),
      { abSurface }
    );
  }

  /**
   * Drawer mount/remount: filter raw Liquid pools once; skip re-filter when already
   * drawer-assigned (otherwise a second roll drops every offer from the list).
   */
  function filterDrawerOffersForMount(offerList) {
    const list = (Array.isArray(offerList) ? offerList : []).filter(
      (offer) => ENABLE_FBT || offer.offerType !== 'fbt'
    );
    if (!list.length) return [];

    const hasAbRules = list.some((offer) => offer?.isABTest);
    const alreadyDrawerFiltered = list.some((offer) => offer?.abSurface === AB_SURFACE_DRAWER);

    if (!hasAbRules || alreadyDrawerFiltered) {
      return list;
    }

    return filterRuntimeOfferList(list, AB_SURFACE_DRAWER);
  }

  window.__superUpsellFilterRuntimeOffers = filterRuntimeOfferList;
  window.__superUpsellFilterDrawerOffersForMount = filterDrawerOffersForMount;

  function runAfterCartMorph(event, callback) {
    if (event?.promise?.then) {
      event.promise.then(callback).catch(() => {});
      return;
    }
    callback();
  }

  const SUPER_UPSELL_UI_SELECTOR =
    '.upsell-container, super-upsell-drawer, .upsell-slider, .upsell-slider-controls, .upsell-slider-btn, .upsell-header, .upsell-grid, .qorum-upsell-panel, [data-upsell-auto-injected], [data-upsell-form], .upsell-atc-btn, .upsell-card';

  function isSuperUpsellUiElement(el) {
    if (!(el instanceof Element)) return false;
    return Boolean(el.closest(SUPER_UPSELL_UI_SELECTOR));
  }

  function markSuperUpsellSliderInteraction() {
    window.__superUpsellSliderInteractUntil = Date.now() + 1200;
  }

  function isSuperUpsellSliderInteractionActive() {
    return Date.now() < (window.__superUpsellSliderInteractUntil || 0);
  }

  function getDrawerOffersFingerprint(offers) {
    if (!Array.isArray(offers)) return '';
    return offers
      .map((offer) =>
        [
          offer?.ruleId ?? '',
          offer?.handle ?? '',
          offer?.variant_id ?? '',
          offer?.offerType ?? ''
        ].join(':')
      )
      .join('|');
  }

  function registerGlobalCartAwareWatchers() {
    // Hot-reload safe: drop previous listeners before re-binding.
    if (window.__superUpsellCartWatchAbort) {
      try {
        window.__superUpsellCartWatchAbort.abort();
      } catch (_) {
        /* ignore */
      }
    }
    window.__superUpsellCartWatchAbort = new AbortController();
    const { signal } = window.__superUpsellCartWatchAbort;
    window.__superUpsellGlobalCartWatch = true;

    // One coalesced path for all cart events:
    // 1) remount from cached offers (no network)
    // 2) one debounced network refresh (not per-event / not via MutationObserver)
    const onCartDataChange = (event) => {
      runAfterCartMorph(event, () => {
        if (isSuperUpsellSliderInteractionActive()) return;
        window.__superUpsellRemountDrawerIfMissing?.();
        window.__superUpsellScheduleDrawerRemountRetries?.();
        window.__superUpsellQueueDrawerOfferRefresh?.();
      });
    };

    const isCartDrawerOpenTarget = (target) => {
      if (!(target instanceof Element)) return false;
      if (
        target.id === 'cart-drawer' ||
        target.id === 'CartDrawer' ||
        target.id === 'Cart-Drawer'
      ) {
        return true;
      }
      if (
        target.matches?.(
          'cart-drawer-component, theme-drawer#cart-drawer, cart-drawer, .cart-drawer, .mini_cart_wrap, .ajax-cart, .cart-drawer__dialog'
        )
      ) {
        return true;
      }
      return Boolean(
        target.closest?.(
          'theme-drawer#cart-drawer, #cart-drawer, #CartDrawer, #Cart-Drawer, cart-drawer, cart-drawer-component, .cart-drawer, .mini_cart_wrap, .ajax-cart'
        )
      );
    };

    const restoreDrawerOnOpen = () => {
      // Horizon opens via dialog:open / dialog toggle — not theme-drawer:open.
      // Restore from cache immediately; fetch only if remount failed.
      window.__superUpsellRemountDrawerIfMissing?.();
      window.__superUpsellScheduleDrawerRemountRetries?.();
      if (!document.querySelector('[data-upsell-auto-injected^="cart-drawer-"]')) {
        window.__superUpsellQueueDrawerOfferRefresh?.();
      }
      window.__superUpsellAdaptDrawerContrast?.();
      if (isQorumShop()) queueQorumDrawerRefresh();
    };

    const onCartDrawerOpen = (event) => {
      if (!isCartDrawerOpenTarget(event?.target)) return;
      restoreDrawerOnOpen();
    };

    const onDialogToggle = (event) => {
      const target = event.target;
      if (!(target instanceof HTMLDialogElement)) return;
      if (event.newState && event.newState !== 'open') return;
      if (!target.open && event.newState !== 'open') return;
      if (!isCartDrawerOpenTarget(target)) return;
      restoreDrawerOnOpen();
    };

    document.addEventListener('cart:updated', onCartDataChange, { signal });
    document.addEventListener('cart:refresh', onCartDataChange, { signal });
    document.addEventListener('cart:change', onCartDataChange, { signal });
    document.addEventListener('product:added', onCartDataChange, { signal });
    document.addEventListener('theme:cart:change', onCartDataChange, { signal });
    document.addEventListener('theme:cart:update', onCartDataChange, { signal });
    document.addEventListener('shopify:cart:lines-update', onCartDataChange, { signal });
    document.addEventListener('shopify:cart:discount-update', onCartDataChange, { signal });
    document.addEventListener('shopify:cart:note-update', onCartDataChange, { signal });
    document.addEventListener('theme-drawer:open', onCartDrawerOpen, { signal });
    // Horizon / native <dialog> cart drawers
    document.addEventListener('dialog:open', onCartDrawerOpen, { signal });
    document.addEventListener('toggle', onDialogToggle, { capture: true, signal });

    // Slider prev/next must not trigger cart drawer remount / network refresh.
    document.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (target.closest('.upsell-slider-btn, .upsell-slider-controls')) {
          markSuperUpsellSliderInteraction();
        }
      },
      { capture: true, signal }
    );

    // Horizon quantity/remove often morphs the drawer WITHOUT Shopify cart DOM events.
    // Catch line-item UI interactions early; fetch hook covers the network completion.
    const onCartDrawerInteract = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (isSuperUpsellUiElement(target)) return;

      const control = target.closest(
        'button, a, input, [role="button"], quantity-input, quantity-selector, cart-remove-button, .cart-remove-button'
      );
      if (!control) return;

      // Never treat Super Upsell slider/ATC UI as a cart line change — that remounted
      // the drawer widget and reset slider scroll (prev button stuck disabled).
      if (isSuperUpsellUiElement(control)) return;

      const inDrawer = control.closest(
        'cart-drawer-component, theme-drawer#cart-drawer, cart-drawer, #cart-drawer, #CartDrawer, #Cart-Drawer, .cart-drawer, .mini_cart_wrap, .ajax-cart'
      );
      if (!inDrawer) return;

      // Only real cart LINE controls — not the whole cart-items-component wrapper
      // (Heritage/Horizon wraps summary + upsell inside cart-items-component too).
      const inLineItems = Boolean(
        control.closest(
          '.cart-drawer__items, .cart-items, .cart-item, [data-cart-item], .cart-items__table-row, quantity-selector, quantity-input, cart-remove-button, .cart-remove-button'
        )
      );
      const label = `${control.getAttribute('aria-label') || ''} ${control.getAttribute('name') || ''} ${control.textContent || ''}`.toLowerCase();
      const isQtyOrRemove =
        inLineItems ||
        control.matches('input[name="updates[]"], input[type="number"]') ||
        /remove|decrease|increase|minus|plus|quantity|delete/.test(label) ||
        control.getAttribute('name') === 'minus' ||
        control.getAttribute('name') === 'plus';

      if (!isQtyOrRemove) return;

      window.__superUpsellScheduleDrawerRemountRetries?.();
      window.__superUpsellQueueDrawerOfferRefresh?.();
    };
    document.addEventListener('click', onCartDrawerInteract, { capture: true, signal });
    document.addEventListener('change', onCartDrawerInteract, { capture: true, signal });

    hookCartNetworkForDrawerRefresh(signal);
  }

  function isCartMutatingUrl(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i.test(String(url || ''));
  }

  function notifyCartNetworkMutation() {
    // Last item removed → Dawn marks is-empty before our network refresh finishes.
    // Clear immediately so stale cached offers cannot remount an empty upsell shell.
    if (isLiveCartEmpty()) {
      clearCartDrawerUpsellUI();
    } else {
      window.__superUpsellRemountDrawerIfMissing?.();
    }
    window.__superUpsellScheduleDrawerRemountRetries?.();
    window.__superUpsellQueueDrawerOfferRefresh?.();
  }

  // Horizon cart remove/qty uses fetch("/cart/change...") without emitting cart events.
  function hookCartNetworkForDrawerRefresh(signal) {
    if (!window.__superUpsellNativeFetch) {
      window.__superUpsellNativeFetch = window.fetch.bind(window);
    }

    window.fetch = async function superUpsellFetch(input, init) {
      const response = await window.__superUpsellNativeFetch(input, init);
      try {
        if (!signal?.aborted) {
          const url = typeof input === 'string' ? input : input?.url || '';
          if (isCartMutatingUrl(url)) {
            // Fire on next tick so cart response body can settle, without a long wait.
            window.setTimeout(notifyCartNetworkMutation, 0);
          }
        }
      } catch (_) {
        /* ignore */
      }
      return response;
    };
  }

  registerGlobalCartAwareWatchers();

  window.__superUpsellDrawerApi = {
    mount(host, drawerOffers) {
      window.__superUpsellDrawerMountImpl?.(host, drawerOffers);
    },
    clear(host) {
      if (host instanceof HTMLElement) host.replaceChildren();
    }
  };

  function stripSuperUpsellJsonComments(text) {
    return String(text || 'null').replace(/<!--[\s\S]*?-->/g, '').trim();
  }

  function parseSuperUpsellPayloadText(text) {
    try {
      let cleanText = stripSuperUpsellJsonComments(text);
      let parsed = JSON.parse(cleanText);
      if (typeof parsed === 'string') {
        parsed = JSON.parse(stripSuperUpsellJsonComments(parsed));
      }
      return parsed;
    } catch (error) {
      console.error('Super Upsell: parse error', error);
      return null;
    }
  }

  function normalizeSuperUpsellData(raw) {
    let data = raw;
    if (typeof data === 'string') {
      data = parseSuperUpsellPayloadText(data);
      if (!data) return null;
    }
    if (!data || typeof data !== 'object' || Array.isArray(data)) return null;
    return data;
  }

  // ── Multi-theme cart drawer / cart page targets (LESSON-041) ──────────────
  // Keep in sync with app/utils/upsellThemeTargets.js. Auto-detect by default;
  // optional widgetSettings.themePreset / themeTarget overrides (no Settings UI change).
  const UPSELL_THEME_PRESETS = {
    dawn: {
      drawerSelector: 'cart-drawer, #CartDrawer, .cart-drawer',
      drawerRootSelector: 'cart-drawer .drawer__inner, cart-drawer #CartDrawer, cart-drawer',
      headerSelector: '.drawer__header, .cart-drawer__header',
      drawerUpsellMount: '.cart-drawer__footer, .drawer__footer',
      drawerUpsellInsert: 'beforebegin',
      cartPageMount:
        '#main-cart-items, cart-items, .cart__items, form[action="/cart"], .cart__footer, .main-cart-footer',
      cartPageItems: '#main-cart-items, cart-items, .main-cart-items'
    },
    refresh: {
      drawerSelector: 'cart-drawer, #CartDrawer, .cart-drawer',
      drawerRootSelector: 'cart-drawer .drawer__inner, cart-drawer #CartDrawer, cart-drawer',
      headerSelector: '.drawer__header, .cart-drawer__header',
      drawerUpsellMount: '.cart-drawer__footer, .drawer__footer',
      drawerUpsellInsert: 'beforebegin',
      cartPageMount:
        '#main-cart-items, cart-items, .cart__items, form[action="/cart"], .cart__footer, .main-cart-footer',
      cartPageItems: '#main-cart-items, cart-items, .main-cart-items'
    },
    minimalista: {
      drawerSelector: 'cart-drawer, #CartDrawer, .cart-drawer',
      drawerRootSelector: 'cart-drawer .drawer__inner, cart-drawer #CartDrawer, cart-drawer',
      headerSelector: '.drawer__header, .cart-drawer__header',
      drawerUpsellMount: '.cart-drawer__footer, .drawer__footer',
      drawerUpsellInsert: 'beforebegin',
      cartPageMount: '#main-cart-items, cart-items, .cart__items, form[action="/cart"], .cart__footer',
      cartPageItems: '#main-cart-items, cart-items'
    },
    viola: {
      drawerSelector: 'cart-drawer, #CartDrawer, .cart-drawer',
      drawerRootSelector: 'cart-drawer .drawer__inner, cart-drawer #CartDrawer, cart-drawer',
      headerSelector: '.drawer__header, .cart-drawer__header',
      drawerUpsellMount: '.cart-drawer__footer, .drawer__footer',
      drawerUpsellInsert: 'beforebegin',
      cartPageMount: '#main-cart-items, cart-items, form[action="/cart"], .cart__footer',
      cartPageItems: '#main-cart-items, cart-items'
    },
    horizon: {
      drawerSelector: 'cart-drawer-component, theme-drawer#cart-drawer, #cart-drawer, .cart-drawer',
      drawerRootSelector:
        'cart-drawer-component .cart-drawer__inner, theme-drawer#cart-drawer cart-drawer-component, #cart-drawer cart-drawer-component, cart-drawer-component',
      headerSelector: '#cart-drawer-header, .cart-drawer__header, .cart-drawer__heading',
      // Horizon / Heritage: placements are relative to form#cart-form (before/after/append).
      // Host stays near summary only for refresh lifecycle.
      drawerUpsellMount:
        'form#cart-form.cart-form, form#cart-form[action="/cart"], form.cart-form[action="/cart"], form[action="/cart"], .cart-drawer__summary, .cart-drawer__checkout, [ref="checkoutButtons"], .cart-drawer__footer',
      drawerUpsellInsert: 'beforebegin',
      cartPageMount:
        'form#cart-form, form.cart-form[action="/cart"], form[action="/cart"], .cart__summary, .cart-summary, [data-cart-subtotal], .cart__footer, .main-cart-footer',
      cartPageItems: 'cart-items-component, .cart-page__items, cart-items, form#cart-form'
    },
    prestige: {
      drawerSelector:
        'cart-drawer#cart-drawer:not(.drawer--cart), #cart-drawer:not(.drawer--cart), cart-drawer.cart-drawer',
      drawerRootSelector: 'cart-drawer#cart-drawer, #cart-drawer, cart-drawer.cart-drawer',
      headerSelector: '[slot="header"], cart-drawer > .h4, #cart-drawer > .h4, p.h4',
      drawerUpsellMount: '[slot="footer"], .drawer__footer, .cart-drawer__footer, line-item',
      drawerUpsellInsert: 'beforebegin',
      cartPageMount: '.cart, #main .cart, form[action="/cart"], .cart-section',
      cartPageItems: '.cart__items, line-item, form[action="/cart"]'
    },
    enterprise: {
      drawerSelector:
        'cart-drawer#cart-drawer.drawer--cart, #cart-drawer.drawer--cart, #cart-drawer, cart-drawer.drawer--cart',
      drawerRootSelector: '#cart-drawer.drawer--cart, #cart-drawer, cart-drawer.drawer--cart',
      headerSelector: 'header.drawer__header, .drawer__header',
      drawerUpsellMount: '.drawer__footer, .cart-drawer__footer, .cart-drawer__content',
      drawerUpsellInsert: 'beforebegin',
      cartPageMount: '#main-cart, .cart-page, form[action="/cart"], .cart__footer',
      cartPageItems: 'cart-items, #main-cart .cart-items, form[action="/cart"]'
    },
    habitat: {
      drawerSelector:
        'cart-drawer#Cart-Drawer, #Cart-Drawer, cart-drawer.side-panel, .cart-drawer.side-panel',
      drawerRootSelector: '#Cart-Drawer, cart-drawer.side-panel, .cart-drawer.side-panel',
      headerSelector: '.side-panel-header',
      drawerUpsellMount: '.side-panel-footer, .drawer__footer, .side-panel-content',
      drawerUpsellInsert: 'beforebegin',
      cartPageMount: '#main-cart-items, .cart, form[action="/cart"], .cart__footer',
      cartPageItems: '#main-cart-items, .cart-items'
    },
    aromaedge: {
      drawerSelector: '.mini_cart_wrap, .drawer_main, .cart.cart_drawer',
      drawerRootSelector: '.mini_cart_wrap, .drawer_main, .cart.cart_drawer',
      headerSelector: '.drawer_header',
      drawerUpsellMount: '.drawer_footer, .cart_drawer_footer, .mini_cart_footer',
      drawerUpsellInsert: 'beforebegin',
      cartPageMount: '.cart_page, #cart, form[action="/cart"], .cart-footer',
      cartPageItems: '.cart_items, #cart form, form[action="/cart"]'
    },
    impulse: {
      drawerSelector: '#CartDrawer, .cart-drawer, .drawer--right, .drawer--cart, .ajax-cart',
      drawerRootSelector: '#CartDrawer, .cart-drawer, .drawer--right, .ajax-cart',
      headerSelector: '.drawer__header, .cart-drawer__header, .ajax-cart__header',
      drawerUpsellMount: '.drawer__footer, .ajax-cart__footer, .cart-drawer__footer',
      drawerUpsellInsert: 'beforebegin',
      cartPageMount:
        '#MainContent .cart, form[action="/cart"], .cart__footer, .cart__checkout-wrapper',
      cartPageItems: '.cart__items, form.cart, form[action="/cart"]'
    },
    auto: {
      drawerSelector:
        'theme-drawer#cart-drawer, #cart-drawer, cart-drawer-component, cart-drawer, #CartDrawer, #Cart-Drawer, .cart-drawer, [data-cart-drawer], .drawer--cart, .mini_cart_wrap, .ajax-cart, .drawer--right',
      drawerRootSelector:
        'cart-drawer-component .cart-drawer__inner, theme-drawer#cart-drawer cart-drawer-component, #cart-drawer cart-drawer-component, cart-drawer .drawer__inner, cart-drawer #CartDrawer, #Cart-Drawer, cart-drawer, #CartDrawer, .mini_cart_wrap, .ajax-cart',
      headerSelector:
        '#cart-drawer-header, .cart-drawer__header, .drawer__header, .side-panel-header, [slot="header"], .drawer_header, .ajax-cart__header',
      drawerUpsellMount:
        '.cart-drawer__summary, .cart-drawer__checkout, .cart-drawer__footer, .drawer__footer, .side-panel-footer, .ajax-cart__footer, .drawer_footer, [slot="footer"]',
      drawerUpsellInsert: 'beforebegin',
      cartPageMount:
        '.cart__summary, .cart-summary, cart-items-component, .cart-page__items, #main-cart-items, cart-items, .cart__items, form[action="/cart"], .cart__footer, .main-cart-footer, .cart__footer-wrapper, [data-cart-subtotal]',
      cartPageItems:
        'cart-items-component, .cart-page__items, #main-cart-items, cart-items, .main-cart-items, .cart__items'
    },
    custom: {}
  };

  function getUpsellWidgetSettingsFromBootstrap() {
    const data = window.SUPER_UPSELL_DATA;
    if (!data || typeof data !== 'object') return {};
    return data.widgetSettings || data.settings || {};
  }

  function getThemeNameTokens() {
    const schema = String(window.Shopify?.theme?.schema_name || '').toLowerCase();
    const name = String(window.Shopify?.theme?.name || '').toLowerCase();
    return `${schema} ${name}`;
  }

  function detectUpsellThemeFamily() {
    const tokens = getThemeNameTokens();
    const host = String(window.location?.hostname || '').toLowerCase();

    if (host.includes('lifeinlilac') || document.querySelector('.mini_cart_wrap, .drawer_header')) {
      return 'aromaedge';
    }
    if (/\benterprise\b/.test(tokens) || document.querySelector('#cart-drawer.drawer--cart, cart-drawer.drawer--cart')) {
      return 'enterprise';
    }
    if (
      /\bprestige\b/.test(tokens) ||
      (document.querySelector('cart-drawer#cart-drawer, #cart-drawer') &&
        document.querySelector('[slot="header"], line-item') &&
        !document.querySelector('.drawer--cart') &&
        !document.querySelector('#CartDrawer'))
    ) {
      return 'prestige';
    }
    if (
      /\bhabitat\b|\bhabitage\b/.test(tokens) ||
      document.querySelector('#Cart-Drawer.side-panel, cart-drawer#Cart-Drawer, .side-panel-header')
    ) {
      return 'habitat';
    }
    // Horizon OS family: Horizon, Heritage, Tinker, Atelier, Savor, Pitch, etc.
    // Same cart-drawer-component / .cart-drawer__summary mount contract (LESSON-041).
    if (
      /\bhorizon\b|\bheritage\b|\btinker\b|\batelier\b|\bsavor\b|\bpitch\b/.test(tokens) ||
      document.querySelector('cart-drawer-component, theme-drawer#cart-drawer')
    ) {
      return 'horizon';
    }
    if (/\bimpulse\b/.test(tokens) || document.querySelector('.ajax-cart, .drawer--right')) {
      return 'impulse';
    }
    if (/\brefresh\b/.test(tokens)) return 'refresh';
    if (/\bminimalista\b/.test(tokens)) return 'minimalista';
    if (/\bviola\b/.test(tokens)) return 'viola';
    if (/\bdawn\b/.test(tokens) || document.querySelector('cart-drawer#CartDrawer, #CartDrawer, cart-drawer')) {
      return 'dawn';
    }
    return 'auto';
  }

  function stripEmptyThemeTarget(obj) {
    const out = {};
    if (!obj || typeof obj !== 'object') return out;
    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      if (value == null) return;
      if (typeof value === 'string' && !value.trim()) return;
      out[key] = typeof value === 'string' ? value.trim() : value;
    });
    return out;
  }

  function resolveUpsellThemeTarget() {
    const settings = getUpsellWidgetSettingsFromBootstrap();
    let presetKey = String(settings.themePreset || 'auto').toLowerCase();
    if (presetKey === 'auto') {
      presetKey = detectUpsellThemeFamily();
    }
    const base =
      presetKey === 'custom'
        ? { ...(UPSELL_THEME_PRESETS.auto || {}) }
        : { ...(UPSELL_THEME_PRESETS[presetKey] || UPSELL_THEME_PRESETS.auto) };
    const overrides = stripEmptyThemeTarget(settings.themeTarget);
    const resolved = { ...base, ...overrides, presetKey };
    if (settings.selectorClass && String(settings.selectorClass).trim()) {
      resolved.drawerSelector = String(settings.selectorClass).trim();
    }
    return resolved;
  }

  function queryFirstFromSelectorList(selectorList, root = document) {
    if (!selectorList || !root?.querySelector) return null;
    const parts = String(selectorList)
      .split(',')
      .map((part) => part.trim())
      .filter(Boolean);
    for (const selector of parts) {
      try {
        const el = root.querySelector(selector);
        if (el) return el;
      } catch (_) {
        /* invalid selector — skip */
      }
    }
    return null;
  }

  function findCartDrawerElement() {
    const target = resolveUpsellThemeTarget();
    return (
      queryFirstFromSelectorList(target.drawerSelector) ||
      document.querySelector(
        'theme-drawer#cart-drawer, #cart-drawer, cart-drawer-component, cart-drawer, #CartDrawer, #Cart-Drawer, .cart-drawer, [data-cart-drawer], .drawer--cart, .mini_cart_wrap, .ajax-cart'
      )
    );
  }

  function isViewingCartPage() {
    return (
      window.SUPER_UPSELL_DATA?.pageType === 'cart' ||
      window.location.pathname.includes('/cart')
    );
  }

  /**
   * Drawer cart form: prefer real `form[action="/cart"]` (items / totals),
   * never upsell ATC forms. Summary is last-resort fallback only.
   */
  function findDrawerCartForm(searchRoot = document) {
    const root = searchRoot?.querySelector ? searchRoot : document;
    const preferred =
      root.querySelector('form#CartDrawer-Form') ||
      root.querySelector('form#cart-form[action="/cart"]') ||
      root.querySelector('form.cart-drawer__form[action="/cart"]') ||
      root.querySelector('form.cart-form[action="/cart"]') ||
      root.querySelector('form#cart_form[action="/cart"]') ||
      root.querySelector('form.shopify-cart-form[action="/cart"]') ||
      root.querySelector('cart-items-component form[action="/cart"]') ||
      root.querySelector('cart-items form[action="/cart"]') ||
      root.querySelector('.cart-items__wrapper form[action="/cart"]') ||
      root.querySelector('form[action="/cart"]');

    if (preferred && !preferred.classList.contains('upsell-form')) {
      return preferred;
    }

    const forms = root.querySelectorAll('form[action="/cart"], form[action*="/cart"]');
    for (const form of forms) {
      if (form.classList.contains('upsell-form')) continue;
      if (form.classList.contains('cart-discount__form')) continue;
      const action = String(form.getAttribute('action') || '');
      // Exact /cart or /cart?… — not /cart/add
      if (action === '/cart' || /^\/cart(\?|$)/.test(action)) {
        return form;
      }
    }
    return null;
  }

  function initSuperUpsell() {
    if (window.__superUpsellBootstrapBroken) return;

    const data = normalizeSuperUpsellData(window.SUPER_UPSELL_DATA);
    if (!data) return;
    window.SUPER_UPSELL_DATA = data;

    const hasPendingManualMounts = document.querySelector('[data-upsell-mount]:not([data-upsell-mounted])');
    const pageForManualCheck = data.pageType || 'product';
    const manualTypes = (() => {
      const types = new Set();
      document
        .querySelectorAll(
          '[data-upsell-block][data-offer-type], [data-upsell-mount][data-offer-type]'
        )
        .forEach((block) => {
          const blockPage = block.getAttribute('data-page-context');
          if (blockPage && blockPage !== pageForManualCheck) return;
          const blockType = block.getAttribute('data-offer-type');
          if (blockType) types.add(blockType);
        });
      return types;
    })();
    const hasAutoDuplicateForManual = [...manualTypes].some((offerType) =>
      document.querySelector(`[data-upsell-auto-injected$="-${offerType}"]:not([data-upsell-block])`)
    );

    // Allow re-init when widgets were removed (variant change, theme hot reload, etc.)
    const hasUnrenderedManualMounts = document.querySelector(
      '[data-upsell-mount]:not([data-upsell-mounted])'
    );
    const hasRenderedManualWidgets = document.querySelector(
      '[data-upsell-block][data-upsell-js-rendered]'
    );
    const forceCartRefresh = Boolean(window.__superUpsellForceCartRefresh);
    if (forceCartRefresh) {
      window.__superUpsellForceCartRefresh = false;
    }

    if (
      window.__superUpsellInitDone &&
      !forceCartRefresh &&
      !hasPendingManualMounts &&
      !hasUnrenderedManualMounts &&
      !hasAutoDuplicateForManual &&
      (document.querySelector('[data-upsell-auto-injected]') || hasRenderedManualWidgets)
    ) {
      if (window.__superUpsellDrawerMountImpl) {
        remountDrawerWidgetsIfMissing();
      }
      return;
    }

    window.__superUpsellInitDone = true;

  let rawOffers = data.offers;
  if (typeof rawOffers === 'string') {
    try {
      rawOffers = JSON.parse(rawOffers);
    } catch {
      rawOffers = [];
    }
  }
  let offers = applyAbTestFilter(
    (Array.isArray(rawOffers) ? rawOffers : []).filter(
      (offer) => ENABLE_FBT || offer.offerType !== 'fbt'
    ),
    { abSurface: AB_SURFACE_PAGE }
  );
  let activePageOffers = offers.slice();
  let rawCartDrawerOffers = data.cartDrawerOffers;
  if (typeof rawCartDrawerOffers === 'string') {
    try {
      rawCartDrawerOffers = JSON.parse(rawCartDrawerOffers);
    } catch {
      rawCartDrawerOffers = [];
    }
  }
  let cartDrawerOffers = applyAbTestFilter(
    (Array.isArray(rawCartDrawerOffers) ? rawCartDrawerOffers : []).filter(
      (offer) => ENABLE_FBT || offer.offerType !== 'fbt'
    ),
    { abSurface: AB_SURFACE_DRAWER }
  );
  let activeCartDrawerOffers = cartDrawerOffers.slice();

  // Persist AB-filtered pools so remount/inspect sees assigned variants only
  if (window.SUPER_UPSELL_DATA) {
    window.SUPER_UPSELL_DATA.offers = offers;
    window.SUPER_UPSELL_DATA.cartDrawerOffers = cartDrawerOffers;
  }

  const widgetSettings = data.widgetSettings || {};
  const pageConfig = data.pageConfig || {};
  const drawerPageConfig = data.drawerPageConfig || pageConfig;
  const display = widgetSettings.display || {};
  const appearance = widgetSettings.appearance || {};
  const placements = widgetSettings.placements || {};
  const behavior = widgetSettings.behavior || {};
  const pageType = data.pageType || 'product';
 

  const pagePlacementDisabled =
    (pageType === 'product' && placements.productPage === false) ||
    (pageType === 'cart' && placements.cartPage === false) ||
    (pageType === 'collection' && placements.collectionPage === false);

  function getShopifyRootPath() {
    return window.Shopify?.routes?.root || '/';
  }

  function getEmbedSectionId() {
    const fromData = window.SUPER_UPSELL_DATA?.embedSectionId;
    if (typeof fromData === 'string' && fromData.trim()) return fromData.trim();

    const node = document.getElementById('super-upsell-data-json');
    const host = node?.closest('[id^="shopify-section-"]');
    if (host?.id?.startsWith('shopify-section-')) {
      return host.id.slice('shopify-section-'.length);
    }

    return null;
  }

  function parseEmbedSectionHtml(payload, sectionId) {
    if (!payload || !sectionId) return null;
    const html = payload[sectionId];
    if (!html) return null;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const node = doc.getElementById('super-upsell-data-json');
    if (!node?.textContent?.trim()) return null;

    return normalizeSuperUpsellData(parseSuperUpsellPayloadText(node.textContent));
  }

  const OFFER_TYPE_ORDER = ['cross_sells', 'upsells', 'fbt'];

  function groupOffersByType(offerList) {
    const grouped = {};
    offerList.forEach((offer) => {
      const type = offer.offerType || 'upsells';
      if (!grouped[type]) grouped[type] = [];
      grouped[type].push(offer);
    });
    return grouped;
  }

  function getSettingText(settings, keys, fallback = '') {
    const sources = [settings.display, settings.appearance, settings.behavior];
    for (const key of keys) {
      for (const source of sources) {
        const value = source?.[key];
        if (typeof value === 'string' && value.trim()) return value.trim();
      }
    }
    return fallback;
  }

  function getBadgeForType(display, offerType, pageCfg = pageConfig) {
    const fromPage = pageCfg?.badges?.[offerType];
    if (typeof fromPage === 'string' && fromPage.trim()) return fromPage.trim();

    const badgeFromDisplay = display?.badgeText;
    if (typeof badgeFromDisplay === 'string' && badgeFromDisplay.trim()) return badgeFromDisplay.trim();

    return 'POPULAR';
  }

  function getHeadingForType(display, page, offerType, pageCfg = pageConfig) {
    const fromPage = pageCfg?.headings?.[offerType];
    if (typeof fromPage === 'string' && fromPage.trim()) return fromPage.trim();

    const pageSuffix =
      page === 'cart' ? 'Cart' : page === 'collection' ? 'Collection' : 'ProductPage';

    if (offerType === 'cross_sells') {
      return (
        display[`headingCrossSell${pageSuffix}`] ||
        display.headingCrossSell ||
        display.crossSellHeading ||
        (page === 'cart' ? display.headingCart : null) ||
        'Customers also bought'
      );
    }

    if (offerType === 'fbt') {
      return display.headingFbt || 'Frequently Bought Together';
    }

    return (
      display[`headingUpsell${pageSuffix}`] ||
      display.headingUpsell ||
      (page === 'cart'
        ? display.headingCart
        : page === 'collection'
          ? display.headingCollection
          : display.headingProductPage) ||
      "Don't forget these!"
    );
  }

  function getLayoutForType(display, offerType, pageCfg = pageConfig) {
    const fromPage = pageCfg?.layouts?.[offerType];
    if (typeof fromPage === 'string' && fromPage.trim()) return fromPage.trim();

    if (offerType === 'cross_sells') {
      const crossLayout = display.layoutCrossSell || display.crossSellLayout;
      if (typeof crossLayout === 'string' && crossLayout.trim()) return crossLayout.trim();
    }

    if (offerType === 'upsells') {
      const upsellLayout = display.layoutUpsell || display.upsellLayout;
      if (typeof upsellLayout === 'string' && upsellLayout.trim()) return upsellLayout.trim();
    }

    if (offerType === 'fbt') {
      const fbtLayout = display.layoutFbt || display.fbtLayout;
      if (typeof fbtLayout === 'string' && fbtLayout.trim()) return fbtLayout.trim();
    }

    const globalLayout = display?.layout;
    if (typeof globalLayout === 'string' && globalLayout.trim()) return globalLayout.trim();

    return 'grid';
  }

  function getAddButtonLabel(settings, hasAvailableVariant, pageCfg = pageConfig, offerType = 'upsells') {
    const typeButtons = pageCfg?.buttons?.[offerType];

    if (!hasAvailableVariant) {
      const soldOut = typeButtons?.soldOut || pageCfg?.buttons?.soldOut;
      if (typeof soldOut === 'string' && soldOut.trim()) return soldOut.trim();

      return getSettingText(settings, ['soldOutButtonText', 'soldOutText', 'buttonSoldOutText'], 'Sold out');
    }

    const addLabel = typeButtons?.add || pageCfg?.buttons?.add;
    if (typeof addLabel === 'string' && addLabel.trim()) return addLabel.trim();

    return getSettingText(
      settings,
      ['addButtonText', 'buttonText', 'buttonLabel', 'addToCartButtonText', 'atcButtonText'],
      'Add'
    );
  }

  function normalizeLocationSettings(raw) {
    if (!raw || typeof raw !== 'object') return {};

    const selector = String(
      raw.injectionSelector || raw.customSelector || raw.selector || raw.custom_selector || ''
    ).trim();

    return {
      ...raw,
      injectionSelector: selector,
      injectionLocation: raw.injectionLocation || raw.placement || raw.location || 'after_form'
    };
  }

  function getPageLocationBaseKey(page) {
    if (page === 'product') return 'productPage';
    if (page === 'cart') return 'cartPage';
    if (page === 'collection') return 'collectionPage';
    return '';
  }

  function getQorumThemeBucket() {
    const qorum = window.SUPER_UPSELL_DATA?.qorum;
    if (!qorum || typeof qorum !== 'object') return {};
    return window.matchMedia('(min-width: 750px)').matches
      ? qorum.desktop || {}
      : qorum.mobile || {};
  }

  function prefersQorumExternalDesktopPanel() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  function resolveQorumThemeInjectionLocation(rawLocation, customPlacement) {
    const location = String(rawLocation || 'after_form').trim().toLowerCase();
    if (location !== 'custom') return location;

    const mode = String(customPlacement || 'after').trim().toLowerCase();
    if (mode === 'before') return 'custom_before';
    if (mode === 'append') return 'custom_append';
    return 'custom_after';
  }

  function getQorumDrawerLocationOverride(offerType) {
    const qorum = window.SUPER_UPSELL_DATA?.qorum;
    if (!qorum || typeof qorum !== 'object') return null;

    const bucket = getQorumThemeBucket();
    const isCrossSell = offerType === 'cross_sells';
    const prefix = isCrossSell ? 'crossSell' : 'upsell';
    const rawLocation = bucket[`${prefix}InjectionLocation`];
    const selector = bucket[`${prefix}InjectionSelector`];
    const customPlacement = bucket[`${prefix}CustomPlacement`];

    if (!rawLocation && !selector) return null;

    const injectionLocation = resolveQorumThemeInjectionLocation(rawLocation, customPlacement);

    return normalizeLocationSettings({
      injectionLocation,
      injectionSelector: selector || '',
    });
  }

  function getLocationSettingsForType(page, context, offerType) {
    const isCrossSell = offerType === 'cross_sells';
    const suffix = isCrossSell ? 'CrossSell' : 'Upsell';
    const pageBase = getPageLocationBaseKey(page);

    if (context === 'drawer') {
      const base = normalizeLocationSettings(
        widgetSettings[`cartDrawerLocation${suffix}`] ||
          widgetSettings.cartDrawerLocationUpsell ||
          widgetSettings.cartDrawerLocation ||
          {}
      );
      const qorumOverride = getQorumDrawerLocationOverride(offerType);
      if (qorumOverride) {
        return normalizeLocationSettings({ ...base, ...qorumOverride });
      }
      return base;
    }

    if (!pageBase) return {};

    return normalizeLocationSettings(
      widgetSettings[`${pageBase}Location${suffix}`] ||
        widgetSettings[`${pageBase}LocationUpsell`] ||
        widgetSettings[`${pageBase}Location`] ||
        widgetSettings.location?.[page] ||
        {}
    );
  }

  function resolveInjectionConfig(page, context, offerType) {
    const location = getLocationSettingsForType(page, context, offerType);
    if (location.autoInject === false) return null;

    return {
      autoInject: location.autoInject !== false,
      selector: String(location.injectionSelector || '').trim(),
      injectionLocation: location.injectionLocation || 'after_form'
    };
  }

  const UPSELL_QUICK_ADD_CONTEXT_SELECTOR =
    '.quick-add, .quick-add-modal, quick-add-modal, .quick-add__product-form-component, [data-quick-add]';

  function isUpsellQuickAddContext(node) {
    if (!node) return false;
    return Boolean(node.closest?.(UPSELL_QUICK_ADD_CONTEXT_SELECTOR));
  }

  function isUpsellPaymentTermsForm(form) {
    if (!form) return false;
    return (
      form.classList.contains('payment-terms') ||
      /^product-form-installment/i.test(form.id || '')
    );
  }

  function pickProductPageRoot(scope) {
    if (!scope) return null;
    return (
      scope.querySelector('[data-testid="product-information-details"]') ||
      scope.querySelector('[id^="ProductInformation-"]') ||
      scope.querySelector('.product-details') ||
      scope.querySelector('[data-testid="product-information"]') ||
      scope.querySelector('.product-information') ||
      scope.querySelector('product-info') ||
      scope.querySelector('#ProductInfo') ||
      scope.querySelector('.product__info-wrapper') ||
      null
    );
  }

  function getMainProductFormComponent(searchRoot = document) {
    const productRoot = getProductPageSearchRoot(searchRoot);
    const scopes = productRoot && productRoot !== document ? [productRoot] : [searchRoot || document];

    for (const scope of scopes) {
      const component =
        scope.querySelector(
          '[data-testid="product-information-details"] product-form-component:not(.quick-add__product-form-component)'
        ) ||
        scope.querySelector(
          '.product-information product-form-component:not(.quick-add__product-form-component)'
        ) ||
        scope.querySelector(
          '[data-testid="product-information"] product-form-component:not(.quick-add__product-form-component)'
        );
      if (component) return component;
    }

    return null;
  }

  function getInjectionContexts(page) {
    const contexts = [];

    if (page === 'product' && placements.productPageAutoInject !== false) {
      contexts.push({ id: 'product-page', context: 'page' });
    }
    if (page === 'collection' && placements.collectionPageAutoInject !== false) {
      contexts.push({ id: 'collection-page', context: 'page' });
    }
    if (page === 'cart' && placements.cartPageAutoInject !== false) {
      contexts.push({ id: 'cart-page', context: 'page' });
    }
    // Cart drawer is handled exclusively by the <super-upsell-drawer> web component.

    return contexts;
  }

  function getBlockOfferType(block) {
    const direct = block.getAttribute('data-offer-type');
    if (direct) return direct;

    const types = new Set();
    block.querySelectorAll('[data-offer-type]').forEach((el) => {
      const type = el.getAttribute('data-offer-type');
      if (type) types.add(type);
    });

    if (types.size === 1) return [...types][0];
    return null;
  }

  function getManualBlockOfferTypesForPage(page) {
    const types = new Set();

    document
      .querySelectorAll(
        '[data-upsell-block][data-offer-type], [data-upsell-mount][data-offer-type]'
      )
      .forEach((block) => {
        const blockPage = block.getAttribute('data-page-context');
        if (blockPage && blockPage !== page) return;

        const blockType = getBlockOfferType(block);
        if (blockType) types.add(blockType);
      });

    return types;
  }

  function hasManualBlocksForPage(page) {
    return getManualBlockOfferTypesForPage(page).size > 0;
  }

  function removeAutoInjectedWidgetsForManualOfferTypes(page) {
    const manualTypes = getManualBlockOfferTypesForPage(page);
    if (!manualTypes.size) return;

    document.querySelectorAll('[data-upsell-auto-injected]').forEach((widget) => {
      if (widget.hasAttribute('data-upsell-block')) return;

      const autoId = widget.getAttribute('data-upsell-auto-injected') || '';
      if (autoId.startsWith('cart-drawer-')) return;

      const widgetPage = widget.getAttribute('data-page-context') || page;
      if (widgetPage !== page) return;

      const offerType = widget.getAttribute('data-offer-type');
      if (manualTypes.has(offerType)) {
        widget.remove();
      }
    });
  }

  function removeAutoInjectedWidgetsForManualBlocks(page) {
    removeAutoInjectedWidgetsForManualOfferTypes(page);
  }

  function getProductLimitForPage(displaySettings, blockPage) {
    if (blockPage === 'cart') {
      return displaySettings.maxProductsCart || displaySettings.maxProducts || 0;
    }
    if (blockPage === 'collection') {
      return displaySettings.maxProductsCollection || displaySettings.maxProducts || 0;
    }
    return displaySettings.maxProductsProductPage || displaySettings.maxProducts || 0;
  }

  function renderManualBlockTarget(target, offerList, settings, page) {
    const offerType = getBlockOfferType(target);
    if (!offerType) return false;

    const blockPage = target.getAttribute('data-page-context') || page;
    const contextOffers =
      blockPage === 'drawer' ? getOffersForContext('drawer') : getOffersForContext('page');
    const grouped = groupOffersByType(contextOffers);
    let typeOffers = (grouped[offerType] || []).filter(
      (offer) => (offer.offerType || 'upsells') === offerType
    );

    const displayLimit = getProductLimitForPage(settings.display || display, blockPage);
    if (Number.isFinite(displayLimit) && displayLimit > 0) {
      typeOffers = typeOffers.slice(0, displayLimit);
    }

    if (!typeOffers.length) {
      target.setAttribute('data-upsell-empty', 'true');
      target.setAttribute('data-upsell-mounted', 'true');
      target.style.display = 'none';
      return true;
    }

    target.removeAttribute('data-upsell-empty');
    const headingOverride = target.getAttribute('data-upsell-heading');
    const existingHeading = target.querySelector('.upsell-heading')?.textContent?.trim() || '';
    const customHeading = headingOverride || existingHeading;

    const contextId = `manual-${blockPage}-${offerType}`;
    const container = buildUpsellContainer(typeOffers, settings, blockPage, contextId, offerType);
    if (!container) return false;

    container.removeAttribute('data-upsell-auto-injected');
    container.setAttribute('data-upsell-block', '');
    container.setAttribute('data-upsell-manual', 'true');
    container.setAttribute('data-offer-type', offerType);
    container.setAttribute('data-page-context', blockPage);
    container.setAttribute('data-upsell-js-rendered', 'true');

    const pageOnlyClasses = new Set(['ctm-upsell-container', 'upsell-container--collection']);

    const customClass = target.getAttribute('data-upsell-custom-class');
    if (customClass) {
      customClass.split(/\s+/).forEach((cls) => {
        const trimmed = cls.trim();
        if (!trimmed) return;
        if (blockPage !== 'collection' && pageOnlyClasses.has(trimmed)) return;
        container.classList.add(trimmed);
      });
    }
    target.classList.forEach((cls) => {
      const trimmed = cls.trim();
      if (!trimmed) return;
      if (blockPage !== 'collection' && pageOnlyClasses.has(trimmed)) return;
      container.classList.add(trimmed);
    });
    if (blockPage === 'collection') {
      container.classList.add('ctm-upsell-container');
    }

    if (customHeading) {
      const headingEl = container.querySelector('.upsell-heading');
      if (headingEl) headingEl.textContent = customHeading;
    }

    const inProductDetails = target.closest(
      '[data-testid="product-information-details"], product-info, .product-information, .product-details, .product__info-wrapper, #ProductInfo, .product__info-container'
    );
    if (blockPage === 'product' && !inProductDetails) {
      container.classList.add('upsell-container--block-standalone');
    }

    target.replaceWith(container);
    finishUpsellMount(
      container,
      blockPage === 'drawer' ? 'cart' : blockPage,
      blockPage === 'drawer' ? 'drawer' : 'page',
      container.parentElement
    );
    bindUpsellEvents(container, settings.behavior || behavior);
    return true;
  }

  function mountManualUpsellBlocks(offerList, settings, page) {
    removeAutoInjectedWidgetsForManualBlocks(page);

    document.querySelectorAll('[data-upsell-mount][data-upsell-mounted]:empty').forEach((mount) => {
      mount.removeAttribute('data-upsell-mounted');
      mount.removeAttribute('data-upsell-empty');
      mount.style.removeProperty('display');
    });

    document.querySelectorAll('[data-upsell-mount]:not([data-upsell-mounted])').forEach((mount) => {
      renderManualBlockTarget(mount, offerList, settings, page);
    });

    document
      .querySelectorAll('[data-upsell-block]:not([data-upsell-js-rendered])')
      .forEach((block) => {
        if (block.hasAttribute('data-upsell-mount')) return;
        if (!getBlockOfferType(block)) return;
        renderManualBlockTarget(block, offerList, settings, page);
      });

    removeAutoInjectedWidgetsForManualBlocks(page);
  }

  function isOfferTypeCoveredByManualBlock(offerType, injectionContext, page) {
    return injectionContext.context === 'page' && getManualBlockOfferTypesForPage(page).has(offerType);
  }

  function getOffersForContext(context) {
    if (context === 'drawer') {
      return activeCartDrawerOffers;
    }
    // product / cart / collection all use the AB-filtered active page pool
    return activePageOffers;
  }

  function filterPageOffers(offerList) {
    return applyAbTestFilter(
      (Array.isArray(offerList) ? offerList : []).filter(
        (offer) => ENABLE_FBT || offer.offerType !== 'fbt'
      ),
      { abSurface: AB_SURFACE_PAGE }
    );
  }

  function filterDrawerOffers(offerList) {
    return applyAbTestFilter(
      (Array.isArray(offerList) ? offerList : []).filter(
        (offer) => ENABLE_FBT || offer.offerType !== 'fbt'
      ),
      { abSurface: AB_SURFACE_DRAWER }
    );
  }

  let drawerOffersRefreshInFlight = false;
  let drawerOffersRefreshQueued = false;

  async function fetchFreshEmbedOffers() {
    try {
      const sectionId = getEmbedSectionId();
      if (!sectionId) return null;

      const root = getShopifyRootPath();
      const response = await fetch(
        `${root}cart?sections=${encodeURIComponent(sectionId)}&_=${Date.now()}`,
        { credentials: 'same-origin' }
      );
      if (!response.ok) return null;

      const payload = await response.json();
      const parsed = parseEmbedSectionHtml(payload, sectionId);
      if (!parsed) return null;

      return {
        cartDrawerOffers: filterDrawerOffers(parsed.cartDrawerOffers),
        pageOffers: filterPageOffers(parsed.offers)
      };
    } catch (error) {
      console.error('Super Upsell: Failed to refresh cart-aware offers', error);
      return null;
    }
  }

  function applyPageOffers(nextOffers) {
    if (!Array.isArray(nextOffers)) return false;

    activePageOffers = nextOffers;
    if (window.SUPER_UPSELL_DATA) {
      window.SUPER_UPSELL_DATA.offers = nextOffers;
    }
    return true;
  }

  function applyCartDrawerOffers(nextOffers) {
    if (!Array.isArray(nextOffers)) return false;

    activeCartDrawerOffers = nextOffers;
    if (window.SUPER_UPSELL_DATA) {
      window.SUPER_UPSELL_DATA.cartDrawerOffers = nextOffers;
    }
    return true;
  }

  async function refreshCartAwareDataAndWidgets(offerList, settings, page) {
    const shouldRefreshDrawer = placements.cartDrawerAutoInject !== false;
    const shouldRefreshCartPage = page === 'cart' && placements.cartPageAutoInject !== false;
    if (!shouldRefreshDrawer && !shouldRefreshCartPage) return;

    if (drawerOffersRefreshInFlight) {
      drawerOffersRefreshQueued = true;
      return;
    }
    drawerOffersRefreshInFlight = true;

    try {
      const fresh = await fetchFreshEmbedOffers();
      if (fresh) {
        applyCartDrawerOffers(fresh.cartDrawerOffers);
        if (shouldRefreshCartPage) {
          applyPageOffers(fresh.pageOffers);
        }
      }

      if (shouldRefreshDrawer) {
        refreshCartDrawerWidgets(offerList, settings, page);
        if (
          getOffersForContext('drawer').length &&
          getExpectedWidgetIds(page, offerList).some(
            (id) => id.startsWith('cart-drawer-') && !isWidgetMounted(id)
          )
        ) {
          window.requestAnimationFrame(() => {
            refreshCartDrawerWidgets(offerList, settings, page);
          });
        }
      }
      if (shouldRefreshCartPage) {
        refreshCartPageWidgets(offerList, settings, page);
      }
    } catch (error) {
      console.error('Super Upsell: Failed to refresh cart-aware widgets', error);
    } finally {
      drawerOffersRefreshInFlight = false;
      if (drawerOffersRefreshQueued) {
        drawerOffersRefreshQueued = false;
        refreshCartAwareDataAndWidgets(offerList, settings, page);
      }
    }
  }

  function refreshCartDrawerDataAndWidgets(offerList, settings, page) {
    return refreshCartAwareDataAndWidgets(offerList, settings, page);
  }

  function isWidgetMounted(contextId) {
    const widget = document.querySelector(`[data-upsell-auto-injected="${contextId}"]`);
    if (!widget || !widget.isConnected) return false;

    if (!String(contextId).startsWith('cart-drawer-')) return true;

    const drawer = findCartDrawerElement();
    const drawerInner = drawer?.querySelector(
      '.drawer__inner, .cart-drawer__inner, .cart-drawer__content, cart-drawer-items, cart-items-component[data-drawer]'
    );
    return Boolean(drawerInner?.contains(widget) || drawer?.contains(widget));
  }

  function getRuntimeSettings(context = 'page') {
    const cfg = context === 'drawer' ? drawerPageConfig : pageConfig;
    return { display, appearance, behavior, pageConfig: cfg };
  }

  function injectIntoContext(offerList, settings, page, injectionContext) {
    const contextSettings = getRuntimeSettings(injectionContext.context);
    const contextOffers = getOffersForContext(injectionContext.context);
    const grouped = groupOffersByType(contextOffers);
    let anyInjected = false;

    OFFER_TYPE_ORDER.forEach((offerType) => {
      if (offerType === 'fbt' && !ENABLE_FBT) return;

      const typeOffers = grouped[offerType];
      if (!typeOffers?.length) return;

      if (isOfferTypeCoveredByManualBlock(offerType, injectionContext, page)) return;

      const contextId = `${injectionContext.id}-${offerType}`;
      if (isWidgetMounted(contextId)) {
        anyInjected = true;
        return;
      }

      const config = resolveInjectionConfig(page, injectionContext.context, offerType);
      if (!config || config.autoInject === false) return;

      const injected = initUpsells(typeOffers, contextSettings, page, {
        contextId,
        context: injectionContext.context,
        contextPrefix: injectionContext.id,
        offerType,
        rootElement: injectionContext.rootElement || null,
        selector: config.selector,
        injectionLocation: config.injectionLocation
      });
      if (injected) anyInjected = true;
    });

    return anyInjected;
  }

  function getPendingPageAutoInjectionTypes(offerList, page) {
    const grouped = groupOffersByType(offerList);
    const manualTypes = getManualBlockOfferTypesForPage(page);
    const pending = [];

    getInjectionContexts(page).forEach((injectionContext) => {
      if (injectionContext.context !== 'page') return;

      OFFER_TYPE_ORDER.forEach((offerType) => {
        if (offerType === 'fbt' && !ENABLE_FBT) return;
        if (manualTypes.has(offerType)) return;
        if (!grouped[offerType]?.length) return;

        const config = resolveInjectionConfig(page, injectionContext.context, offerType);
        if (!config || config.autoInject === false) return;

        const contextId = `${injectionContext.id}-${offerType}`;
        if (isWidgetMounted(contextId)) return;

        pending.push(contextId);
      });
    });

    return pending;
  }

  function pollWithRaf(tryFn, maxFrames = 120) {
    if (typeof tryFn !== 'function') return;
    if (tryFn()) return;

    let frame = 0;
    const tick = () => {
      frame += 1;
      if (tryFn() || frame >= maxFrames) return;
      window.requestAnimationFrame(tick);
    };
    window.requestAnimationFrame(tick);
  }

  function watchForInjectionTarget(callback, selectors, isComplete) {
    const canInject = () =>
      selectors.some((selector) => document.querySelector(selector)) ||
      document.querySelector(
        '[data-testid="product-information-details"], [data-testid="product-information"], product-form-component:not(.quick-add__product-form-component), product-form, #MainContent, main, .product-grid-container, [data-testid="product-grid"], cart-items-component'
      );

    pollWithRaf(() => {
      if (!canInject()) return false;
      callback();
      return typeof isComplete === 'function' ? isComplete() : true;
    }, 240);
  }

  function getPendingCustomInjectionSelectors(offerList, page) {
    const selectors = [];
    const grouped = groupOffersByType(offerList);
    const manualTypes = getManualBlockOfferTypesForPage(page);

    getInjectionContexts(page).forEach((injectionContext) => {
      if (injectionContext.context !== 'page') return;

      OFFER_TYPE_ORDER.forEach((offerType) => {
        if (offerType === 'fbt' && !ENABLE_FBT) return;
        if (manualTypes.has(offerType)) return;
        if (!grouped[offerType]?.length) return;

        const config = resolveInjectionConfig(page, injectionContext.context, offerType);
        if (!config || config.autoInject === false) return;

        const contextId = `${injectionContext.id}-${offerType}`;
        if (isWidgetMounted(contextId)) return;

        const customSelector = String(config.selector || '').trim();
        if (customSelector) selectors.push(customSelector);
      });
    });

    return selectors;
  }

  function runAutoInjection(offerList, settings, page) {
    const tryInjectAllContexts = () => {
      getInjectionContexts(page).forEach((injectionContext) => {
        injectIntoContext(offerList, settings, page, injectionContext);
      });
    };

    removeAutoInjectedWidgetsForManualOfferTypes(page);

    tryInjectAllContexts();
    const pageAutoInjectEnabled =
      (page === 'product' && placements.productPageAutoInject !== false) ||
      (page === 'cart' && placements.cartPageAutoInject !== false) ||
      (page === 'collection' && placements.collectionPageAutoInject !== false);

    if (pageAutoInjectEnabled && getPendingPageAutoInjectionTypes(offerList, page).length > 0) {
      watchForInjectionTarget(
        tryInjectAllContexts,
        [
          ...getDefaultSelectors(page, 'page'),
          ...getPendingCustomInjectionSelectors(offerList, page)
        ],
        () => getPendingPageAutoInjectionTypes(offerList, page).length === 0
      );
    }

    if (placements.cartDrawerAutoInject !== false && !findCartDrawerElement()) {
      watchForCartDrawer(tryInjectAllContexts);
    }

    if (
      placements.cartDrawerAutoInject !== false &&
      getOffersForContext('drawer').length &&
      getExpectedWidgetIds(page, offerList).some((id) => id.startsWith('cart-drawer-') && !isWidgetMounted(id))
    ) {
      watchForInjectionTarget(
        tryInjectAllContexts,
        [
          '.cart-drawer__items',
          'cart-items-component[data-drawer] .cart-drawer__items',
          'cart-items-component[data-drawer]',
          '.cart-drawer__inner',
          'theme-drawer#cart-drawer dialog'
        ],
        () =>
          !getExpectedWidgetIds(page, offerList).some(
            (id) => id.startsWith('cart-drawer-') && !isWidgetMounted(id)
          )
      );
    }

    watchWidgetPersistence(offerList, settings, page);
    watchCartDrawerLifecycle(offerList, settings, page);
  }

  function refreshCartPageWidgets(offerList, settings, page) {
    if (page !== 'cart' || placements.cartPageAutoInject === false) return;

    document.querySelectorAll('[data-upsell-auto-injected^="cart-page-"]').forEach((widget) => {
      widget.remove();
    });

    const pageOffers = getOffersForContext('page');
    if (!pageOffers.length) return;

    injectIntoContext(offerList, settings, page, { id: 'cart-page', context: 'page' });

    window.requestAnimationFrame(() => {
      document.querySelectorAll('[data-upsell-auto-injected^="cart-page-"]').forEach((widget) => {
        finishUpsellMount(widget, 'cart', 'page');
      });
    });
  }

  function scheduleCartPageRefresh(offerList, settings, page) {
    if (page !== 'cart') return;
    window.__superUpsellRefreshCartAware?.();
  }

  function refreshCartDrawerWidgets(offerList, settings, page) {
    if (placements.cartDrawerAutoInject === false) return;

    if (isViewingCartPage()) {
      document.querySelectorAll('[data-upsell-auto-injected^="cart-drawer-"]').forEach((widget) => {
        widget.remove();
      });
      return;
    }

    const drawer = findCartDrawerElement();
    if (!drawer) return;

    document.querySelectorAll('[data-upsell-auto-injected^="cart-drawer-"]').forEach((widget) => {
      widget.remove();
    });

    const drawerOffers = getOffersForContext('drawer');
    if (!drawerOffers.length) return;

    const drawerContext = { id: 'cart-drawer', context: 'drawer', rootElement: drawer };
    injectIntoContext(drawerOffers, getRuntimeSettings('drawer'), page, drawerContext);

    document.querySelectorAll('[data-upsell-auto-injected^="cart-drawer-"]').forEach((widget) => {
      finishUpsellMount(widget, 'cart', 'drawer');
    });

    window.__superUpsellAdaptDrawerContrast?.();
    if (isQorumShop()) scheduleQorumDrawerLayoutRefresh();
  }

  function hookCartDrawerRender(offerList, settings, page) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__upsellRenderHooked) return;

    const original = drawer.renderContents;
    if (typeof original !== 'function') return;

    drawer.__upsellRenderHooked = true;
    drawer.renderContents = function renderContentsWithUpsell(parsedState) {
      const result = original.call(this, parsedState);
      window.__superUpsellRefreshCartAware?.();
      return result;
    };
  }

  function watchCartDrawerLifecycle(offerList, settings, page) {
    if (window.__superUpsellCartDrawerWatchActive) return;
    if (placements.cartDrawerAutoInject === false) return;

    window.__superUpsellCartDrawerWatchActive = true;
    hookCartDrawerRender(offerList, settings, page);
  }

  function getExpectedWidgetIds(page, offerList) {
    const ids = [];
    if (hasManualBlocksForPage(page)) return ids;

    getInjectionContexts(page).forEach((injectionContext) => {
      const grouped = groupOffersByType(getOffersForContext(injectionContext.context));
      OFFER_TYPE_ORDER.forEach((offerType) => {
        if (offerType === 'fbt' && !ENABLE_FBT) return;

        const typeOffers = grouped[offerType];
        if (!typeOffers?.length) return;

        if (isOfferTypeCoveredByManualBlock(offerType, injectionContext, page)) return;

        const config = resolveInjectionConfig(page, injectionContext.context, offerType);
        if (!config || config.autoInject === false) return;

        ids.push(`${injectionContext.id}-${offerType}`);
      });
    });

    return ids;
  }

  function watchWidgetPersistence(offerList, settings, page) {
    if (window.__superUpsellPersistenceActive) return;
    window.__superUpsellPersistenceActive = true;

    let reinjectQueued = false;

    const scheduleReinject = () => {
      if (reinjectQueued) return;
      reinjectQueued = true;
      window.requestAnimationFrame(() => {
        reinjectQueued = false;
        const missing = getExpectedWidgetIds(page, offerList).some(
          (id) => !isWidgetMounted(id)
        );
        if (!missing) return;

        window.__superUpsellInitDone = false;
        runAutoInjection(offerList, settings, page);
        if (placements.cartDrawerAutoInject !== false || page === 'cart') {
          window.__superUpsellRefreshCartAware?.();
        }
      });
    };

    // Theme/app events cover dynamic section rerenders without MutationObserver.
    document.addEventListener('shopify:section:load', scheduleReinject);
    document.addEventListener('shopify:section:unload', scheduleReinject);
    document.addEventListener('shopify:section:reorder', scheduleReinject);
    document.addEventListener('shopify:section:select', scheduleReinject);
    document.addEventListener('shopify:section:deselect', scheduleReinject);
    document.addEventListener('shopify:block:select', scheduleReinject);
    document.addEventListener('shopify:block:deselect', scheduleReinject);
  }

  function watchForCartDrawer(callback) {
    pollWithRaf(() => {
      if (findCartDrawerElement()) {
        callback();
        return true;
      }
      return false;
    }, 240);
  }

  // ── Storefront tracking (A/B analytics) ──────────────────────────────────
  // Payload matches STOREFRONT_API_DOCUMENTATION.md + checkout-ui:
  // shop, offer_type, page_type, product_handle, ruleId, variantLabel,
  // eventType, revenue, checkoutToken
  let cachedCheckoutToken = null;
  let checkoutTokenPromise = null;
  const trackedImpressionKeys = new Set();

  function getShopDomain() {
    return (
      window.Shopify?.shop ||
      window.SUPER_UPSELL_DATA?.shop ||
      ''
    );
  }

  function isQorumShop() {
    const shop = String(getShopDomain() || '').trim().toLowerCase();
    const host = String(window.location.hostname || '').trim().toLowerCase();
    if (QORUM_SHOP_DOMAINS.includes(shop)) return true;
    if (QORUM_HOSTNAMES.includes(host)) return true;
    if (shop.includes('qorum')) return true;
    return host.includes('qorumindia');
  }

  function shouldUseQorumDrawerLayout(contextId) {
    return isQorumShop() && String(contextId || '').startsWith('cart-drawer-');
  }

  function findQorumDrawerInnerRoot() {
    const drawer = findCartDrawerElement();
    if (!drawer) return null;

    return (
      drawer.querySelector('cart-drawer-component .cart-drawer__inner') ||
      drawer.querySelector('.cart-drawer__inner') ||
      drawer.querySelector('.drawer__inner') ||
      drawer.querySelector('cart-drawer-component') ||
      drawer
    );
  }

  function cleanupLegacyQorumDrawerDom(root) {
    if (!root) return;
    root.classList.remove('qorum-drawer-split');

    const main = root.querySelector(':scope > .qorum-cart-main');
    if (!main) return;

    while (main.firstChild) {
      root.insertBefore(main.firstChild, main);
    }
    main.remove();
  }

  function findQorumMobileUpsellAnchor(root) {
    if (!root) return null;

    return (
      root.querySelector('.cart-drawer__summary') ||
      root.querySelector('.cart-drawer__footer') ||
      root.querySelector('.drawer__footer') ||
      root.querySelector('form#cart-form') ||
      root.querySelector('.cart-drawer__checkout') ||
      root.querySelector('[ref="checkoutButtons"]') ||
      root.lastElementChild
    );
  }

  function queryInDrawerRoot(root, selector) {
    if (!selector) return null;
    try {
      const drawer = findCartDrawerElement();
      return (
        document.querySelector(selector) ||
        drawer?.querySelector(selector) ||
        (root?.querySelector ? root.querySelector(selector) : null)
      );
    } catch (_) {
      return null;
    }
  }

  function findQorumThemeSelectorTarget() {
    const bucket = getQorumThemeBucket();
    for (const prefix of ['upsell', 'crossSell']) {
      const loc = String(bucket[`${prefix}InjectionLocation`] || '').toLowerCase();
      if (loc !== 'custom') continue;
      const selector = String(bucket[`${prefix}InjectionSelector`] || '').trim();
      if (!selector) continue;
      const target = queryInDrawerRoot(null, selector);
      if (target) return target;
    }
    return null;
  }

  function resolveQorumPanelMountFromLocation(searchRoot, loc) {
    if (!loc) return null;

    const customSelector = String(loc.injectionSelector || '').trim();
    const rawLocation = String(loc.injectionLocation || 'after_form').trim().toLowerCase();

    if (customSelector && rawLocation.startsWith('custom_')) {
      const parsed = parseInjectionPlacement(loc.injectionLocation, customSelector);
      const target = queryInDrawerRoot(null, parsed.selector || customSelector);
      if (!target) return null;

      if (parsed.placement === 'before_selector') {
        return {
          host: target.parentElement || searchRoot,
          anchor: target,
          insert: 'before',
        };
      }

      if (parsed.placement === 'after_selector') {
        return {
          host: target.parentElement || searchRoot,
          anchor: target,
          insert: 'after',
        };
      }

      if (parsed.placement === 'insert') {
        return { host: target, anchor: null, insert: 'append' };
      }
    }

    const form = findDrawerCartForm(searchRoot);
    if (!form) return null;
    const host = form.parentElement || searchRoot;

    if (rawLocation === 'before_form' || rawLocation === 'before') {
      return { host, anchor: form, insert: 'before' };
    }
    if (rawLocation === 'after_form' || rawLocation === 'after') {
      return { host, anchor: form, insert: 'after' };
    }
    if (rawLocation === 'form_append' || rawLocation === 'inside_form') {
      return { host: form, anchor: null, insert: 'append' };
    }

    return null;
  }

  function findQorumPanelInsertMount(root) {
    const searchRoot = root || findQorumDrawerInnerRoot() || document;

    for (const offerType of ['upsells', 'cross_sells']) {
      const loc = getQorumDrawerLocationOverride(offerType);
      const mount = resolveQorumPanelMountFromLocation(searchRoot, loc);
      if (mount) return mount;
    }

    const fallback = findQorumMobileUpsellAnchor(searchRoot);
    if (!fallback) return null;
    return {
      host: fallback.parentElement || searchRoot,
      anchor: fallback,
      insert: 'before',
    };
  }

  function mountQorumPanelInDrawer(panel, root) {
    const mount = findQorumPanelInsertMount(root);
    if (!mount?.host) {
      if (panel.parentElement !== root) root.appendChild(panel);
      return;
    }

    const { host, anchor, insert } = mount;

    if (insert === 'append' && !anchor) {
      if (panel.parentElement !== host) host.appendChild(panel);
      return;
    }

    if (!anchor) return;

    if (insert === 'before') {
      if (panel.parentElement !== host || panel.nextElementSibling !== anchor) {
        host.insertBefore(panel, anchor);
      }
      return;
    }

    if (insert === 'after') {
      const next = anchor.nextElementSibling;
      if (next) {
        if (panel.parentElement !== host || panel.nextElementSibling !== next) {
          host.insertBefore(panel, next);
        }
      } else if (panel.parentElement !== host) {
        host.appendChild(panel);
      }
    }
  }

  function getOpenCartDrawerDialog() {
    const drawer = findCartDrawerElement();
    if (!drawer) return null;

    return (
      drawer.querySelector('dialog[open]') ||
      drawer.closest('dialog[open]') ||
      document.querySelector(
        'theme-drawer#cart-drawer dialog[open], #cart-drawer dialog[open], cart-drawer dialog[open], cart-drawer-component dialog[open]'
      )
    );
  }

  /** Dawn / Qorum cart-drawer — mount on sliding `.drawer__inner`, not outer shell. */
  function getQorumExternalPanelMount() {
    const dialog = getOpenCartDrawerDialog();
    if (dialog) return dialog;

    if (!isCartDrawerOpen()) return null;

    const drawer = findCartDrawerElement();
    if (!drawer) return null;

    const themeTarget = findQorumThemeSelectorTarget();
    if (themeTarget) return themeTarget;

    return (
      drawer.querySelector('.drawer__inner') ||
      drawer.querySelector('cart-drawer-component .cart-drawer__inner') ||
      drawer.querySelector('.cart-drawer__inner') ||
      drawer.querySelector(':scope > .cart-drawer') ||
      drawer.querySelector('.cart-drawer') ||
      drawer.querySelector('.cart-drawer__dialog') ||
      drawer
    );
  }

  function getOpenCartDrawerWidth() {
    const dialog = getOpenCartDrawerDialog();
    if (!dialog) return 0;
    return Math.round(dialog.getBoundingClientRect().width || 0);
  }

  function shouldUseQorumExternalPanel() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  function getQorumPanelConfig() {
    const qorum =
      window.SUPER_UPSELL_DATA?.qorum ||
      window.QORUM_UPSELL_CONFIG ||
      window.SUPER_UPSELL_DATA?.widgetSettings?.qorum ||
      null;

    if (!qorum || typeof qorum !== 'object') {
      if (!isQorumShop()) {
        return {
          title: '',
          subtitle: '',
          showOnDesktop: true,
          showOnMobile: true,
        };
      }
    }

    const cfg = qorum && typeof qorum === 'object' ? qorum : {};
    const title = String(cfg.drawerPanelTitle ?? QORUM_DRAWER_TITLE_DEFAULT).trim();
    const subtitle = String(cfg.drawerPanelSubtitle ?? QORUM_DRAWER_SUBTITLE_DEFAULT).trim();
    const showOnDesktop = cfg.showOnDesktop !== false;
    const showOnMobile = cfg.showOnMobile !== false;

    return {
      title: title || QORUM_DRAWER_TITLE_DEFAULT,
      subtitle: subtitle || QORUM_DRAWER_SUBTITLE_DEFAULT,
      showOnDesktop,
      showOnMobile,
    };
  }

  function shouldShowQorumPanelForViewport() {
    const { showOnDesktop, showOnMobile } = getQorumPanelConfig();
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    if (isDesktop) return showOnDesktop !== false;
    return showOnMobile !== false;
  }

  function ensureQorumUpsellPanel() {
    let panel = document.querySelector('.qorum-upsell-panel[data-qorum-upsell-panel]');
    if (panel) return panel;

    panel = document.createElement('div');
    panel.className = 'qorum-upsell-panel';
    panel.setAttribute('data-qorum-upsell-panel', '');
    panel.hidden = true;
    panel.innerHTML = `
      <div class="qorum-upsell-panel__hdr">
        <div class="qorum-upsell-panel__title"></div>
        <div class="qorum-upsell-panel__sub"></div>
      </div>
      <div class="qorum-upsell-panel__body"></div>
    `;
    document.body.appendChild(panel);
    return panel;
  }

  function positionExternalQorumPanel(panel, mount) {
    if (!(panel instanceof HTMLElement) || !(mount instanceof HTMLElement)) return;

    const positioningRoot =
      mount.matches('dialog, .cart-drawer, .cart-drawer__dialog, .drawer__inner') ||
      mount.classList.contains('cart-drawer') ||
      mount.classList.contains('drawer__inner')
        ? mount
        : mount.parentElement || mount;

    positioningRoot.classList.add('qorum-drawer-has-external-panel');
    positioningRoot.style.setProperty(
      '--qorum-external-panel-width',
      `${QORUM_EXTERNAL_PANEL_WIDTH}px`
    );

    if (panel.parentElement !== positioningRoot) {
      positioningRoot.insertBefore(panel, positioningRoot.firstChild);
    }

    panel.style.position = 'absolute';
    panel.style.top = '0';
    panel.style.left = `-${QORUM_EXTERNAL_PANEL_WIDTH}px`;
    panel.style.height = '100%';
    panel.style.width = `${QORUM_EXTERNAL_PANEL_WIDTH}px`;
    panel.style.zIndex = '2';
  }

  function isCartDrawerOpen() {
    const drawer = findCartDrawerElement();
    if (!drawer) return false;

    const openDialog = getOpenCartDrawerDialog();

    if (openDialog?.open) return true;
    if (drawer.hasAttribute('open')) return true;
    if (
      drawer.classList.contains('active') ||
      drawer.classList.contains('is-open') ||
      drawer.classList.contains('drawer--is-open')
    ) {
      return true;
    }

    return drawer.getAttribute('aria-hidden') === 'false';
  }

  function revertQorumDrawerLayout(root = null) {
    root = root || findQorumDrawerInnerRoot();
    cleanupLegacyQorumDrawerDom(root);

    const panel = document.querySelector('.qorum-upsell-panel[data-qorum-upsell-panel]');
    if (!panel) return;

    panel.hidden = true;
    panel.classList.remove('qorum-upsell-panel--external', 'qorum-layout-stacked');
    panel.removeAttribute('style');

    document
      .querySelectorAll('dialog.qorum-drawer-has-external-panel, .qorum-drawer-has-external-panel')
      .forEach((node) => {
        node.classList.remove('qorum-drawer-has-external-panel');
        node.style.removeProperty('--qorum-external-panel-width');
      });

    if (panel.parentElement !== document.body) {
      document.body.appendChild(panel);
    }
  }

  function applyQorumDrawerLayout() {
    if (!isQorumShop()) return;

    const root = findQorumDrawerInnerRoot();
    if (!root) return;

    cleanupLegacyQorumDrawerDom(root);

    const widgets = [...document.querySelectorAll('.upsell-container--qorum')].filter(
      (node) => node.isConnected
    );
    if (!widgets.length) {
      revertQorumDrawerLayout(root);
      return;
    }

    if (!isCartDrawerOpen()) {
      revertQorumDrawerLayout(root);
      return;
    }

    if (!shouldShowQorumPanelForViewport()) {
      revertQorumDrawerLayout(root);
      return;
    }

    const panel = ensureQorumUpsellPanel();
    panel.hidden = false;

    const { title, subtitle } = getQorumPanelConfig();
    const titleEl = panel.querySelector('.qorum-upsell-panel__title');
    const subtitleEl = panel.querySelector('.qorum-upsell-panel__sub');
    const externalMount = getQorumExternalPanelMount();
    const useExternalPanel =
      shouldUseQorumExternalPanel() &&
      externalMount &&
      prefersQorumExternalDesktopPanel();

    if (titleEl) titleEl.textContent = title;
    if (subtitleEl) subtitleEl.textContent = subtitle;
    panel.dataset.qorumPanelTitle = title;
    panel.dataset.qorumPanelSubtitle = subtitle;

    const body = panel.querySelector('.qorum-upsell-panel__body');
    if (!body) return;

    let layoutChanged = false;
    widgets.forEach((widget) => {
      if (widget.parentElement !== body) {
        body.appendChild(widget);
        layoutChanged = true;
      }
    });

    panel.classList.toggle('qorum-upsell-panel--external', Boolean(useExternalPanel));
    panel.classList.toggle('qorum-layout-stacked', !useExternalPanel);

    if (useExternalPanel) {
      positionExternalQorumPanel(panel, externalMount);
      if (layoutChanged) refreshQorumDrawerSliders(widgets);
      return;
    }

    document
      .querySelectorAll('dialog.qorum-drawer-has-external-panel, .qorum-drawer-has-external-panel')
      .forEach((node) => {
        node.classList.remove('qorum-drawer-has-external-panel');
        node.style.removeProperty('--qorum-external-panel-width');
      });

    panel.removeAttribute('style');

    mountQorumPanelInDrawer(panel, root);
    if (layoutChanged) refreshQorumDrawerSliders(widgets);
  }

  let qorumLayoutRefreshRaf = null;
  let qorumDrawerRefreshTimer = null;

  function scheduleQorumDrawerLayoutRefresh() {
    if (!isQorumShop()) return;
    if (qorumLayoutRefreshRaf) return;
    qorumLayoutRefreshRaf = window.requestAnimationFrame(() => {
      qorumLayoutRefreshRaf = null;
      applyQorumDrawerLayout();
    });
  }

  function queueQorumDrawerRefresh() {
    if (!isQorumShop()) return;
    // No artificial delay — Complete the Look should layout on the next frame.
    if (qorumDrawerRefreshTimer) window.clearTimeout(qorumDrawerRefreshTimer);
    qorumDrawerRefreshTimer = null;
    scheduleQorumDrawerLayoutRefresh();
  }

  function bindQorumDrawerOpenWatcher() {
    if (!isQorumShop() || window.__superUpsellQorumDrawerWatcher) return;
    window.__superUpsellQorumDrawerWatcher = true;

    watchForCartDrawer(queueQorumDrawerRefresh);

    document.addEventListener(
      'click',
      (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        if (isSuperUpsellUiElement(target)) return;

        if (
          target.closest(
            '[data-testid="cart-drawer-trigger"], cart-drawer-component button[aria-haspopup="dialog"], [data-cart-drawer-trigger], #cart-icon-bubble, .cart-drawer__close, .drawer__close, [aria-label*="Close" i]'
          )
        ) {
          queueQorumDrawerRefresh();
        }
      },
      true
    );

    document.addEventListener('theme-drawer:open', queueQorumDrawerRefresh, { passive: true });
    document.addEventListener('dialog:open', queueQorumDrawerRefresh, { passive: true });

    document.querySelectorAll('cart-drawer').forEach((drawerEl) => {
      drawerEl.addEventListener('transitionend', queueQorumDrawerRefresh, { passive: true });
    });
    document.addEventListener(
      'toggle',
      (event) => {
        if (!(event.target instanceof HTMLDialogElement)) return;
        queueQorumDrawerRefresh();
      },
      { capture: true, passive: true }
    );
  }

  if (!window.__superUpsellQorumLayoutBound) {
    window.__superUpsellQorumLayoutBound = true;
    let qorumLastWidth = window.innerWidth;
    let qorumLastIsDesktop = window.matchMedia('(min-width: 750px)').matches;

    function remountDrawerWidgetsForBreakpointChange() {
      if (isViewingCartPage()) return;
      document
        .querySelectorAll('[data-upsell-auto-injected^="cart-drawer-"]')
        .forEach((widget) => widget.remove());
      revertQorumDrawerLayout();
      window.__superUpsellForceCartRefresh = true;
      initSuperUpsell();
    }

    window.addEventListener(
      'resize',
      () => {
        const isDesktop = window.matchMedia('(min-width: 750px)').matches;
        const widthChanged = window.innerWidth !== qorumLastWidth;
        const breakpointChanged = isDesktop !== qorumLastIsDesktop;

        if (!widthChanged && !breakpointChanged) return;

        qorumLastWidth = window.innerWidth;
        qorumLastIsDesktop = isDesktop;

        if (breakpointChanged) {
          remountDrawerWidgetsForBreakpointChange();
          return;
        }

        scheduleQorumDrawerLayoutRefresh();
      },
      { passive: true }
    );
    bindQorumDrawerOpenWatcher();
  }

  function normalizeOfferTypeForApi(offerType) {
    const s = String(offerType || 'upsell').toLowerCase();
    if (s.includes('cross')) return 'crosssell';
    if (s === 'fbt') return 'fbt';
    return 'upsell';
  }

  function normalizeVariantLabel(label) {
    const v = String(label || 'A').trim().toUpperCase();
    return v === 'B' ? 'B' : 'A';
  }

  function escapeAttr(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  async function getCheckoutToken() {
    if (cachedCheckoutToken) return cachedCheckoutToken;

    const cleanToken = (tok) => {
      if (!tok) return null;
      try {
        return decodeURIComponent(tok).trim().replace(/^"|"$/g, '').split('?')[0].split(':')[0];
      } catch {
        return String(tok).trim().replace(/^"|"$/g, '').split('?')[0].split(':')[0];
      }
    };

    try {
      const match = document.cookie.match(/(?:^|;\s*)cart=([^;]*)/);
      if (match?.[1]) {
        cachedCheckoutToken = cleanToken(match[1]);
        return cachedCheckoutToken;
      }
    } catch {
      /* ignore */
    }

    if (!checkoutTokenPromise) {
      const cartUrl = `${getShopifyRootPath()}cart.js`;
      console.log('cartUrl', cartUrl);
      checkoutTokenPromise = fetch(cartUrl, { credentials: 'same-origin' })
        .then((res) => (res.ok ? res.json() : null))
        .then((cart) => {
         
          cachedCheckoutToken = cart?.token ? cleanToken(cart.token) : null;
          return cachedCheckoutToken;
        })
        .catch(() => null)
        .finally(() => {
          checkoutTokenPromise = null;
        });
    }

    return checkoutTokenPromise;
  }

  async function trackStorefrontEvent(eventType, meta = {}) {
    const shopDomain = getShopDomain();
    if (!shopDomain) return;

    const checkoutToken = await getCheckoutToken();
    const proxyPath =
      eventType === 'impression'
        ? '/apps/super-upsell/impression'
        : '/apps/super-upsell/click';

    const payload = {
      shop: shopDomain,
      offer_type: normalizeOfferTypeForApi(meta.offerType),
      page_type: meta.pageType || pageType || 'product',
      product_handle: meta.productHandle || null,
      ruleId: meta.ruleId != null && String(meta.ruleId).trim() ? String(meta.ruleId) : null,
      variantLabel: normalizeVariantLabel(meta.variantLabel),
      eventType,
      revenue: meta.revenue != null ? String(meta.revenue) : '0',
      checkoutToken: checkoutToken || null
    };

    fetch(proxyPath, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true
    }).catch((err) =>
      console.error(`Super Upsell: Failed to track ${eventType}`, err)
    );
  }

  function trackClick(productHandle, offerType, meta = {}) {
    trackStorefrontEvent('click', {
      ...meta,
      productHandle,
      offerType
    });
  }

  function trackImpression(meta = {}) {
    trackStorefrontEvent('impression', meta);
  }

  /**
   * One impression per ruleId + variantLabel + surface (matches checkout-ui).
   * Drawer uses `cart_drawer` surface + requires data-rule-id (no phantom "default" rows).
   */
  function trackWidgetImpressions(container, page, context = 'page') {
    if (!container) return;

    const isDrawer =
      context === 'drawer' ||
      container.getAttribute('data-ab-surface') === AB_SURFACE_DRAWER ||
      container.classList.contains('upsell-container--drawer');
    const surface = isDrawer
      ? AB_SURFACE_DRAWER
      : container.getAttribute('data-page-context') || page || pageType || 'product';

    const selector = isDrawer
      ? '[data-upsell-form][data-rule-id]:not([data-rule-id=""]), .upsell-link[data-rule-id]:not([data-rule-id=""])'
      : '[data-upsell-form][data-rule-id], .upsell-link[data-rule-id], [data-upsell-form], .upsell-link';

    const nodes = container.querySelectorAll(selector);
    const seen = new Set();

    nodes.forEach((el) => {
      const ruleIdRaw = String(el.getAttribute('data-rule-id') || '').trim();
      if (isDrawer && !ruleIdRaw) return;

      const ruleId = ruleIdRaw || 'default';
      const variantLabel = normalizeVariantLabel(el.getAttribute('data-variant-label') || 'A');
      const key = `${ruleId}_${variantLabel}_${surface}`;
      if (seen.has(key) || trackedImpressionKeys.has(key)) return;
      seen.add(key);
      trackedImpressionKeys.add(key);

      trackImpression({
        offerType: el.getAttribute('data-offer-type') || 'upsells',
        pageType: surface,
        productHandle: el.getAttribute('data-product-handle') || null,
        ruleId: ruleIdRaw || null,
        variantLabel
      });
    });
  }

  function readTrackingMetaFromEl(el) {
    if (!el) return {};
    const drawerHost =
      el.closest('[data-upsell-auto-injected^="cart-drawer-"]') ||
      el.closest('.upsell-container--drawer') ||
      el.closest('[data-ab-surface="cart_drawer"]');
    const pageContext =
      drawerHost?.getAttribute('data-page-context') ||
      el.closest('[data-page-context]')?.getAttribute('data-page-context') ||
      pageType;
    return {
      ruleId: el.getAttribute('data-rule-id') || null,
      variantLabel: el.getAttribute('data-variant-label') || 'A',
      offerType: el.getAttribute('data-offer-type') || 'upsells',
      productHandle: el.getAttribute('data-product-handle') || '',
      pageType: drawerHost ? AB_SURFACE_DRAWER : pageContext
    };
  }

  /**
   * App placement modes (injectionLocation):
   * - insert / append / custom + selector → append inside matched element
   * - before / before_form / form_before   → sibling before form wrapper
   * - after / after_form / form_after      → sibling after form wrapper
   * - inside_form / form_append            → append inside add-to-cart form
   * - inside_form_prepend / form_prepend   → prepend inside add-to-cart form
   * - top / bottom                         → collection page grid aliases
   */
  function parseInjectionPlacement(injectionLocation, selector) {
    let location = String(injectionLocation || 'after_form').trim().toLowerCase();
    const customSelector = String(selector || '').trim();

    const locationAliases = {
      form_append: 'inside_form',
      form_prepend: 'inside_form_prepend',
      form_before: 'before_form',
      form_after: 'after_form',
      prepend: 'before_form',
      insert_before: 'before',
      insert_after: 'after',
      custom_before: 'before',
      custom_after: 'after',
      custom_append: 'append',
      custom_selector: 'append',
      selector_before: 'before',
      selector_after: 'after',
      selector_append: 'append',
      selector: 'append'
    };

    if (locationAliases[location]) {
      location = locationAliases[location];
    }

    // Custom location with a real selector → target that node.
    // Custom WITHOUT selector must fall back to form placement (not dead `insert`).
    if (customSelector) {
      if (
        location === 'before' ||
        location === 'before_selector' ||
        location === 'before_form' ||
        location === 'top'
      ) {
        return { placement: 'before_selector', selector: customSelector };
      }
      if (
        location === 'after' ||
        location === 'after_selector' ||
        location === 'after_form' ||
        location === 'bottom'
      ) {
        return { placement: 'after_selector', selector: customSelector };
      }
      if (
        location === 'insert' ||
        location === 'append' ||
        location === 'custom' ||
        location === 'inside_form' ||
        location === 'insert_form' ||
        location === 'in_form' ||
        location.includes('append') ||
        location.includes('custom')
      ) {
        return { placement: 'insert', selector: customSelector };
      }

      return { placement: 'insert', selector: customSelector };
    }

    switch (location) {
      case 'insert':
      case 'append':
      case 'custom':
        // No selector provided — treat as after_form so injection still works.
        return { placement: 'after_form', selector: '' };
      case 'before_form':
      case 'before':
      case 'top':
        return { placement: 'before_form', selector: '' };
      case 'inside_form':
      case 'insert_form':
      case 'in_form':
        return { placement: 'inside_form', selector: '' };
      case 'inside_form_prepend':
        return { placement: 'inside_form_prepend', selector: '' };
      case 'after_form':
      case 'after':
      case 'bottom':
        return { placement: 'after_form', selector: '' };
      default:
        return { placement: 'after_form', selector: '' };
    }
  }

  function getDrawerPlacementAnchors(searchRoot = document) {
    const root = searchRoot || document;
    const cartForm = findDrawerCartForm(root);

    const items =
      root.querySelector('cart-drawer-items') ||
      root.querySelector('.cart-drawer__items') ||
      root.querySelector('cart-items-component') ||
      root.querySelector('.cart-items__wrapper');

    const summary =
      root.querySelector('.cart-drawer__summary') ||
      root.querySelector('.cart-drawer__checkout') ||
      root.querySelector('[ref="checkoutButtons"]') ||
      root.querySelector('.cart-drawer__footer') ||
      root.querySelector('.drawer__footer') ||
      root.querySelector('.cart-summary') ||
      root.querySelector('[slot="footer"]');

    const shell =
      root.querySelector('.cart-drawer__content') ||
      root.querySelector('.cart-drawer__inner') ||
      root.querySelector('.drawer__inner') ||
      root;

    return { cartForm, items, summary, shell };
  }

  /**
   * Theme-wise drawer fallback when `form[action="/cart"]` is missing.
   * Uses UPSELL_THEME_PRESETS.drawerUpsellMount / drawerUpsellInsert
   * (Dawn footer, Horizon summary, Prestige slot=footer, …).
   */
  function resolveDrawerThemeFallback(placement, searchRoot = document) {
    const root = searchRoot || document;
    const target = resolveUpsellThemeTarget();

    const themeMount =
      queryFirstFromSelectorList(target.drawerUpsellMount, root) ||
      queryFirstFromSelectorList(target.drawerUpsellMount, document) ||
      root.querySelector('.cart-drawer__summary') ||
      root.querySelector('.cart-drawer__checkout') ||
      root.querySelector('[ref="checkoutButtons"]') ||
      root.querySelector('.cart-drawer__footer') ||
      root.querySelector('.drawer__footer') ||
      root.querySelector('[slot="footer"]') ||
      root.querySelector('.cart-summary') ||
      root.querySelector('.cart-drawer__items') ||
      root.querySelector('cart-drawer-items') ||
      root.querySelector('.cart-drawer__content') ||
      root.querySelector('.drawer__inner') ||
      root.querySelector('.cart-drawer__inner');

    if (!themeMount) return null;

    const themeInsert = String(target.drawerUpsellInsert || 'beforebegin')
      .trim()
      .toLowerCase();

    if (placement === 'before_form') {
      if (themeInsert === 'afterbegin') {
        return { target: themeMount, insertMode: 'prepend_inside' };
      }
      return { target: themeMount, insertMode: 'before' };
    }

    if (placement === 'after_form') {
      if (themeInsert === 'beforeend') {
        return { target: themeMount, insertMode: 'append_inside' };
      }
      if (themeInsert === 'afterbegin') {
        return { target: themeMount, insertMode: 'append_inside' };
      }
      return { target: themeMount, insertMode: 'after' };
    }

    if (placement === 'inside_form' || placement === 'inside_form_prepend') {
      if (placement === 'inside_form_prepend' || themeInsert === 'afterbegin') {
        return { target: themeMount, insertMode: 'prepend_inside' };
      }
      if (themeInsert === 'beforeend') {
        return { target: themeMount, insertMode: 'append_inside' };
      }
      // Theme mounts are often footer/summary nodes — keep offer inside them.
      return { target: themeMount, insertMode: 'prepend_inside' };
    }

    return null;
  }

  /**
   * Cart drawer only:
   * 1) Common — relative to `form[action="/cart"]` / #cart-form
   * 2) Fallback — theme preset mount (Dawn/Horizon/Prestige/…)
   * 3) Last resort — items / summary / shell
   */
  function resolveDrawerFormPlacement(placement, searchRoot) {
    const { cartForm, items, summary, shell } = getDrawerPlacementAnchors(searchRoot);

    // 1) Common form logic
    if (cartForm) {
      if (placement === 'before_form') {
        return { target: cartForm, insertMode: 'before' };
      }
      if (placement === 'after_form') {
        return { target: cartForm, insertMode: 'after' };
      }
      if (placement === 'inside_form') {
        return { target: cartForm, insertMode: 'append_inside' };
      }
      if (placement === 'inside_form_prepend') {
        return { target: cartForm, insertMode: 'prepend_inside' };
      }
    }

    // 2) Theme-wise fallback (only when form is missing)
    const themeFallback = resolveDrawerThemeFallback(placement, searchRoot);
    if (themeFallback?.target) return themeFallback;

    // 3) Generic last resort
    if (placement === 'before_form') {
      if (items) return { target: items, insertMode: 'before' };
      if (summary) return { target: summary, insertMode: 'before' };
      if (shell) return { target: shell, insertMode: 'prepend_inside' };
      return null;
    }

    if (placement === 'after_form') {
      if (items) return { target: items, insertMode: 'after' };
      if (summary) return { target: summary, insertMode: 'before' };
      if (shell) return { target: shell, insertMode: 'append_inside' };
      return null;
    }

    if (placement === 'inside_form' || placement === 'inside_form_prepend') {
      const mode = placement === 'inside_form_prepend' ? 'prepend_inside' : 'append_inside';
      if (summary) return { target: summary, insertMode: 'prepend_inside' };
      if (items) return { target: items, insertMode: mode };
      if (shell) return { target: shell, insertMode: mode };
      return null;
    }

    return null;
  }

  /**
   * Product page: prefer real ATC form; else buy-box / product-details / info column.
   */
  function getProductPlacementAnchors(searchRoot = document) {
    const root = getProductPageSearchRoot(searchRoot);
    const formComponent = getMainProductFormComponent(root);
    const innerForm = findInnerAddToCartForm(root);
    const formAnchor =
      formComponent ||
      root.querySelector('product-form') ||
      (innerForm
        ? innerForm.closest(
            'product-form-component, product-form, .buy-buttons-block, .product-form'
          ) || innerForm
        : null);

    const buyBox =
      root.querySelector('.buy-buttons-block') ||
      root.querySelector('buy-buttons') ||
      root.querySelector('[data-testid="buy-buttons"]') ||
      (innerForm ? innerForm.closest('.group-block, .product-details') : null);

    const details =
      root.querySelector('[data-testid="product-information-details"]') ||
      root.querySelector('.product-details') ||
      root.querySelector('.product__info-container') ||
      root.querySelector('.product-information') ||
      root.querySelector('product-info') ||
      root.querySelector('#ProductInfo');

    return { formAnchor, innerForm, buyBox, details, root };
  }

  function resolveProductFormPlacement(placement, searchRoot) {
    const { formAnchor, innerForm, buyBox, details, root } = getProductPlacementAnchors(searchRoot);
    const siblingAnchor = formAnchor || buyBox || details;

    if (placement === 'inside_form' || placement === 'inside_form_prepend') {
      const mode = placement === 'inside_form_prepend' ? 'prepend_inside' : 'append_inside';
      if (innerForm) return { target: innerForm, insertMode: mode };
      if (formAnchor) return { target: formAnchor, insertMode: mode };
      if (buyBox) return { target: buyBox, insertMode: mode };
      if (details) return { target: details, insertMode: mode };
      if (root && root !== document) return { target: root, insertMode: mode };
      return null;
    }

    if (placement === 'before_form' || placement === 'after_form') {
      if (!siblingAnchor) {
        if (root && root !== document) {
          return {
            target: root,
            insertMode: placement === 'before_form' ? 'prepend_inside' : 'append_inside'
          };
        }
        return null;
      }
      return {
        target: siblingAnchor,
        insertMode: placement === 'before_form' ? 'before' : 'after'
      };
    }

    return null;
  }

  function getProductPageSearchRoot(searchRoot = document) {
    if (searchRoot && searchRoot !== document) {
      return pickProductPageRoot(searchRoot) || searchRoot;
    }

    return pickProductPageRoot(document) || document;
  }

  function usesCustomPlacement(container) {
    return Boolean((container?.getAttribute('data-upsell-selector') || '').trim());
  }

  function isWrongMediaColumnPlacement(container) {
    return Boolean(
      container?.closest('media-gallery') ||
      container?.closest('.product__media-wrapper') ||
      container?.closest('[data-testid="product-information-media"]') ||
      container?.closest('.product-information__media')
    );
  }

  const UPSELL_PAGE_SHELL_CLASSES = [
    'upsell-container--product',
    'upsell-container--product-inline',
    'upsell-container--product-wide',
    'upsell-container--cart',
    'upsell-container--collection',
    'upsell-container--drawer'
  ];

  const PRODUCT_INLINE_HOST_SELECTOR =
    '[data-testid="product-information-details"], [id^="ProductInformation-"], .product-details, .product-information, .product__info-wrapper, #ProductInfo, .product__info-container, .product-form, [data-product-form], product-form, product-form-component:not(.quick-add__product-form-component)';

  function applyUpsellPageClasses(container, page, context = 'page', options = {}) {
    if (!container) return;

    UPSELL_PAGE_SHELL_CLASSES.forEach((cls) => container.classList.remove(cls));
    container.removeAttribute('data-upsell-scope');
    container.removeAttribute('data-upsell-page-shell');

    if (context === 'drawer') {
      container.classList.add('upsell-container--drawer');
      container.setAttribute('data-upsell-page-shell', 'drawer');
      return;
    }

    if (page === 'cart') {
      container.classList.add('upsell-container--cart');
      container.setAttribute('data-upsell-page-shell', 'cart');
      return;
    }

    if (page === 'collection') {
      container.classList.add('upsell-container--collection');
      container.setAttribute('data-upsell-page-shell', 'collection');
      return;
    }

    if (page === 'product') {
      container.classList.add('upsell-container--product');

      let scope = options.scope;
      if (scope !== 'inline' && scope !== 'wide') {
        const insertTarget = options.insertTarget || null;
        const inlineHost =
          container.closest(PRODUCT_INLINE_HOST_SELECTOR) ||
          insertTarget?.closest?.(PRODUCT_INLINE_HOST_SELECTOR);
        scope = inlineHost ? 'inline' : 'wide';
      }

      container.classList.add(`upsell-container--product-${scope}`);
      container.setAttribute('data-upsell-scope', scope);
      container.setAttribute('data-upsell-page-shell', `product-${scope}`);
    }
  }

  function finishUpsellMount(container, page, context = 'page', insertTarget = null) {
    if (!container) return;
    applyUpsellPageClasses(container, page, context, { insertTarget });
    // After DOM insert + drawer class — sample real theme surface colors.
    adaptUpsellSurfaceContrast(container);
    if (container.classList.contains('upsell-container--drawer')) {
      window.__superUpsellAdaptDrawerContrast?.();
    }
    container.removeAttribute('data-slider-bound');
    initUpsellSlider(container);
    if (container.classList.contains('upsell-container--qorum')) {
      scheduleQorumDrawerLayoutRefresh();
    }
    // A/B analytics: impression with ruleId + variantLabel + checkoutToken
    trackWidgetImpressions(container, page, context);
  }

  function refreshMountedUpsellWidgets(pageType) {
    document.querySelectorAll('.upsell-container').forEach((widget) => {
      const page = widget.getAttribute('data-page-context') || pageType;
      const shell = widget.getAttribute('data-upsell-page-shell');
      const context = shell === 'drawer' ? 'drawer' : 'page';
      const contextId = widget.getAttribute('data-upsell-auto-injected') || '';

      if (page === 'product') {
        fixMisplacedProductWidget(widget, contextId);
      }
      if (page === 'collection') {
        fixMisplacedCollectionWidget(widget, contextId);
      }

      finishUpsellMount(widget, page, context);
    });
  }

  function getUpsellPageShell(container) {
    const shell = container?.getAttribute?.('data-upsell-page-shell');
    if (shell) return shell;

    if (container?.classList?.contains('upsell-container--drawer')) return 'drawer';
    if (container?.classList?.contains('upsell-container--cart')) return 'cart';
    if (container?.classList?.contains('upsell-container--collection')) return 'collection';
    if (container?.classList?.contains('upsell-container--product-wide')) return 'product-wide';
    if (container?.classList?.contains('upsell-container--product-inline')) return 'product-inline';
    return '';
  }

  function fixMisplacedProductWidget(container, contextId = '') {
    if (container?.hasAttribute('data-upsell-block')) return;
    if (!container || !String(contextId).startsWith('product-page-')) return;
    if (usesCustomPlacement(container)) return;
    if (!isWrongMediaColumnPlacement(container)) return;

    const productInfo =
      document.querySelector('product-info') ||
      document.querySelector('[data-testid="product-information-details"]') ||
      document.querySelector('.product-information');
    const productForm =
      productInfo?.querySelector('product-form') || getMainProductFormComponent(productInfo);
    if (!productInfo || !productForm) return;

    const formWrapper = productForm.parentElement || productInfo;
    const existingWidgets = formWrapper.querySelectorAll('[data-upsell-auto-injected^="product-page-"]');
    const anchor = existingWidgets.length ? existingWidgets[existingWidgets.length - 1] : productForm;

    if (anchor.parentNode) {
      anchor.parentNode.insertBefore(container, anchor.nextSibling);
    } else {
      productInfo.appendChild(container);
    }
  }

  function findInnerAddToCartForm(searchRoot) {
    const root = searchRoot || document;
    const productRoot = getProductPageSearchRoot(root);
    const scopes = productRoot && productRoot !== document ? [productRoot, root] : [root];

    for (const scope of scopes) {
      const prioritized =
        scope.querySelector(
          '[data-testid="product-information-details"] form.shopify-product-form[data-type="add-to-cart-form"]'
        ) ||
        scope.querySelector(
          '.product-information form.shopify-product-form[data-type="add-to-cart-form"]'
        ) ||
        scope.querySelector(
          'product-form-component:not(.quick-add__product-form-component) form.shopify-product-form[data-type="add-to-cart-form"]'
        ) ||
        scope.querySelector('product-form form[action*="/cart/add"]');
      if (prioritized && !isUpsellQuickAddContext(prioritized) && !isUpsellPaymentTermsForm(prioritized)) {
        return prioritized;
      }

      const forms = scope.querySelectorAll('form[action*="/cart/add"]');
      for (const form of forms) {
        if (isUpsellQuickAddContext(form) || isUpsellPaymentTermsForm(form)) continue;
        if (
          form.getAttribute('data-type') === 'add-to-cart-form' ||
          form.classList.contains('shopify-product-form') ||
          form.closest('product-form, product-form-component')
        ) {
          return form;
        }
      }
    }

    return (
      root.querySelector('.product-form form') ||
      root.querySelector('.shopify-product-form')
    );
  }

  function findFormSiblingAnchor(searchRoot, page, context) {
    if (page === 'product' && context === 'page') {
      searchRoot = getProductPageSearchRoot(searchRoot);
    }

    if (context === 'drawer') {
      // Cart drawer: form first, then theme-wise mount.
      const cartForm = findDrawerCartForm(searchRoot);
      if (cartForm) return cartForm;

      const target = resolveUpsellThemeTarget();
      const themeMount =
        queryFirstFromSelectorList(target.drawerUpsellMount, searchRoot) ||
        queryFirstFromSelectorList(target.drawerUpsellMount, document);
      if (themeMount) return themeMount;

      const safeMount =
        searchRoot.querySelector('.cart-drawer__summary') ||
        searchRoot.querySelector('.cart-drawer__checkout') ||
        searchRoot.querySelector('[ref="checkoutButtons"]') ||
        searchRoot.querySelector('.cart-drawer__footer') ||
        searchRoot.querySelector('.drawer__footer') ||
        searchRoot.querySelector('.cart-summary') ||
        searchRoot.querySelector('[slot="footer"]');
      if (safeMount) return safeMount;

      const themedHeader = queryFirstFromSelectorList(target.headerSelector, searchRoot);
      if (themedHeader) return themedHeader;

      const drawerItems =
        searchRoot.querySelector('cart-drawer-items') ||
        searchRoot.querySelector('.cart-drawer__items');
      if (drawerItems) return drawerItems;

      return (
        searchRoot.querySelector('.cart-drawer__content') ||
        searchRoot.querySelector('.drawer__inner') ||
        searchRoot.querySelector('.cart-drawer__inner') ||
        searchRoot
      );
    }

    if (page === 'product') {
      const productFormComponent = getMainProductFormComponent(searchRoot);
      if (productFormComponent) return productFormComponent;

      const productForm = searchRoot.querySelector('product-form');
      if (productForm) return productForm;
    }

    const innerForm = findInnerAddToCartForm(searchRoot);
    if (innerForm) {
      return innerForm.closest('product-form-component, product-form') || innerForm;
    }

    if (page === 'cart') {
      return (
        getCartPagePlacementAnchor(searchRoot) ||
        searchRoot.querySelector('cart-items-component') ||
        searchRoot.querySelector('.cart-items-component') ||
        searchRoot.querySelector('.cart-page__items') ||
        searchRoot.querySelector('cart-items') ||
        searchRoot.querySelector('form[action="/cart"]') ||
        searchRoot.querySelector('form[action*="/cart"]')
      );
    }

    return null;
  }

  function isCollectionProductGrid(el) {
    if (!el) return false;
    if (el.id === 'product-grid') return true;
    return Boolean(
      el.matches?.(
        '[data-testid="product-grid"], .product-grid, ul.grid.product-grid, ul.product-grid, .collection-grid'
      )
    );
  }

  function getCollectionPageAnchor(searchRoot = document) {
    return (
      searchRoot.querySelector('.product-grid-container') ||
      searchRoot.querySelector('[data-testid="product-grid"]')?.closest('.collection-wrapper') ||
      searchRoot.querySelector('[data-testid="product-grid"]') ||
      searchRoot.querySelector('.product-grid') ||
      searchRoot.querySelector('#ProductGridContainer') ||
      searchRoot.querySelector('#product-grid')?.closest('.collection') ||
      searchRoot.querySelector('#product-grid, ul.grid.product-grid, .collection-grid')
    );
  }

  function getCollectionInsertMode(placement) {
    if (placement === 'before_form' || placement === 'before_selector') return 'before';
    if (placement === 'after_form' || placement === 'after_selector') return 'after';
    return 'after';
  }

  function resolveCollectionPageTarget(options) {
    const { placement, selector = '', searchRoot, contextId } = options;

    if (isWidgetMounted(contextId)) {
      return { skip: true };
    }

    const customSelector = String(selector || '').trim();
    const defaultAnchor = getCollectionPageAnchor(searchRoot);

    if (customSelector) {
      const customTarget =
        document.querySelector(customSelector) || searchRoot.querySelector(customSelector);
      if (customTarget) {
        if (isCollectionProductGrid(customTarget)) {
          const wrapper = getCollectionPageAnchor(searchRoot) || customTarget.parentElement;
          return { target: wrapper, insertMode: getCollectionInsertMode(placement) };
        }

        if (placement === 'before_selector') {
          return { target: customTarget, insertMode: 'before' };
        }
        if (placement === 'after_selector') {
          return { target: customTarget, insertMode: 'after' };
        }
        if (placement === 'insert') {
          return { target: customTarget, insertMode: 'append_inside' };
        }

        return { target: customTarget, insertMode: getCollectionInsertMode(placement) };
      }
      // Custom selector not found → fall through to default collection anchor.
    }

    if (!defaultAnchor) return null;
    return { target: defaultAnchor, insertMode: getCollectionInsertMode(placement) };
  }

  function fixMisplacedCollectionWidget(container, contextId = '') {
    if (!container || !String(contextId).startsWith('collection-page-')) return;
    if (!isCollectionProductGrid(container.parentElement)) return;

    const anchor = getCollectionPageAnchor();
    if (!anchor?.parentNode) return;

    const placement = String(container.getAttribute('data-upsell-placement') || 'after_form').toLowerCase();
    const selector = (container.getAttribute('data-upsell-selector') || '').trim();
    const { placement: parsedPlacement } = parseInjectionPlacement(placement, selector);
    const insertMode = getCollectionInsertMode(parsedPlacement);

    if (insertMode === 'before') {
      anchor.parentNode.insertBefore(container, anchor);
      return;
    }

    anchor.parentNode.insertBefore(container, anchor.nextSibling);
  }

  function getCartPageItemsAnchor(searchRoot = document) {
    const target = resolveUpsellThemeTarget();
    return (
      queryFirstFromSelectorList(target.cartPageItems, searchRoot) ||
      searchRoot.querySelector('cart-items-component') ||
      searchRoot.querySelector('.cart-items-component') ||
      searchRoot.querySelector('.cart-page__items') ||
      searchRoot.querySelector('cart-items') ||
      searchRoot.querySelector('#main-cart-items') ||
      searchRoot.querySelector('.main-cart-items') ||
      searchRoot.querySelector('[id^="shopify-section-"][id*="cart-items"]')
    );
  }

  function getCartPagePlacementAnchor(searchRoot = document) {
    const target = resolveUpsellThemeTarget();
    return (
      queryFirstFromSelectorList(target.cartPageMount, searchRoot) ||
      searchRoot.querySelector('.cart-page__items') ||
      searchRoot.querySelector('cart-items-component .cart-items__wrapper') ||
      searchRoot.querySelector('cart-items .page-width') ||
      searchRoot.querySelector('cart-items form#cart') ||
      searchRoot.querySelector('cart-items form[action="/cart"]') ||
      searchRoot.querySelector('cart-items form[action*="/cart"]') ||
      getCartPageItemsAnchor(searchRoot)
    );
  }

  function resolveCartPageTarget(options) {
    const { placement, selector = '', searchRoot, contextId } = options;

    if (isWidgetMounted(contextId)) {
      return { skip: true };
    }

    const customSelector = String(selector || '').trim();
    if (customSelector) {
      const customTarget =
        document.querySelector(customSelector) || searchRoot.querySelector(customSelector);
      if (customTarget) {
        if (placement === 'before_selector' || placement === 'before_form') {
          return { target: customTarget, insertMode: 'before' };
        }
        if (placement === 'after_selector' || placement === 'after_form') {
          return { target: customTarget, insertMode: 'after' };
        }
        if (placement === 'inside_form_prepend') {
          return { target: customTarget, insertMode: 'prepend_inside' };
        }
        return { target: customTarget, insertMode: 'append_inside' };
      }
      // Selector not found → continue with cart anchors.
    }

    const cartAnchor =
      getCartPagePlacementAnchor(searchRoot) || findFormSiblingAnchor(searchRoot, 'cart', 'page');

    if (placement === 'inside_form') {
      const cartForm =
        searchRoot.querySelector('cart-items form#cart') ||
        searchRoot.querySelector('form[action="/cart"]') ||
        searchRoot.querySelector('form[action*="/cart"]');
      if (cartForm) return { target: cartForm, insertMode: 'append_inside' };
      if (cartAnchor) return { target: cartAnchor, insertMode: 'append_inside' };
      return null;
    }

    if (placement === 'inside_form_prepend') {
      const cartForm =
        searchRoot.querySelector('cart-items form#cart') ||
        searchRoot.querySelector('form[action="/cart"]') ||
        searchRoot.querySelector('form[action*="/cart"]');
      if (cartForm) return { target: cartForm, insertMode: 'prepend_inside' };
      if (cartAnchor) return { target: cartAnchor, insertMode: 'prepend_inside' };
      return null;
    }

    if (placement === 'insert') {
      // No usable custom node — place after cart block.
      if (!cartAnchor) return null;
      return { target: cartAnchor, insertMode: 'after' };
    }

    if (placement === 'before_form' || placement === 'before_selector') {
      if (!cartAnchor) return null;
      return { target: cartAnchor, insertMode: 'before' };
    }

    if (placement === 'after_form' || placement === 'after_selector') {
      if (!cartAnchor) return null;
      const cartForm =
        searchRoot.querySelector('cart-items form#cart') ||
        searchRoot.querySelector('form[action="/cart"]') ||
        searchRoot.querySelector('form[action*="/cart"]');
      if (cartForm && cartAnchor.contains(cartForm)) {
        return { target: cartForm, insertMode: 'after' };
      }
      return { target: cartAnchor, insertMode: 'after' };
    }

    return resolveInjectionTarget({
      placement,
      selector,
      page: 'cart',
      context: 'page',
      searchRoot,
      contextId
    });
  }

  function resolveInjectionTarget(options) {
    const {
      placement,
      selector = '',
      page,
      context,
      searchRoot,
      contextId
    } = options;

    if (isWidgetMounted(contextId)) {
      return { skip: true };
    }

    if (placement === 'insert') {
      if (selector) {
        const target = document.querySelector(selector) || searchRoot.querySelector(selector);
        if (target) return { target, insertMode: 'append_inside' };
      }
      // Missing / not-found selector → form fallback below (after_form intent).
    }

    if (placement === 'before_selector' || placement === 'after_selector') {
      if (selector) {
        const target = document.querySelector(selector) || searchRoot.querySelector(selector);
        if (target) {
          return {
            target,
            insertMode: placement === 'before_selector' ? 'before' : 'after'
          };
        }
      }
      // Missing selector → same intent as before_form / after_form.
      const formPlacement = placement === 'before_selector' ? 'before_form' : 'after_form';
      if (context === 'drawer') return resolveDrawerFormPlacement(formPlacement, searchRoot);
      if (page === 'product') return resolveProductFormPlacement(formPlacement, searchRoot);
    }

    if (placement === 'inside_form' || placement === 'inside_form_prepend') {
      if (context === 'drawer') {
        return resolveDrawerFormPlacement(placement, searchRoot);
      }

      if (page === 'product') {
        const productResolved = resolveProductFormPlacement(placement, searchRoot);
        if (productResolved) return productResolved;
      }

      const addForm = findInnerAddToCartForm(searchRoot);
      if (addForm) {
        return {
          target: addForm,
          insertMode: placement === 'inside_form_prepend' ? 'prepend_inside' : 'append_inside'
        };
      }

      if (page === 'cart') {
        const cartForm =
          searchRoot.querySelector('form[action="/cart"]') ||
          searchRoot.querySelector('form[action*="/cart"]');
        if (cartForm) {
          return {
            target: cartForm,
            insertMode: placement === 'inside_form_prepend' ? 'prepend_inside' : 'append_inside'
          };
        }
      }

      if (page === 'product') return resolveProductFormPlacement(placement, searchRoot);
      if (context === 'drawer') return resolveDrawerFormPlacement(placement, searchRoot);
      return null;
    }

    if (placement === 'before_form' || placement === 'after_form') {
      if (context === 'drawer') {
        return resolveDrawerFormPlacement(placement, searchRoot);
      }

      if (page === 'product') {
        const productResolved = resolveProductFormPlacement(placement, searchRoot);
        if (productResolved) return productResolved;
      }

      const anchor = findFormSiblingAnchor(searchRoot, page, context);
      if (anchor) {
        return {
          target: anchor,
          insertMode: placement === 'before_form' ? 'before' : 'after'
        };
      }

      if (page === 'product') return resolveProductFormPlacement(placement, searchRoot);
      return null;
    }

    if (placement === 'insert') {
      if (context === 'drawer') return resolveDrawerFormPlacement('after_form', searchRoot);
      if (page === 'product') return resolveProductFormPlacement('after_form', searchRoot);
    }

    return null;
  }

  function resolveUpsellPlacementTarget(options) {
    const {
      page,
      context,
      placement,
      selector = '',
      searchRoot,
      contextId
    } = options;

    if (page === 'collection' && context === 'page') {
      return resolveCollectionPageTarget({
        placement,
        selector,
        searchRoot,
        contextId
      });
    }

    if (page === 'cart' && context === 'page') {
      return resolveCartPageTarget({
        placement,
        selector,
        searchRoot,
        contextId
      });
    }

    return resolveInjectionTarget({
      placement,
      selector,
      page,
      context,
      searchRoot,
      contextId
    });
  }

  function relocateUpsellBySettings(container, page, context, offerType, rootElement = null) {
    if (!container?.isConnected) return false;
    if (container.hasAttribute('data-upsell-block')) return false;

    const config = resolveInjectionConfig(page, context, offerType);
    if (!config) return false;

    const customSelector = String(config.selector || '').trim();
    const { placement, selector: placementSelector } = parseInjectionPlacement(
      config.injectionLocation,
      customSelector
    );
    const usesCustomSelector = Boolean(customSelector);
    const searchRoot =
      rootElement ||
      (page === 'product' && context === 'page' && !usesCustomSelector
        ? getProductPageSearchRoot()
        : document);

    const contextId =
      container.getAttribute('data-upsell-auto-injected') ||
      `manual-${page}-${offerType}`;

    const resolved = resolveUpsellPlacementTarget({
      page,
      context,
      placement,
      selector: placementSelector,
      searchRoot,
      contextId: `${contextId}-relocate`
    });

    if (!resolved?.target || resolved.skip) return false;

    container.setAttribute('data-upsell-placement', config.injectionLocation || 'after_form');
    if (customSelector) {
      container.setAttribute('data-upsell-selector', customSelector);
    } else {
      container.removeAttribute('data-upsell-selector');
    }

    const contextPrefix = contextId.replace(/-(cross_sells|upsells|fbt)$/, '');
    insertUpsellContainer(
      container,
      resolved.target,
      resolved.insertMode,
      context,
      rootElement,
      contextPrefix
    );

    if (page === 'product' && context === 'page') {
      fixMisplacedProductWidget(container, contextId);
    }
    if (page === 'collection' && context === 'page') {
      fixMisplacedCollectionWidget(container, contextId);
    }
    finishUpsellMount(container, page, context, resolved.target);

    return true;
  }

  function initUpsells(allOffers, settings, page, injectionOptions = {}) {
    const {
      contextId = 'default',
      context = 'page',
      contextPrefix = '',
      offerType = 'upsells',
      rootElement = null,
      selector = '',
      injectionLocation = 'after_form'
    } = injectionOptions;

    const customSelector = String(selector || '').trim();
    const { placement, selector: placementSelector } = parseInjectionPlacement(
      injectionLocation,
      customSelector
    );
    const usesCustomSelector = Boolean(customSelector);

    const searchRoot =
      rootElement ||
      (page === 'product' && context === 'page' && !usesCustomSelector
        ? getProductPageSearchRoot()
        : document);

    let resolved =
      page === 'collection' && context === 'page'
        ? resolveCollectionPageTarget({
            placement,
            selector: placementSelector,
            searchRoot,
            contextId
          })
        : page === 'cart' && context === 'page'
          ? resolveCartPageTarget({
              placement,
              selector: placementSelector,
              searchRoot,
              contextId
            })
          : resolveInjectionTarget({
              placement,
              selector: placementSelector,
              page,
              context,
              searchRoot,
              contextId
            });

    if (resolved?.skip) return true;

    let targetElement = resolved?.target || null;
    let insertMode = resolved?.insertMode || 'after';

    // Custom selector missing from DOM → keep going with form/theme fallbacks
    // (do not abort; placement must still work).
    if (!targetElement && usesCustomSelector) {
      const fallbackPlacement =
        placement === 'before_selector'
          ? 'before_form'
          : placement === 'after_selector'
            ? 'after_form'
            : placement === 'insert'
              ? 'after_form'
              : placement;

      const fallbackResolved =
        context === 'drawer'
          ? resolveDrawerFormPlacement(fallbackPlacement, searchRoot)
          : page === 'product'
            ? resolveProductFormPlacement(fallbackPlacement, searchRoot)
            : page === 'cart' && context === 'page'
              ? resolveCartPageTarget({
                  placement: fallbackPlacement,
                  selector: '',
                  searchRoot,
                  contextId
                })
              : null;

      if (fallbackResolved?.target) {
        targetElement = fallbackResolved.target;
        insertMode = fallbackResolved.insertMode;
      }
    }

    if (!targetElement && page === 'collection' && context === 'page') {
      const collectionResolved = resolveCollectionPageTarget({
        placement: placement === 'insert' && !placementSelector ? 'after_form' : placement,
        selector: placementSelector,
        searchRoot,
        contextId
      });
      if (collectionResolved?.skip) return true;
      if (collectionResolved?.target) {
        targetElement = collectionResolved.target;
        insertMode = collectionResolved.insertMode;
      }
    }

    if (!targetElement) {
      const defaultSelectors = getDefaultSelectors(page, context);
      for (const sel of defaultSelectors) {
        const el = searchRoot.querySelector(sel);
        if (!el) continue;

        if (page === 'collection' && context === 'page') {
          if (isCollectionProductGrid(el)) {
            targetElement = getCollectionPageAnchor(searchRoot) || el.parentElement;
          } else {
            targetElement = el;
          }
          insertMode = getCollectionInsertMode(placement);
          break;
        }

        if (placement === 'inside_form') {
          const form =
            context === 'drawer'
              ? findDrawerCartForm(searchRoot)
              : el.tagName === 'FORM'
                ? el
                : findInnerAddToCartForm(searchRoot);
          if (form) {
            targetElement = form;
            insertMode = 'append_inside';
            break;
          }
        }

        if (placement === 'inside_form_prepend') {
          const form =
            context === 'drawer'
              ? findDrawerCartForm(searchRoot)
              : el.tagName === 'FORM'
                ? el
                : findInnerAddToCartForm(searchRoot);
          if (form) {
            targetElement = form;
            insertMode = 'prepend_inside';
            break;
          }
        }

        if (placement === 'before_form' || placement === 'after_form') {
          if (context === 'drawer') {
            const drawerResolved = resolveDrawerFormPlacement(placement, searchRoot);
            if (drawerResolved?.target) {
              targetElement = drawerResolved.target;
              insertMode = drawerResolved.insertMode;
              break;
            }
          }
          targetElement = findFormSiblingAnchor(searchRoot, page, context) || el;
          insertMode = placement === 'before_form' ? 'before' : 'after';
          break;
        }

        if (placement === 'insert' && placementSelector) {
          targetElement =
            searchRoot.querySelector(placementSelector) ||
            document.querySelector(placementSelector);
          if (targetElement) {
            insertMode = 'append_inside';
            break;
          }
        }

        targetElement = el;
        insertMode = 'append_inside';
        break;
      }
    }

    if (!targetElement) {
      if (context === 'drawer') {
        const drawerFallback =
          resolveDrawerFormPlacement(
            placement === 'before_form' ||
              placement === 'after_form' ||
              placement === 'inside_form' ||
              placement === 'inside_form_prepend'
              ? placement
              : 'after_form',
            rootElement || searchRoot
          ) || null;
        if (drawerFallback?.target) {
          targetElement = drawerFallback.target;
          insertMode = drawerFallback.insertMode;
        } else {
          targetElement =
            (rootElement &&
              rootElement.querySelector?.(
                '.cart-drawer__summary, .cart-drawer__checkout, .cart-drawer__footer, .drawer__footer, .cart-drawer__content, .drawer__inner, .cart-drawer__inner'
              )) ||
            rootElement;
          insertMode =
            placement === 'before_form' || placement === 'inside_form_prepend'
              ? 'prepend_inside'
              : 'append_inside';
        }
      } else if (page === 'product') {
        const productFallback = resolveProductFormPlacement(
          placement === 'before_form' ||
            placement === 'after_form' ||
            placement === 'inside_form' ||
            placement === 'inside_form_prepend'
            ? placement
            : 'after_form',
          searchRoot
        );
        if (productFallback?.target) {
          targetElement = productFallback.target;
          insertMode = productFallback.insertMode;
        }
      }

      if (!targetElement) {
        targetElement =
          searchRoot.querySelector('[data-testid="product-information-details"]') ||
          searchRoot.querySelector('.product-information') ||
          searchRoot.querySelector('.product__info-wrapper') ||
          searchRoot.querySelector('product-info') ||
          searchRoot.querySelector('#ProductInfo') ||
          searchRoot.querySelector('.product-section') ||
          searchRoot.querySelector('#MainContent') ||
          searchRoot.querySelector('main') ||
          document.body;
        insertMode =
          placement === 'before_form' || placement === 'inside_form_prepend'
            ? 'prepend_inside'
            : placement === 'before_selector'
              ? 'before'
              : placement === 'after_selector' || placement === 'after_form'
                ? 'after'
                : 'append_inside';
        // body / main: only append/prepend inside is safe
        if (targetElement === document.body || targetElement?.matches?.('main, #MainContent')) {
          insertMode =
            placement === 'before_form' || placement === 'inside_form_prepend'
              ? 'prepend_inside'
              : 'append_inside';
        }
      }
    }

    if (!targetElement) return false;

    const container = buildUpsellContainer(
      allOffers,
      settings,
      context === 'drawer' ? 'cart' : page,
      contextId,
      offerType
    );
    if (!container) return false;

    container.setAttribute('data-upsell-placement', injectionLocation || 'after_form');
    if (customSelector) {
      container.setAttribute('data-upsell-selector', customSelector);
    }

    insertUpsellContainer(container, targetElement, insertMode, context, rootElement, contextPrefix);
    fixMisplacedProductWidget(container, contextId);
    fixMisplacedCollectionWidget(container, contextId);
    finishUpsellMount(container, page, context, targetElement);
    bindUpsellEvents(container, settings.behavior || {});
    return true;
  }

  function getDefaultSelectors(page, context) {
    const target = resolveUpsellThemeTarget();

    if (context === 'drawer') {
      const themed = String(target.drawerUpsellMount || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
      return [
        'form#cart-form.cart-form',
        'form#cart-form[action="/cart"]',
        'form.cart-form[action="/cart"]',
        'form[action="/cart"]',
        ...themed,
        '.cart-drawer__summary',
        '.cart-drawer__checkout',
        '[ref="checkoutButtons"]',
        '.cart-drawer__footer',
        '.drawer__footer',
        '.cart-summary',
        '.cart-drawer__content',
        '.cart-drawer__inner',
        '.drawer__inner'
      ];
    }
    if (page === 'cart') {
      const themed = String(target.cartPageMount || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
      return [
        ...themed,
        'cart-items-component',
        '.cart-items-component',
        '.cart-page__items',
        'cart-items',
        '.cart__items',
        'form[action="/cart"]',
        '.cart__footer',
        '.main-cart-footer',
        '.cart__footer-wrapper',
        '[data-cart-subtotal]',
        '.cart__contents'
      ];
    }
    if (page === 'collection') {
      return [
        '.product-grid-container',
        '[data-testid="product-grid"]',
        '.collection-wrapper',
        '.product-grid',
        '#ProductGridContainer',
        '.collection.page-width',
        '#MainContent',
        'main'
      ];
    }
    return [
      '[data-testid="product-information-details"]',
      '[data-testid="product-information"]',
      'product-form-component:not(.quick-add__product-form-component)',
      'product-form',
      'product-info',
      '#ProductInfo',
      'form.shopify-product-form[data-type="add-to-cart-form"]',
      'form[action*="/cart/add"]',
      '.product-form',
      '[data-product-form]',
      '.shopify-product-form',
      '.product__info-wrapper',
      '.product__content',
      '.product-section',
      '.ProductForm',
      '.product-single__form'
    ];
  }

  function getSliderNavButton(direction) {
    const isPrev = direction === 'prev';
    const points = isPrev ? '15 18 9 12 15 6' : '9 18 15 12 9 6';
    const label = isPrev ? 'Previous products' : 'Next products';
    return `
      <button type="button" class="upsell-slider-btn upsell-slider-btn--${direction}" aria-label="${label}">
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
          <polyline points="${points}" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `;
  }

  function getContainerPageContext(container) {
    const shell = getUpsellPageShell(container);
    if (shell === 'drawer') return 'drawer';
    if (shell === 'cart') return 'cart';
    if (shell === 'collection') return 'collection';
    if (shell === 'product-inline' || shell === 'product-wide') return 'product';

    const explicit = container?.getAttribute?.('data-page-context');
    if (explicit) return explicit;

    const injected = container?.getAttribute?.('data-upsell-auto-injected') || '';
    if (injected.startsWith('product-page-') || injected.startsWith('manual-product-')) return 'product';
    if (injected.startsWith('cart-page-') || injected.startsWith('manual-cart-')) return 'cart';
    if (injected.startsWith('collection-page-') || injected.startsWith('manual-collection-')) {
      return 'collection';
    }
    if (injected.startsWith('cart-drawer-') || injected.startsWith('manual-drawer-')) return 'drawer';

    return 'page';
  }

  function shouldSkipQorumDesktopSlider(container) {
    if (!container?.classList?.contains('upsell-container--qorum')) return false;
    if (!container.classList.contains('upsell-layout--slider')) return false;
    // Desktop: grid stack only — mobile keeps slider JS for carousel.
    return shouldUseQorumExternalPanel();
  }

  function initUpsellSlider(container) {
    if (shouldSkipQorumDesktopSlider(container)) return;
    if (!container?.classList?.contains('upsell-layout--slider')) return;
    if (container.getAttribute('data-slider-bound') === 'true') return;

    const slider = container.querySelector('.upsell-slider');
    const track = container.querySelector('.upsell-slider-track');
    const prevBtn = container.querySelector('.upsell-slider-btn--prev');
    const nextBtn = container.querySelector('.upsell-slider-btn--next');
    if (!slider || !track || !prevBtn || !nextBtn) return;

    const bindSlider = () => {
      if (track.clientWidth < 40) return false;

      if (container.getAttribute('data-slider-bound') === 'true') return true;
      container.setAttribute('data-slider-bound', 'true');

    const SCROLL_EDGE_THRESHOLD = 8;
    let ignoreSnapUntil = 0;
    let layoutTimer = null;
    let scrollSnapTimer = null;

    const getCards = () => Array.from(track.querySelectorAll(':scope > .upsell-card'));

    const getGap = () => {
      const style = window.getComputedStyle(track);
      return parseFloat(style.columnGap || style.gap || '0') || 0;
    };

    const getMaxScrollLeft = () => Math.max(0, track.scrollWidth - track.clientWidth);

    const isAtScrollStart = () => track.scrollLeft <= SCROLL_EDGE_THRESHOLD;

    const isAtScrollEnd = () => {
      const maxScrollLeft = getMaxScrollLeft();
      if (maxScrollLeft <= SCROLL_EDGE_THRESHOLD) return true;
      return track.scrollLeft >= maxScrollLeft - SCROLL_EDGE_THRESHOLD;
    };

    const setNavDisabled = (prevDisabled, nextDisabled) => {
      prevBtn.disabled = prevDisabled;
      nextBtn.disabled = nextDisabled;
      prevBtn.setAttribute('aria-disabled', prevDisabled ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', nextDisabled ? 'true' : 'false');
      prevBtn.classList.toggle('is-disabled', prevDisabled);
      nextBtn.classList.toggle('is-disabled', nextDisabled);
    };

    // Cumulative widths — stable even inside transformed drawers / horizontal cards.
    const getCardScrollPositions = () => {
      const cards = getCards();
      if (!cards.length) return [];

      const gap = getGap();
      let offset = 0;
      return cards.map((card) => {
        const left = Math.round(offset);
        offset += card.offsetWidth + gap;
        return left;
      });
    };

    const getActiveSlideIndex = () => {
      const positions = getCardScrollPositions();
      if (!positions.length) return 0;

      const scroll = track.scrollLeft;
      let active = 0;
      let minDist = Infinity;

      positions.forEach((pos, index) => {
        const dist = Math.abs(pos - scroll);
        if (dist < minDist) {
          minDist = dist;
          active = index;
        }
      });

      return active;
    };

    const scrollToSlide = (index, behavior = 'smooth') => {
      const positions = getCardScrollPositions();
      if (!positions.length) return;

      const target = Math.max(0, Math.min(index, positions.length - 1));
      ignoreSnapUntil = Date.now() + 450;
      track.scrollTo({ left: positions[target], behavior });
    };

    const applySliderLayout = () => {
      const cards = getCards();
      track.classList.toggle('upsell-slider-track--single', cards.length === 1);

      container.style.width = '100%';
      container.style.maxWidth = '100%';
      container.style.minWidth = '0';

      slider.style.width = '100%';
      slider.style.maxWidth = '100%';
      slider.style.minWidth = '0';

      // Clear JS pin so CSS 100cqi (against the track) can size cards for a true
      // 2-up look. Do NOT shrink-to-80 on every paint (that made skinny cards).
      container.style.removeProperty('--upsell-slider-card-width');
      slider.style.removeProperty('--upsell-slider-card-width');
      track.style.removeProperty('--upsell-slider-card-width');
      void slider.offsetWidth;

      const column =
        container.closest(
          '.product-details, .buy-buttons-block, .product__info-container, .product-form, [data-testid="product-information-details"], .product-information__grid .group-block'
        ) || container.parentElement;

      const winW = window.innerWidth || 0;
      const isBlown =
        winW > 0 &&
        ((column?.clientWidth || 0) > winW * 0.72 ||
          (slider.clientWidth || 0) > winW * 0.72 ||
          (container.clientWidth || 0) > winW * 0.72);

      // Only shrink when %/min-content already blew the column (B side of A/B).
      if (isBlown) {
        container.style.setProperty('--upsell-slider-card-width', '80px');
        slider.style.setProperty('--upsell-slider-card-width', '80px');
        track.style.setProperty('--upsell-slider-card-width', '80px');
        void track.offsetWidth;
      }

      const prevBtnW = prevBtn.getBoundingClientRect().width || 0;
      const nextBtnW = nextBtn.getBoundingClientRect().width || 0;
      const sliderGap = parseFloat(window.getComputedStyle(slider).gap || '0') || 0;
      // Overlay arrows (position:absolute) must not reduce card width.
      const prevPos = window.getComputedStyle(prevBtn).position;
      const nextPos = window.getComputedStyle(nextBtn).position;
      const overlayNav =
        (prevPos === 'absolute' || prevPos === 'fixed') &&
        (nextPos === 'absolute' || nextPos === 'fixed');
      const navChrome = overlayNav
        ? 0
        : Math.max(0, prevBtnW) + Math.max(0, nextBtnW) + sliderGap * 2;

      // Scrollport for "N full cards visible" — with overlay nav this is full slider.
      let trackViewport = track.clientWidth || 0;
      if (trackViewport < 40) {
        const fallback =
          slider.clientWidth || column?.clientWidth || container.clientWidth || 0;
        trackViewport = Math.max(1, fallback - navChrome);
      }

      const styles = window.getComputedStyle(container);
      let visible = parseFloat(styles.getPropertyValue('--upsell-slider-visible')) || 1;
      visible = Math.max(1, visible);
      const gap = getGap();

      const isQorumMobileCarousel =
        container.classList.contains('upsell-container--qorum-carousel') &&
        window.matchMedia('(max-width: 749px)').matches;

      const isMobilePeek =
        window.matchMedia('(max-width: 749px)').matches &&
        cards.length > 1 &&
        !track.classList.contains('upsell-slider-track--single') &&
        !isQorumMobileCarousel;

      let cardWidth;
      if (isQorumMobileCarousel) {
        cardWidth = trackViewport;
      } else if (isMobilePeek) {
        cardWidth = (trackViewport - gap) / 1.15;
      } else if (cards.length === 1) {
        cardWidth = trackViewport;
      } else {
        cardWidth = (trackViewport - gap * Math.max(0, visible - 1)) / visible;
      }

      // Pin px so card count can't grow % widths again — no artificial 120px floor.
      cardWidth = Math.max(1, Math.min(trackViewport, Math.floor(cardWidth * 100) / 100));
      const px = `${cardWidth}px`;
      container.style.setProperty('--upsell-slider-card-width', px);
      slider.style.setProperty('--upsell-slider-card-width', px);
      track.style.setProperty('--upsell-slider-card-width', px);
    };

    const setNoScrollClass = (shouldNoScroll) => {
      if (!slider) return;
      const hasClass = slider.classList.contains('upsell-slider--no-scroll');
      if (hasClass === shouldNoScroll) return;

      // Toggling overflow can reset scrollLeft in some browsers — preserve it.
      const keepScroll = track.scrollLeft;
      slider.classList.toggle('upsell-slider--no-scroll', shouldNoScroll);
      track.scrollLeft = keepScroll;
    };

    const updateNavButtons = () => {
      const cards = getCards();
      const maxScrollLeft = getMaxScrollLeft();
      const canScroll = cards.length > 1 && maxScrollLeft > SCROLL_EDGE_THRESHOLD;

      if (!canScroll) {
        setNavDisabled(true, true);
        return;
      }

      // Only scrollLeft — don't mix in index guesses (those caused prev flicker).
      setNavDisabled(isAtScrollStart(), isAtScrollEnd());
    };

    const updateScrollState = () => {
      const cards = getCards();
      const canScroll =
        cards.length > 1 &&
        track.scrollWidth > track.clientWidth + SCROLL_EDGE_THRESHOLD;
      setNoScrollClass(!canScroll);
      updateNavButtons();
    };

    const updateSliderState = () => {
      applySliderLayout();
      requestAnimationFrame(updateScrollState);
    };

    const scheduleLayoutUpdate = () => {
      if (layoutTimer) window.clearTimeout(layoutTimer);
      layoutTimer = window.setTimeout(() => {
        const keepScroll = track.scrollLeft;
        updateSliderState();
        requestAnimationFrame(() => {
          if (Math.abs(track.scrollLeft - keepScroll) > 1) {
            track.scrollLeft = keepScroll;
          }
          updateNavButtons();
        });
      }, 80);
    };

    prevBtn.addEventListener('click', (event) => {
      event.preventDefault();
      markSuperUpsellSliderInteraction();
      if (prevBtn.disabled) return;

      const nextIndex = Math.max(0, getActiveSlideIndex() - 1);
      scrollToSlide(nextIndex);
      window.setTimeout(updateNavButtons, 320);
    });

    nextBtn.addEventListener('click', (event) => {
      event.preventDefault();
      markSuperUpsellSliderInteraction();
      if (nextBtn.disabled) return;

      const cards = getCards();
      const maxScrollLeft = getMaxScrollLeft();
      const nextIndex = Math.min(cards.length - 1, getActiveSlideIndex() + 1);
      const positions = getCardScrollPositions();
      const nextPosition = positions[nextIndex];

      ignoreSnapUntil = Date.now() + 450;
      if (nextPosition != null && nextPosition < maxScrollLeft - SCROLL_EDGE_THRESHOLD) {
        scrollToSlide(nextIndex);
      } else {
        track.scrollTo({ left: maxScrollLeft, behavior: 'smooth' });
      }
      window.setTimeout(updateNavButtons, 320);
    });

    track.addEventListener('scroll', updateNavButtons, { passive: true });

    const snapToNearestSlide = () => {
      if (Date.now() < ignoreSnapUntil) {
        updateNavButtons();
        return;
      }

      const maxScrollLeft = getMaxScrollLeft();
      const cards = getCards();
      if (cards.length <= 1 || maxScrollLeft <= SCROLL_EDGE_THRESHOLD) {
        updateNavButtons();
        return;
      }

      // Light snap only — never force scroll back to start.
      if (isAtScrollEnd()) {
        if (Math.abs(track.scrollLeft - maxScrollLeft) > 6) {
          track.scrollTo({ left: maxScrollLeft, behavior: 'auto' });
        }
      } else if (!isAtScrollStart()) {
        const index = getActiveSlideIndex();
        const positions = getCardScrollPositions();
        const target = positions[index];
        if (target != null && index > 0 && Math.abs(track.scrollLeft - target) > 6) {
          track.scrollTo({ left: target, behavior: 'auto' });
        }
      }

      updateNavButtons();
    };

    if ('onscrollend' in window) {
      track.addEventListener(
        'scrollend',
        () => {
          snapToNearestSlide();
          updateNavButtons();
        },
        { passive: true }
      );
    } else {
      track.addEventListener(
        'scroll',
        () => {
          if (scrollSnapTimer) window.clearTimeout(scrollSnapTimer);
          scrollSnapTimer = window.setTimeout(snapToNearestSlide, 140);
        },
        { passive: true }
      );
    }

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(scheduleLayoutUpdate);
      observer.observe(track);
      if (slider) observer.observe(slider);
    }

    window.addEventListener('resize', scheduleLayoutUpdate, { passive: true });
    container.__superUpsellSliderRefresh = () => {
      updateSliderState();
      window.requestAnimationFrame(updateNavButtons);
    };
    updateSliderState();
    return true;
    };

    if (bindSlider()) return;

    if (typeof ResizeObserver !== 'undefined') {
      const waitObserver = new ResizeObserver(() => {
        if (bindSlider()) waitObserver.disconnect();
      });
      waitObserver.observe(track);
      if (slider) waitObserver.observe(slider);
    } else {
      pollWithRaf(() => bindSlider(), 120);
    }
  }

  function refreshQorumDrawerSliders(widgets) {
    if (!Array.isArray(widgets) || !widgets.length) return;

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        widgets.forEach((widget) => {
          if (!widget?.isConnected) return;
          if (!widget.classList.contains('upsell-layout--slider')) return;
          if (shouldSkipQorumDesktopSlider(widget)) return;

          if (typeof widget.__superUpsellSliderRefresh === 'function') {
            widget.__superUpsellSliderRefresh();
            return;
          }

          widget.removeAttribute('data-slider-bound');
          initUpsellSlider(widget);
        });
      });
    });
  }

  function buildQorumProductBadgesHtml(product, showBadge, fallbackBadgeText) {
    const badges = Array.isArray(product?.badges)
      ? product.badges.filter((badge) => badge?.title)
      : [];

    let badgeInner = '';
    if (badges.length) {
      badgeInner = `<div class="card__badge qorum-card__badge">${badges
        .map(
          (badge) =>
            `<span class="badge qorum-badge" style="color:${escapeAttr(badge.text_color || '#C9A96E')};background-color:${escapeAttr(badge.bg_color || 'rgba(10,10,10,0.78)')};">${escapeAttr(badge.title)}</span>`
        )
        .join('')}</div>`;
    } else if (showBadge && fallbackBadgeText) {
      badgeInner = `<div class="card__badge qorum-card__badge"><span class="badge qorum-badge upsell-badge">${escapeAttr(fallbackBadgeText)}</span></div>`;
    }

    if (!badgeInner) return '';
    return `<div class="qorum-ucard-badge-bar">${badgeInner}</div>`;
  }

  function buildQorumCollectionHtml(product) {
    const title = product?.collection_title;
    if (!title) return '';

    const label = escapeAttr(title);
    const url = product?.collection_url;
    const link = url
      ? `<a href="${escapeAttr(url)}">${label}</a>`
      : label;

    return `<div class="collection__rating"><span class="card__collection">${link}</span></div>`;
  }

  function buildQorumSubtitleHtml(product) {
    if (!product?.subtitle) return '';
    return `<div class="card__subtitle">${escapeAttr(product.subtitle)}</div>`;
  }

  function upsellImageAlt(product) {
    const subtitle = product && product.subtitle != null ? String(product.subtitle).trim() : '';
    const imageAlt = product && product.image_alt != null ? String(product.image_alt).trim() : '';
    return escapeAttr(subtitle || imageAlt);
  }

  function buildQorumPriceRowHtml(product, showPrice, soldOutHtml) {
    const priceHtml = showPrice
      ? `<span class="price"><span class="price-item upsell-price">${product.formatted_price || ''}</span></span>`
      : '';
    const emiHtml = product?.formatted_emi
      ? `<div class="card__monthly_emi">${escapeAttr(product.formatted_emi)}</div>`
      : '';

    return `<div class="card__price_emi qorum-ucard-price-row">${priceHtml}${emiHtml}${soldOutHtml || ''}</div>`;
  }

  function buildUpsellContainer(allOffers, settings, page, contextId, offerType = 'upsells') {
    const container = document.createElement('div');
    const isDrawerWidget = String(contextId || '').startsWith('cart-drawer-');
    const useQorumDrawerLayout = shouldUseQorumDrawerLayout(contextId);
    const layout = getLayoutForType(settings.display || {}, offerType, settings.pageConfig);
    const buttonStyle = settings.appearance?.buttonStyle || 'filled';
    let showOnMobile = settings.display?.showOnMobile !== false;
    let showOnDesktop = settings.display?.showOnDesktop !== false;
    if (useQorumDrawerLayout) {
      const qorumCfg = getQorumPanelConfig();
      showOnMobile = qorumCfg.showOnMobile !== false;
      showOnDesktop = qorumCfg.showOnDesktop !== false;
    }
    const hideMobile = showOnMobile === false ? ' upsell-hide-mobile' : '';
    const hideDesktop = showOnDesktop === false ? ' upsell-hide-desktop' : '';
    const cartAddUrl = `${getShopifyRootPath()}cart/add`;

    container.className = `upsell-container upsell-layout--${layout} upsell-button--${buttonStyle}${hideMobile}${hideDesktop}`;
    if (useQorumDrawerLayout) {
      container.classList.add('upsell-container--qorum');
      // Settings carousel/slider → desktop grid stack + mobile slider carousel.
      if (layout === 'slider') {
        container.classList.add('upsell-container--qorum-carousel');
      }
    }
    container.setAttribute('data-upsell-auto-injected', contextId);
    container.setAttribute('data-page-context', isDrawerWidget ? AB_SURFACE_DRAWER : page);
    if (isDrawerWidget) {
      container.setAttribute('data-ab-surface', AB_SURFACE_DRAWER);
    }
    container.setAttribute('data-offer-type', offerType);

    applyAppearanceStyles(container, settings.appearance || {});

    const headingText = getHeadingForType(settings.display || {}, page, offerType, settings.pageConfig);

    const showPrice = settings.display?.showPrice !== false;
    const showBadge = Boolean(settings.display?.showBadge);
    const badgeText = getBadgeForType(settings.display || {}, offerType, settings.pageConfig);
    const enableVariantSelector = Boolean(settings.behavior?.enableVariantSelector);
    const enableQuantitySelector = Boolean(settings.behavior?.enableQuantitySelector);
    const offersToRender = allOffers.filter(
      (offer) => (offer.offerType || 'upsells') === offerType
    );
    if (!offersToRender.length) return null;

    const cardsHtml = offersToRender.map((product) => {
      const priceHtml = showPrice ? `<p class="upsell-price">${product.formatted_price}</p>` : '';
      const badgeHtml = showBadge ? `<span class="upsell-badge">${badgeText}</span>` : '';
      const variantList = Array.isArray(product.variants) ? product.variants : [];
      const hasAvailableVariant =
        product.available !== false &&
        (variantList.length === 0 || variantList.some((variant) => variant.available !== false));
      const defaultVariantId =
        variantList.find((variant) => variant.available !== false)?.id ||
        product.variant_id ||
        variantList[0]?.id;
      const hasVariants = enableVariantSelector && variantList.length > 1;
      const variantHtml = hasVariants
        ? `<select name="id" class="upsell-variant-select">
                ${variantList.map(v => `<option value="${v.id}" ${v.available === false ? 'disabled' : ''}>${v.title}</option>`).join('')}
              </select>`
        : `<input type="hidden" name="id" value="${defaultVariantId || ''}">`;
      const qtyHtml = enableQuantitySelector
        ? `<input type="number" name="quantity" min="1" value="1" class="upsell-qty-input">`
        : '';
      const soldOutHtml = hasAvailableVariant ? '' : '<span class="upsell-sold-out">Sold out</span>';
      const addBtnAttrs = hasAvailableVariant ? '' : ' disabled aria-disabled="true"';
      const addButtonLabel = getAddButtonLabel(settings, hasAvailableVariant, settings.pageConfig, offerType);
      const ruleIdAttr = escapeAttr(product.ruleId != null ? product.ruleId : '');
      const variantLabelAttr = escapeAttr(
        normalizeVariantLabel(product.variantLabel || product.abVariant || 'A')
      );
      const trackingAttrs = `data-product-handle="${escapeAttr(product.handle)}" data-offer-type="${escapeAttr(product.offerType || 'upsells')}" data-rule-id="${ruleIdAttr}" data-variant-label="${variantLabelAttr}"`;

      if (useQorumDrawerLayout) {
        const qorumBadgesHtml = buildQorumProductBadgesHtml(product, showBadge, badgeText);
        const qorumCollectionHtml = buildQorumCollectionHtml(product);
        const qorumSubtitleHtml = buildQorumSubtitleHtml(product);
        const qorumPriceRowHtml = buildQorumPriceRowHtml(product, showPrice, soldOutHtml);
        const productUrl = `${getShopifyRootPath()}products/${product.handle}`;

        if(hasAvailableVariant){
            return `
              <div class="upsell-card qorum-ucard product-card-wrapper${hasAvailableVariant ? '' : ' upsell-card--unavailable'}">
                <div class="card card--standard qorum-ucard-shell">
                  <div class="card__inner qorum-ucard-media-wrap">
                    <a href="${productUrl}" class="upsell-link qorum-ucard-img card__media" ${trackingAttrs}>
                      <img src="${product.image}" loading="lazy" class="upsell-image" alt="${upsellImageAlt(product)}">
                      ${qorumBadgesHtml}
                    </a>
                  </div>
                  <div class="card__content qorum-ucard-body">
                    <div class="card__information">
                      ${qorumCollectionHtml}
                      <h3 class="card__heading upsell-title qorum-ucard-name">
                        <a href="${productUrl}" class="full-unstyled-link upsell-qorum-card-text" ${trackingAttrs}>${escapeAttr(product.title)}</a>
                      </h3>
                      ${qorumSubtitleHtml}
                      ${qorumPriceRowHtml}
                      <form method="post" action="${cartAddUrl}" class="upsell-form" data-upsell-form ${trackingAttrs}>
                        ${variantHtml}
                        ${qtyHtml}
                        <button type="submit" class="upsell-atc-btn qorum-ucard-btn"${addBtnAttrs}>${addButtonLabel}</button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            `;
        }else{
           return '';
        }
        
      }


       if(hasAvailableVariant){
           return `
            <div class="upsell-card${hasAvailableVariant ? '' : ' upsell-card--unavailable'}">
              <a href="${getShopifyRootPath()}products/${product.handle}" class="upsell-link" ${trackingAttrs}>
                <img src="${product.image}" loading="lazy" class="upsell-image" alt="${upsellImageAlt(product)}">
                ${badgeHtml}
                <h4 class="upsell-title">${product.title}</h4>
                ${priceHtml}
                ${soldOutHtml}
              </a>
              <form method="post" action="${cartAddUrl}" class="upsell-form" data-upsell-form ${trackingAttrs}>
                ${variantHtml}
                ${qtyHtml}
                <button type="submit" class="upsell-atc-btn"${addBtnAttrs}>${addButtonLabel}</button>
              </form>
            </div>
          `;
        }else{
           return '';
        }
    }).join('');

    const safeHeading = String(headingText || 'Products').replace(/"/g, '&quot;');
    const sliderControlsHtml =
      layout === 'slider'
        ? `
      <div class="upsell-slider-controls" aria-label="${safeHeading} navigation">
        ${getSliderNavButton('prev')}
        ${getSliderNavButton('next')}
      </div>
    `
        : '';

    const gridHtml =
      layout === 'slider'
        ? `
      <div class="upsell-slider">
        <div class="upsell-grid upsell-slider-track" role="region" aria-label="${safeHeading}">
          ${cardsHtml}
        </div>
      </div>
    `
        : useQorumDrawerLayout
          ? `<div class="upsell-grid upsell-qorum-grid-track" role="region" aria-label="${safeHeading}">${cardsHtml}</div>`
          : `<div class="upsell-grid">${cardsHtml}</div>`;

    container.innerHTML = `
      <div class="upsell-container__inner">
        <div class="upsell-header">
          <h3 class="upsell-heading">${headingText}</h3>
          ${sliderControlsHtml}
        </div>
        ${gridHtml}
      </div>
    `;

    return container;
  }

  function hasUpsellSibling(node, contextPrefix) {
    const injected = node?.getAttribute?.('data-upsell-auto-injected');
    return Boolean(injected && (!contextPrefix || injected.startsWith(`${contextPrefix}-`)));
  }

  function insertUpsellContainer(container, targetElement, insertMode, context, rootElement, contextPrefix = '') {
    if (!container || !targetElement) return;

    // before / after = sibling placement (works for cart drawer + cart page).
    // Do not force drawer widgets into append-inside — that broke Settings
    // before_form / after_form / form_append.
    if (insertMode === 'append_inside') {
      targetElement.appendChild(container);
      return;
    }

    if (insertMode === 'prepend_inside') {
      targetElement.insertBefore(container, targetElement.firstChild);
      return;
    }

    if (targetElement === document.body) {
      targetElement.appendChild(container);
      return;
    }

    if (!targetElement.parentNode) {
      (rootElement || document.body).appendChild(container);
      return;
    }

    if (insertMode === 'before') {
      let insertBefore = targetElement;
      while (hasUpsellSibling(insertBefore.previousElementSibling, contextPrefix)) {
        insertBefore = insertBefore.previousElementSibling;
      }
      targetElement.parentNode.insertBefore(container, insertBefore);
      return;
    }

    // insertMode === 'after' (before_form / after_form default)
    let anchor = targetElement;
    while (hasUpsellSibling(anchor.nextElementSibling, contextPrefix)) {
      anchor = anchor.nextElementSibling;
    }
    targetElement.parentNode.insertBefore(container, anchor.nextSibling);
  }

  function applyAppearanceStyles(container, appearance) {
    const radius = Number.isFinite(appearance.borderRadius)
      ? appearance.borderRadius
      : parseInt(appearance.borderRadius || '8', 10);

    const shadow = getShadowStyles(appearance.cardShadow);

    container.style.setProperty('--upsell-bg', appearance.backgroundColor || '#f9f9f9');
    container.style.setProperty('--upsell-text', appearance.textColor || '#202223');
    container.style.setProperty('--upsell-heading', appearance.headingColor || '#202223');
    container.style.setProperty('--upsell-primary', appearance.primaryColor || '#000000');
    container.style.setProperty('--upsell-button-text', appearance.buttonTextColor || '#ffffff');
    container.style.setProperty('--upsell-card-bg', appearance.cardBackgroundColor || '#ffffff');
    container.style.setProperty('--upsell-radius', Number.isFinite(radius) ? `${radius}px` : '8px');
    container.style.setProperty('--upsell-card-shadow', shadow.base);
    container.style.setProperty('--upsell-card-shadow-hover', shadow.hover);
    container.style.setProperty('--upsell-font', appearance.fontFamily || 'inherit');
  }

  function parseCssColor(input) {
    if (input == null) return null;
    const s = String(input).trim().toLowerCase();
    if (!s || s === 'transparent' || s === 'inherit' || s === 'initial') return null;

    const rgba = s.match(
      /^rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)(?:\s*[,/]\s*([\d.]+%?))?\s*\)$/
    );
    if (rgba) {
      const aRaw = rgba[4];
      let a = 1;
      if (aRaw != null) {
        a = String(aRaw).endsWith('%') ? parseFloat(aRaw) / 100 : Number(aRaw);
      }
      if (!(a > 0.08)) return null;
      return { r: Number(rgba[1]), g: Number(rgba[2]), b: Number(rgba[3]), a };
    }

    let hex = s[0] === '#' ? s.slice(1) : '';
    if (hex.length === 3 || hex.length === 4) {
      hex = hex
        .split('')
        .map((ch) => ch + ch)
        .join('');
    }
    if (hex.length === 6 || hex.length === 8) {
      const r = parseInt(hex.slice(0, 2), 16);
      const g = parseInt(hex.slice(2, 4), 16);
      const b = parseInt(hex.slice(4, 6), 16);
      const a = hex.length === 8 ? parseInt(hex.slice(6, 8), 16) / 255 : 1;
      if ([r, g, b].some((n) => Number.isNaN(n)) || !(a > 0.08)) return null;
      return { r, g, b, a };
    }
    return null;
  }

  function relativeLuminance(color) {
    const channel = (v) => {
      const c = Math.max(0, Math.min(255, Number(v))) / 255;
      return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
    };
    return 0.2126 * channel(color.r) + 0.7152 * channel(color.g) + 0.0722 * channel(color.b);
  }

  function contrastRatio(a, b) {
    const l1 = relativeLuminance(a);
    const l2 = relativeLuminance(b);
    const light = Math.max(l1, l2);
    const dark = Math.min(l1, l2);
    return (light + 0.05) / (dark + 0.05);
  }

  function colorToCss(color) {
    return `rgb(${Math.round(color.r)}, ${Math.round(color.g)}, ${Math.round(color.b)})`;
  }

  function findOpaqueBackgroundColor(el) {
    let node = el instanceof Element ? el : null;
    while (node && node.nodeType === 1 && node !== document.documentElement) {
      const parsed = parseCssColor(getComputedStyle(node).backgroundColor);
      if (parsed) return { color: parsed, node };
      node = node.parentElement;
    }
    return { color: { r: 255, g: 255, b: 255, a: 1 }, node: document.body };
  }

  function pickReadableColor(background, preferredCss, lightCss = '#f5f5f5', darkCss = '#202223') {
    const light = parseCssColor(lightCss) || { r: 245, g: 245, b: 245, a: 1 };
    const dark = parseCssColor(darkCss) || { r: 32, g: 34, b: 35, a: 1 };
    const preferred = parseCssColor(preferredCss);
    if (preferred && contrastRatio(preferred, background) >= 3.5) {
      return preferredCss;
    }
    return contrastRatio(light, background) >= contrastRatio(dark, background)
      ? colorToCss(light)
      : colorToCss(dark);
  }

  /**
   * Drawer widgets sit on the theme drawer surface (often dark). Merchant
   * appearance colors assume a light page, so auto-pick readable heading /
   * text / borders from the real surface + card backgrounds.
   */
  function adaptUpsellSurfaceContrast(container) {
    if (!(container instanceof HTMLElement)) return;
    if (!container.classList.contains('upsell-container--drawer')) return;
    if (container.classList.contains('upsell-container--qorum')) return;

    const surfaceHost =
      container.closest(
        '.cart-drawer__summary, .cart-drawer__content, .cart-drawer__dialog, .cart-drawer__inner, cart-drawer-component, .cart-drawer, #CartDrawer, #Cart-Drawer, .drawer, .drawer__inner, .mini_cart_wrap, .ajax-cart'
      ) || container.parentElement;

    const { color: surface } = findOpaqueBackgroundColor(surfaceHost || container);
    const isDarkSurface = relativeLuminance(surface) < 0.45;
    container.dataset.upsellSurface = isDarkSurface ? 'dark' : 'light';

    const themeText = surfaceHost ? getComputedStyle(surfaceHost).color : '';
    const preferredHeading =
      container.style.getPropertyValue('--upsell-heading').trim() ||
      themeText ||
      '#202223';

    container.style.setProperty(
      '--upsell-heading',
      pickReadableColor(surface, preferredHeading, themeText || '#f5f5f5', '#202223')
    );

    container.style.setProperty(
      '--upsell-surface-border',
      isDarkSurface ? 'rgba(255, 255, 255, 0.18)' : 'rgba(0, 0, 0, 0.1)'
    );

    // Cards keep an opaque surface (default white) — ensure body text reads on that.
    const cardBg =
      parseCssColor(container.style.getPropertyValue('--upsell-card-bg')) ||
      parseCssColor(
        getComputedStyle(container).getPropertyValue('--upsell-card-bg')
      ) ||
      { r: 255, g: 255, b: 255, a: 1 };
    const preferredText =
      container.style.getPropertyValue('--upsell-text').trim() || '#202223';
    container.style.setProperty('--upsell-text', pickReadableColor(cardBg, preferredText));

    const preferredBtnBg =
      container.style.getPropertyValue('--upsell-primary').trim() || '#000000';
    const preferredBtnText =
      container.style.getPropertyValue('--upsell-button-text').trim() || '#ffffff';
    const btnBg = parseCssColor(preferredBtnBg) || { r: 0, g: 0, b: 0, a: 1 };
    container.style.setProperty(
      '--upsell-button-text',
      pickReadableColor(btnBg, preferredBtnText, '#ffffff', '#111111')
    );
  }

  function getShadowStyles(level) {
    if (level === 'strong') {
      return { base: '0 6px 18px rgba(0,0,0,0.18)', hover: '0 10px 24px rgba(0,0,0,0.22)' };
    }
    if (level === 'soft') {
      return { base: '0 2px 8px rgba(0,0,0,0.08)', hover: '0 6px 16px rgba(0,0,0,0.12)' };
    }
    return { base: 'none', hover: '0 6px 16px rgba(0,0,0,0.12)' };
  }

  const KNOWN_CART_SECTIONS = [
    'cart-drawer',
    'cart-icon-bubble',
    'cart-notification',
    'cart-notification-product',
    'cart-notification-button',
    'cart-items',
    'main-cart-items',
    'main-cart-footer',
    'cart-footer',
    'header',
    'minicart',
    'ajax-cart',
    'side-cart',
    'cart-drawer-items'
  ];

  function getShopifyRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  function getCartAddUrl() {
    return `${getShopifyRoot()}cart/add.js`;
  }

  function getCartUrl() {
    return `${getShopifyRoot()}cart`;
  }

  function getCartSectionIds() {
    const ids = new Set(KNOWN_CART_SECTIONS);

    document.querySelectorAll('[data-section-id]').forEach((el) => {
      const id = el.getAttribute('data-section-id');
      if (id && /cart|drawer|header|mini/i.test(id)) {
        ids.add(id);
      }
    });

    document.querySelectorAll('[id^="shopify-section-"]').forEach((el) => {
      const id = el.id.replace('shopify-section-', '');
      if (/cart|drawer|header|mini/i.test(id)) {
        ids.add(id);
      }
    });

    return Array.from(ids).slice(0, 5);
  }

  function replaceSectionHtml(sectionId, html) {
    if (!html) return;

    const existing =
      document.getElementById(`shopify-section-${sectionId}`) ||
      document.querySelector(`[data-section-id="${sectionId}"]`);

    if (!existing) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newEl =
      doc.getElementById(`shopify-section-${sectionId}`) ||
      doc.querySelector(`[data-section-id="${sectionId}"]`) ||
      doc.body.firstElementChild;

    if (newEl) {
      existing.innerHTML = newEl.innerHTML;
    }
  }

  function updateCartCount(itemCount) {
    if (!Number.isFinite(itemCount)) return;

    const countSelectors = [
      '[data-cart-count]',
      '.cart-count-bubble',
      '.cart-count',
      '.js-cart-count',
      '.cart-item-count',
      '#CartCount',
      '.header__cart-count',
      '.site-header__cart-count',
      'cart-count',
      '.icon-cart-count',
      '[data-header-cart-count]'
    ];

    countSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        el.textContent = itemCount;
        el.setAttribute('data-cart-count', String(itemCount));
        el.classList.toggle('cart-count--empty', itemCount === 0);
      });
    });
  }

  async function fetchCartState() {
    try {
      const res = await fetch(`${getShopifyRoot()}cart.js`, {
        headers: { Accept: 'application/json' }
      });
      return await res.json();
    } catch {
      return null;
    }
  }

  async function fetchAndReplaceSections(sectionIds) {
    if (!sectionIds.length) return;

    try {
      const url = `${window.location.pathname}?sections=${sectionIds.join(',')}`;
      const res = await fetch(url, { credentials: 'same-origin' });
      const sections = await res.json();
      sectionIds.forEach((id) => replaceSectionHtml(id, sections[id]));
    } catch (err) {
      console.error('Super Upsell: Failed to refresh cart sections', err);
    }
  }

  function findHorizonCartDrawer() {
    return document.querySelector('cart-drawer-component');
  }

  function findThemeCartDrawer() {
    return document.querySelector('theme-drawer#cart-drawer');
  }

  function isHorizonCartTheme() {
    return Boolean(
      findHorizonCartDrawer() ||
      findThemeCartDrawer() ||
      document.querySelector('cart-items-component') ||
      document.querySelector('product-form-component')
    );
  }

  function getCartItemCount(cartData, addResponse) {
    if (cartData?.item_count != null) return cartData.item_count;
    if (addResponse?.item_count != null) return addResponse.item_count;
    if (Array.isArray(addResponse?.items)) return addResponse.items.length;
    return 1;
  }

  function buildHorizonCartFromAjax(cartData) {
    if (!cartData) return null;

    const currencyCode = cartData.currency || 'USD';
    const toAmount = (value) => String((Number(value) || 0) / 100);

    return {
      id: cartData.token || cartData.id || '',
      totalQuantity: cartData.item_count ?? 0,
      cost: {
        totalAmount: {
          amount: toAmount(cartData.total_price),
          currencyCode
        }
      },
      lines: (cartData.items || []).map((item, index) => ({
        id: item.key || item.id || index,
        quantity: item.quantity,
        cost: {
          totalAmount: {
            amount: toAmount(item.final_line_price ?? item.line_price),
            currencyCode
          }
        }
      })),
      discountCodes: []
    };
  }

  function dispatchHorizonCartUpdate(cartData, addResponse) {
    const itemCount = getCartItemCount(cartData, addResponse);
    const sections = addResponse?.sections || null;
    const event = new CustomEvent('shopify:cart:lines-update', { bubbles: true });

    event.action = 'add';
    event.context = 'product';
    event.lines = [];
    event.promise = Promise.resolve({
      cart: buildHorizonCartFromAjax(cartData || addResponse),
      detail: {
        sections,
        items: cartData?.items || addResponse?.items,
        itemCount,
        source: 'super-upsell',
        didError: false
      }
    });

    document.dispatchEvent(event);

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          data: {
            itemCount,
            source: 'super-upsell'
          },
          cart: cartData || addResponse
        }
      })
    );
  }

  function openHorizonCartDrawer() {
    const themeDrawer = findThemeCartDrawer();
    if (themeDrawer && typeof themeDrawer.open === 'function') {
      themeDrawer.open();
      return true;
    }

    const drawer = findHorizonCartDrawer();
    if (drawer) {
      const parentDrawer = drawer.closest('theme-drawer');
      if (parentDrawer && typeof parentDrawer.open === 'function') {
        parentDrawer.open();
        return true;
      }

      if (typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }

      if (typeof drawer.showDialog === 'function') {
        drawer.showDialog();
        return true;
      }
    }

    const trigger = document.querySelector(
      '[data-testid="cart-drawer-trigger"], [aria-controls="cart-drawer"]'
    );
    if (trigger) {
      trigger.click();
      return true;
    }

    return false;
  }

  function dispatchArchetypeCartEvents(cartData, addResponse) {
    const product = addResponse?.items?.[0] || addResponse;

    document.dispatchEvent(
      new CustomEvent('ajaxProduct:added', {
        bubbles: true,
        detail: { product, cart: cartData }
      })
    );

    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true, detail: { cart: cartData } }));
  }

  function isArchetypeCartTheme() {
    return Boolean(
      !document.querySelector('cart-drawer') &&
      !findHorizonCartDrawer() &&
      (document.querySelector('#CartDrawer') ||
        document.querySelector('[data-cart-drawer]') ||
        document.body?.classList.contains('template-theme-impulse'))
    );
  }

  function dispatchCartEvents(cartData, addResponse = null) {
    const detail = { cart: cartData, source: 'super-upsell' };
    const eventNames = [
      'cart:refresh',
      'cart:updated',
      'cart:change',
      'theme:cart:change',
      'theme:cart:update',
      'ajaxCart:updated',
      'product:added',
      'cart:build',
      'cart:open'
    ];

    eventNames.forEach((name) => {
      document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
    });

    if (isHorizonCartTheme()) {
      dispatchHorizonCartUpdate(cartData, addResponse);
    }

    if (isArchetypeCartTheme()) {
      dispatchArchetypeCartEvents(cartData, addResponse);
    }

    if (window.PubSub?.publish && window.PUB_SUB_EVENTS?.cartUpdate) {
      window.PubSub.publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source: 'super-upsell',
        cartData
      });
    }
  }

  function prepareDawnCartUi(cartElement, triggerElement = null) {
    if (!cartElement) return;

    if (cartElement.classList.contains('is-empty')) {
      cartElement.classList.remove('is-empty');
    }

    const drawerInner = cartElement.querySelector?.('.drawer__inner');
    if (drawerInner?.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }

    if (typeof cartElement.setActiveElement === 'function') {
      cartElement.setActiveElement(triggerElement || document.activeElement);
    }
  }

  function appendHorizonCartSections(formData) {
    const sectionIds = new Set();

    document.querySelectorAll('cart-items-component').forEach((item) => {
      const id = item instanceof HTMLElement ? item.dataset.sectionId : null;
      if (id) sectionIds.add(id);
    });

    document.querySelectorAll('[data-section-id]').forEach((el) => {
      const id = el.getAttribute('data-section-id');
      if (id && /cart-drawer|cart-icon|header/i.test(id)) {
        sectionIds.add(id);
      }
    });

    if (sectionIds.size) {
      formData.append('sections', Array.from(sectionIds).join(','));
      formData.append('sections_url', window.location.pathname);
    }
  }

  function appendCartSectionsToFormData(formData, triggerElement = null) {
    if (isHorizonCartTheme()) {
      appendHorizonCartSections(formData);
      return;
    }

    const onCartPage = pageType === 'cart' || window.location.pathname.includes('/cart');
    const cartItems = document.querySelector('cart-items');

    if (onCartPage && cartItems && typeof cartItems.getSectionsToRender === 'function') {
      const sections = cartItems
        .getSectionsToRender()
        .map((section) => section.section || section.id)
        .filter(Boolean);
      if (sections.length) {
        formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname);
        return;
      }
    }

    const cartDrawer = document.querySelector('cart-drawer');
    const cartNotification = document.querySelector('cart-notification');
    const cartUi = cartNotification || cartDrawer;

    if (cartUi && typeof cartUi.getSectionsToRender === 'function') {
      formData.append('sections', cartUi.getSectionsToRender().map((section) => section.id).join(','));
      formData.append('sections_url', window.location.pathname);
      prepareDawnCartUi(cartUi, triggerElement);
      return;
    }

    const sectionIds = getCartSectionIds();
    if (sectionIds.length) {
      formData.append('sections', sectionIds.join(','));
      formData.append('sections_url', window.location.pathname);
    }
  }

  function openCartDrawer(cartData) {
    if (isHorizonCartTheme()) {
      dispatchHorizonCartUpdate(cartData, cartData);
      return openHorizonCartDrawer();
    }

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      prepareDawnCartUi(cartDrawer);
      if (typeof cartDrawer.renderContents === 'function' && cartData) {
        cartDrawer.renderContents(cartData);
        return true;
      }
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        return true;
      }
    }

    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification) {
      prepareDawnCartUi(cartNotification);
      if (typeof cartNotification.renderContents === 'function' && cartData) {
        cartNotification.renderContents(cartData);
        return true;
      }
    }

    if (typeof window.SLIDECART_OPEN === 'function') {
      if (typeof window.SLIDECART_UPDATE === 'function') {
        window.SLIDECART_UPDATE(cartData);
      }
      window.SLIDECART_OPEN();
      return true;
    }

    const triggerSelectors = [
      '[data-cart-drawer-trigger]',
      'a[href="/cart"][data-drawer-trigger]',
      '.js-drawer-open-cart',
      '.js-cart-drawer-trigger',
      '#CartLink',
      '.cart-drawer-toggle',
      '[aria-controls="CartDrawer"]',
      '[aria-controls="cart-drawer"]',
      '.header__icon--cart button',
      '.header__icon--cart',
      '#cart-icon-bubble',
      '.site-header__cart',
      '.cart-link',
      '[data-action="open-drawer"][data-drawer="cart"]'
    ];

    for (const selector of triggerSelectors) {
      const trigger = document.querySelector(selector);
      if (trigger) {
        trigger.click();
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:open', { bubbles: true, detail: { cart: cartData } })
        );
        return true;
      }
    }

    const drawerSelectors = [
      '#CartDrawer',
      '#cart-drawer',
      '.cart-drawer',
      '.drawer--cart',
      '[data-cart-drawer]'
    ];

    for (const selector of drawerSelectors) {
      const drawer = document.querySelector(selector);
      if (!drawer) continue;

      drawer.classList.add('active', 'is-open', 'open', 'drawer--is-open', 'animate');
      drawer.setAttribute('open', '');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden', 'cart-open', 'drawer-open', 'js-drawer-open');
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:open', { bubbles: true, detail: { cart: cartData } })
      );
      return true;
    }

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:open', { bubbles: true, detail: { cart: cartData } })
    );
    return false;
  }

  async function syncCartAfterAdd(addResponse, behavior) {
    const action = behavior.addToCartAction || 'open_cart';
    const cartDrawer = document.querySelector('cart-drawer');
    const cartNotification = document.querySelector('cart-notification');
    const horizonTheme = isHorizonCartTheme();
    const sectionIds = getCartSectionIds();
    const onCartPage = pageType === 'cart' || window.location.pathname.includes('/cart');

    const applySections = (sections) => {
      if (!sections) return;
      Object.entries(sections).forEach(([id, html]) => replaceSectionHtml(id, html));
    };

    if (!horizonTheme && addResponse.sections) {
      if (onCartPage) {
        applySections(addResponse.sections);
      } else if (action !== 'redirect' && cartDrawer && typeof cartDrawer.renderContents === 'function') {
        prepareDawnCartUi(cartDrawer);
        cartDrawer.renderContents(addResponse);
      } else if (action !== 'redirect' && cartNotification && typeof cartNotification.renderContents === 'function') {
        prepareDawnCartUi(cartNotification);
        cartNotification.renderContents(addResponse);
      } else {
        applySections(addResponse.sections);
      }
    } else if (!horizonTheme && sectionIds.length) {
      await fetchAndReplaceSections(sectionIds);
    }

    const cart = await fetchCartState();
    if (cart?.item_count != null) {
      updateCartCount(cart.item_count);
    }

    dispatchCartEvents(cart || addResponse, addResponse);

    if (action === 'redirect') {
      window.location.href = getCartUrl();
      return;
    }

    if (action === 'stay_on_page' || action === 'stay' || action === 'none') {
      if (onCartPage) {
        scheduleCartPageRefresh(offers, getRuntimeSettings(), pageType);
      } else {
        window.__superUpsellRefreshCartAware?.();
      }
      return;
    }

    if (onCartPage) {
      scheduleCartPageRefresh(offers, getRuntimeSettings(), pageType);
      return;
    }

    if (horizonTheme) {
      openHorizonCartDrawer();
      window.__superUpsellRefreshCartAware?.();
      return;
    }

    const dawnHandled =
      Boolean(addResponse.sections) &&
      ((cartDrawer && typeof cartDrawer.renderContents === 'function') ||
        (cartNotification && typeof cartNotification.renderContents === 'function'));

    if (!dawnHandled) {
      openCartDrawer(addResponse.sections ? addResponse : cart);
    }

    window.__superUpsellRefreshCartAware?.();
  }

  function bindUpsellEvents(container, behavior) {
    const forms = container.querySelectorAll('[data-upsell-form]');
    const links = container.querySelectorAll('.upsell-link');

    // Track link clicks (full A/B payload)
    links.forEach(link => {
      if (link.getAttribute('data-events-bound')) return;
      link.setAttribute('data-events-bound', 'true');

      link.addEventListener('click', () => {
        const meta = readTrackingMetaFromEl(link);
        trackClick(meta.productHandle || '', meta.offerType, meta);
      });
    });

    forms.forEach(form => {
      // Prevent double binding
      if (form.getAttribute('data-events-bound')) return;
      form.setAttribute('data-events-bound', 'true');

      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const meta = readTrackingMetaFromEl(form);
        trackClick(meta.productHandle || '', meta.offerType, meta);

        const btn = form.querySelector('button[type="submit"]');
        const originalText = btn.innerText;
        btn.innerText = 'Adding...';
        btn.classList.add('loading');
        btn.disabled = true;

        const formData = new FormData(form);
        appendCartSectionsToFormData(formData, btn);

        try {
          const response = await fetch(getCartAddUrl(), {
            method: 'POST',
            body: formData
          });

          const resData = await response.json();
          const isError = resData.status && Number(resData.status) >= 400;
          const isSuccess = !isError && (resData.id || resData.items || resData.variant_id);

          if (isSuccess) {
            btn.innerText = 'Added!';
            // Cart token can change after add — refresh for conversion matching
            cachedCheckoutToken = null;
            prepareDawnCartUi(document.querySelector('cart-drawer') || document.querySelector('cart-notification'), btn);
            await syncCartAfterAdd(resData, behavior);
            setTimeout(() => {
              btn.innerText = originalText;
              btn.classList.remove('loading');
              btn.disabled = false;
            }, 2000);
          } else {
            btn.innerText = 'Error';
            setTimeout(() => {
              btn.innerText = originalText;
              btn.classList.remove('loading');
              btn.disabled = false;
            }, 2000);
          }
        } catch (error) {
          btn.innerText = 'Error';
          setTimeout(() => {
            btn.innerText = originalText;
            btn.classList.remove('loading');
            btn.disabled = false;
          }, 2000);
        }
      });
    });

    initUpsellSlider(container);
  }

  const runtimeSettings = getRuntimeSettings();
  mountManualUpsellBlocks(offers, runtimeSettings, pageType);

  // Auto-injection driven by widgetSettings placements + location keys
  const hasAnyOffers = offers.length > 0 || cartDrawerOffers.length > 0;
  const hasManualMounts = hasManualBlocksForPage(pageType) || hasPendingManualMounts;
  const cartDrawerPipelineEnabled = placements.cartDrawerAutoInject !== false;

  if (!pagePlacementDisabled && (hasAnyOffers || hasManualMounts || cartDrawerPipelineEnabled)) {
    runAutoInjection(offers, runtimeSettings, pageType);
    if (!hasManualBlocksForPage(pageType)) {
      refreshMountedUpsellWidgets(pageType);
    }
  }

  function remountIfPendingManualMounts() {
    if (!document.querySelector('[data-upsell-mount]:not([data-upsell-mounted])')) return;
    window.__superUpsellInitDone = false;
    initSuperUpsell();
  }

  if (!window.__superUpsellMountEventsBound) {
    window.__superUpsellMountEventsBound = true;
    document.addEventListener('shopify:section:load', remountIfPendingManualMounts);
    document.addEventListener('shopify:section:reorder', remountIfPendingManualMounts);
    document.addEventListener('shopify:block:select', remountIfPendingManualMounts);
    document.addEventListener('super-upsell:data-ready', remountIfPendingManualMounts);
  }

  function mountDrawerHost(host, drawerOffers) {
    if (!(host instanceof HTMLElement)) return;
    host.replaceChildren();

    document.querySelectorAll('[data-upsell-auto-injected^="cart-drawer-"]').forEach((widget) => {
      widget.remove();
    });

    if (isViewingCartPage()) {
      suDebug('mountDrawerHost skip: on /cart page');
      clearCartDrawerUpsellUI();
      return;
    }

    if (isLiveCartEmpty()) {
      suDebug('mountDrawerHost skip: live cart empty');
      clearCartDrawerUpsellUI();
      return;
    }

    drawerOffers = filterDrawerOffersForMount(drawerOffers);
    if (window.SUPER_UPSELL_DATA) {
      window.SUPER_UPSELL_DATA.cartDrawerOffers = drawerOffers;
    }

    if (!drawerOffers.length) {
      suDebug('mountDrawerHost skip: cartDrawerOffers empty', {
        theme: window.Shopify?.theme?.name,
        themeId: window.Shopify?.theme?.id,
        build: SUPER_UPSELL_BUILD
      });
      clearCartDrawerUpsellUI();
      return;
    }
    if (placements.cartDrawerAutoInject === false) {
      suDebug('mountDrawerHost skip: cartDrawerAutoInject=false');
      clearCartDrawerUpsellUI();
      return;
    }

    revealDrawerHost(host);
    suDebug('mountDrawerHost', {
      offerCount: drawerOffers.length,
      drawer: findCartDrawerElement()?.tagName || null,
      build: SUPER_UPSELL_BUILD
    });

    // Place widgets relative to the real drawer DOM so before/after/append work.
    // Host remains for refresh lifecycle only.
    const drawer = findCartDrawerElement();
    const mountRoot = drawer || host;
    const grouped = groupOffersByType(drawerOffers);
    const contextSettings = getRuntimeSettings('drawer');

    OFFER_TYPE_ORDER.forEach((offerType) => {
      if (offerType === 'fbt' && !ENABLE_FBT) return;

      const typeOffers = grouped[offerType];
      if (!typeOffers?.length) return;

      if (isOfferTypeCoveredByManualBlock(offerType, { id: 'cart-drawer', context: 'drawer' }, pageType)) {
        return;
      }

      const config = resolveInjectionConfig(pageType, 'drawer', offerType);
      if (!config || config.autoInject === false) return;

      const contextId = `cart-drawer-${offerType}`;
      initUpsells(typeOffers, contextSettings, pageType, {
        contextId,
        context: 'drawer',
        contextPrefix: 'cart-drawer',
        offerType,
        rootElement: mountRoot,
        selector: config.selector,
        injectionLocation: config.injectionLocation
      });
    });

    scheduleQorumDrawerLayoutRefresh();
  }

  window.__superUpsellDrawerMountImpl = mountDrawerHost;
  document.dispatchEvent(new CustomEvent('super-upsell:ready'));
  bootstrapDrawerHost();
  // Cache mount only — avoid a boot-time cart.js + /cart HTML fetch.
  if (typeof remountDrawerWidgetsIfMissing === 'function') {
    remountDrawerWidgetsIfMissing();
  }
  }

  let globalCartRefreshInFlight = false;
  let globalCartRefreshQueued = false;
  let cartDrawerRetryGeneration = 0;
  let drawerDomRemountGeneration = 0;
  let drawerOfferRefreshTimer = null;
  let drawerOfferRefreshInFlight = false;
  let drawerOfferRefreshQueued = false;

  function updateSuperUpsellBootstrapData(patch) {
    if (!patch || typeof patch !== 'object') return;
    if (!window.SUPER_UPSELL_DATA || typeof window.SUPER_UPSELL_DATA !== 'object') {
      window.SUPER_UPSELL_DATA = {};
    }
    Object.assign(window.SUPER_UPSELL_DATA, patch);

    const node = document.getElementById('super-upsell-data-json');
    if (!node?.textContent?.trim()) return;

    try {
      let current = parseSuperUpsellPayloadText(node.textContent);
      if (!current) return;
      Object.assign(current, patch);
      node.textContent = JSON.stringify(current);
    } catch (error) {
      console.error('Super Upsell: Failed to sync bootstrap JSON', error);
    }
  }

  function removeCartDrawerWidgets() {
    document.querySelectorAll('[data-upsell-auto-injected^="cart-drawer-"]').forEach((widget) => {
      widget.remove();
    });
  }

  /** Dawn / Horizon empty-cart signals in the live drawer DOM. */
  function isLiveCartEmpty() {
    const dawnDrawer = document.querySelector('cart-drawer');
    if (dawnDrawer?.classList.contains('is-empty')) return true;

    const drawerInner = document.querySelector('cart-drawer .drawer__inner.is-empty, .drawer__inner.is-empty');
    if (drawerInner) return true;

    const horizonDrawer = document.querySelector('cart-drawer-component');
    if (horizonDrawer) {
      const items = horizonDrawer.querySelectorAll(
        '.cart-items .cart-item, [data-cart-item], .cart-drawer__items .cart-item'
      );
      const emptyMsg = horizonDrawer.querySelector('.cart-drawer__empty, [data-cart-empty]');
      if (emptyMsg && items.length === 0) return true;
    }

    return false;
  }

  /** Hide every drawer upsell surface — widgets, host shell, Qorum panel, cached offers. */
  function clearCartDrawerUpsellUI() {
    removeCartDrawerWidgets();

    document.querySelectorAll('super-upsell-drawer[data-super-upsell-drawer]').forEach((host) => {
      host.replaceChildren();
      host.setAttribute('hidden', '');
      host.style.display = 'none';
    });

    document.querySelectorAll('.upsell-container--drawer, .upsell-container--qorum').forEach((node) => {
      if (node.closest('[data-upsell-auto-injected^="cart-drawer-"]')) return;
      if (
        node.matches('[data-upsell-auto-injected^="cart-drawer-"]') ||
        node.classList.contains('upsell-container--qorum')
      ) {
        node.remove();
      }
    });

    if (window.SUPER_UPSELL_DATA) {
      window.SUPER_UPSELL_DATA.cartDrawerOffers = [];
    }

    try {
      updateSuperUpsellBootstrapData({ cartDrawerOffers: [] });
    } catch (_) {
      /* bootstrap helper may not exist yet during early boot */
    }

    // Qorum panel helpers live inside initSuperUpsell — hide/cleanup directly here.
    const panel = document.querySelector('.qorum-upsell-panel[data-qorum-upsell-panel]');
    if (panel) {
      panel.hidden = true;
      panel.classList.remove('qorum-upsell-panel--external', 'qorum-layout-stacked');
      panel.removeAttribute('style');
      const body = panel.querySelector('.qorum-upsell-panel__body');
      if (body) body.replaceChildren();
      if (panel.parentElement !== document.body) {
        document.body.appendChild(panel);
      }
    }
    document
      .querySelectorAll('dialog.qorum-drawer-has-external-panel, .qorum-drawer-has-external-panel')
      .forEach((node) => {
        node.classList.remove('qorum-drawer-has-external-panel');
        node.style.removeProperty('--qorum-external-panel-width');
      });
    document.querySelectorAll('.qorum-drawer-split').forEach((node) => {
      node.classList.remove('qorum-drawer-split');
    });

    suDebug('clearCartDrawerUpsellUI');
  }

  function revealDrawerHost(host) {
    if (!(host instanceof HTMLElement)) return;
    host.removeAttribute('hidden');
    host.style.removeProperty('display');
  }

  function getGlobalEmbedSectionId() {
    const fromData = window.SUPER_UPSELL_DATA?.embedSectionId;
    if (typeof fromData === 'string' && fromData.trim()) return fromData.trim();

    const node = document.getElementById('super-upsell-data-json');
    const host = node?.closest('[id^="shopify-section-"]');
    if (host?.id?.startsWith('shopify-section-')) {
      return host.id.slice('shopify-section-'.length);
    }

    return null;
  }

  function filterOffersForRuntime(offerList, abSurface = AB_SURFACE_PAGE) {
    return filterRuntimeOfferList(offerList, abSurface);
  }

  /**
   * Body app embeds are NOT shopify-section wrappers, so Section Rendering API
   * with `sections=embed` often returns empty HTML. Prefer a real section id when
   * present; otherwise fetch `/cart` HTML so Liquid re-renders offers with the
   * live cart context.
   */
  function isRenderableShopifySectionId(sectionId) {
    const id = String(sectionId || '').trim();
    if (!id) return false;
    // Manual theme.liquid embed uses a fake id — Section Rendering API never returns it.
    if (id === 'embed' || id === 'theme-super-upsell') return false;
    return true;
  }

  async function fetchEmbedPayloadFromCartContext() {
    const root = window.Shopify?.routes?.root || '/';
    const sectionId = getGlobalEmbedSectionId();

    // Skip a guaranteed-empty round-trip for body embeds (theme-super-upsell).
    if (isRenderableShopifySectionId(sectionId)) {
      try {
        const sectionRes = await fetch(
          `${root}cart?sections=${encodeURIComponent(sectionId)}&_=${Date.now()}`,
          { credentials: 'same-origin' }
        );
        if (sectionRes.ok) {
          const payload = await sectionRes.json();
          const html = payload[sectionId];
          if (html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const node = doc.getElementById('super-upsell-data-json');
            const parsed = normalizeSuperUpsellData(parseSuperUpsellPayloadText(node?.textContent));
            if (parsed) return parsed;
          }
        }
      } catch (error) {
        console.error('Super Upsell: section refresh failed, falling back to cart HTML', error);
      }
    }

    try {
      const pageRes = await fetch(`${root}cart?_=${Date.now()}`, {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      });
      if (!pageRes.ok) return null;
      const html = await pageRes.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const node = doc.getElementById('super-upsell-data-json');
      return normalizeSuperUpsellData(parseSuperUpsellPayloadText(node?.textContent));
    } catch (error) {
      console.error('Super Upsell: cart HTML embed refresh failed', error);
      return null;
    }
  }

  /**
   * Match preloaded drawerOfferCatalog against live cart.js items.
   * Avoids waiting on full /cart HTML Liquid re-render for Complete the Look.
   */
  function matchDrawerCatalogToCart(catalog, cart) {
    const list = Array.isArray(catalog) ? catalog : [];
    if (!list.length || !cart || !Array.isArray(cart.items) || !cart.items.length) {
      return [];
    }

    const handles = new Set();
    const productIds = new Set();
    const inCartProductIds = new Set();

    cart.items.forEach((item) => {
      const handle = String(item.handle || item.product_handle || '').trim();
      if (handle) handles.add(handle);
      const pid = Number(item.product_id || item.productId || 0);
      if (pid) {
        productIds.add(pid);
        inCartProductIds.add(pid);
      }
    });

    const matched = [];
    const seen = new Set();

    list.forEach((offer) => {
      if (!offer || typeof offer !== 'object') return;

      const offerId = Number(offer.id || 0);
      if (offerId && inCartProductIds.has(offerId)) return;

      const triggerHandles = Array.isArray(offer.triggerHandles) ? offer.triggerHandles : [];
      const triggerIds = Array.isArray(offer.triggerIds) ? offer.triggerIds : [];
      const triggerProductIds = Array.isArray(offer.triggerProductIds)
        ? offer.triggerProductIds
        : [];

      const hit =
        triggerHandles.some((h) => handles.has(String(h || '').trim())) ||
        triggerIds.some((id) => productIds.has(Number(id) || 0)) ||
        triggerProductIds.some((id) => productIds.has(Number(id) || 0));

      if (!hit) return;

      const key = `${offer.handle || offer.id || ''}|${offer.offerType || ''}|${offer.ruleId || ''}|${offer.abVariant || 'A'}`;
      if (seen.has(key)) return;
      seen.add(key);
      matched.push(offer);
    });

    return matched;
  }

  function getDrawerOfferCatalog() {
    const raw = window.SUPER_UPSELL_DATA?.drawerOfferCatalog;
    if (Array.isArray(raw)) return raw;
    if (typeof raw === 'string') {
      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }
    return [];
  }

  /**
   * @returns {Promise<Array|null>} offers array, [] when cart empty, null on fetch failure
   * (null must not wipe cached widgets).
   */
  async function fetchCartDrawerOffersFromEmbed() {
    const root = window.Shopify?.routes?.root || '/';

    try {
      const cartRes = await fetch(`${root}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!cartRes.ok) return null;

      const cart = await cartRes.json();
      if ((cart.item_count ?? 0) === 0) return [];

      // Fast path: match preloaded catalog against cart.js (no /cart HTML).
      const catalogMatched = matchDrawerCatalogToCart(getDrawerOfferCatalog(), cart);
      const fastOffers = filterOffersForRuntime(catalogMatched, AB_SURFACE_DRAWER);
      if (fastOffers.length) {
        suDebug('drawer catalog fast-path', { count: fastOffers.length });
        return fastOffers;
      }

      // Fallback: Liquid re-render via cart HTML (collection edge-cases / empty catalog).
      const parsed = await fetchEmbedPayloadFromCartContext();
      if (!parsed) return null;

      let drawerOffers = parsed?.cartDrawerOffers;
      if (typeof drawerOffers === 'string') {
        try {
          drawerOffers = JSON.parse(drawerOffers);
        } catch {
          return null;
        }
      }

      return filterOffersForRuntime(drawerOffers, AB_SURFACE_DRAWER);
    } catch (error) {
      console.error('Super Upsell: Failed to fetch cart drawer offers', error);
      return null;
    }
  }

  function remountDrawerWidgetsIfMissing() {
    if (window.__superUpsellRemounting) return false;

    if (isViewingCartPage() || isLiveCartEmpty()) {
      clearCartDrawerUpsellUI();
      return false;
    }

    const drawerOffers = filterDrawerOffersForMount(window.SUPER_UPSELL_DATA?.cartDrawerOffers);
    if (window.SUPER_UPSELL_DATA) {
      window.SUPER_UPSELL_DATA.cartDrawerOffers = drawerOffers;
    }
    const hasDrawerOffers = drawerOffers.length > 0;
    if (!hasDrawerOffers) {
      clearCartDrawerUpsellUI();
      return false;
    }

    const hasDrawerWidget = document.querySelector('[data-upsell-auto-injected^="cart-drawer-"]');
    if (hasDrawerWidget) {
      const host = ensureDrawerHostElement();
      revealDrawerHost(host);
      return true;
    }

    window.__superUpsellRemounting = true;
    try {
      const host = ensureDrawerHostElement();
      revealDrawerHost(host);
      if (host && window.__superUpsellDrawerApi?.mount) {
        window.__superUpsellDrawerApi.mount(host, drawerOffers);
        return Boolean(document.querySelector('[data-upsell-auto-injected^="cart-drawer-"]'));
      }

      if (window.__superUpsellDrawerMountImpl) {
        window.__superUpsellForceCartRefresh = true;
        initSuperUpsell();
      }
      return Boolean(document.querySelector('[data-upsell-auto-injected^="cart-drawer-"]'));
    } finally {
      window.__superUpsellRemounting = false;
    }
  }

  // DOM-only retries after cart morph. Never triggers network.
  // Uses its own generation so network refresh cannot cancel these timers.
  function scheduleDrawerRemountRetries() {
    const generation = ++drawerDomRemountGeneration;
    // One quick follow-up is enough for Dawn; catalog path mounts immediately.
    [0, 120].forEach((delay) => {
      window.setTimeout(() => {
        if (generation !== drawerDomRemountGeneration) return;
        remountDrawerWidgetsIfMissing();
      }, delay);
    });
  }

  async function runDrawerOfferNetworkRefresh() {
    if (drawerOfferRefreshInFlight) {
      drawerOfferRefreshQueued = true;
      return;
    }

    drawerOfferRefreshInFlight = true;
    try {
      remountDrawerWidgetsIfMissing();
      // Real fetch path only — never call __superUpsellRefreshCartAware here (that queues).
      await globalRefreshCartAwareOffers();
    } finally {
      drawerOfferRefreshInFlight = false;
      // Horizon often morphs AFTER section HTML fetch — remount again.
      remountDrawerWidgetsIfMissing();
      scheduleDrawerRemountRetries();
      if (drawerOfferRefreshQueued) {
        drawerOfferRefreshQueued = false;
        queueDrawerOfferRefresh();
      }
    }
  }

  // Coalesce burst cart / ATC / section events into one cart.js + embed fetch.
  function queueDrawerOfferRefresh() {
    if (isSuperUpsellSliderInteractionActive()) return;
    window.clearTimeout(drawerOfferRefreshTimer);
    const hasCachedDrawerOffers =
      filterDrawerOffersForMount(window.SUPER_UPSELL_DATA?.cartDrawerOffers).length > 0;
    // Empty cache (first ATC) → fetch immediately; otherwise short coalesce.
    const delay = hasCachedDrawerOffers ? 100 : 0;
    drawerOfferRefreshTimer = window.setTimeout(() => {
      if (isSuperUpsellSliderInteractionActive()) return;
      runDrawerOfferNetworkRefresh();
    }, delay);
  }

  window.__superUpsellRemountDrawerIfMissing = remountDrawerWidgetsIfMissing;
  window.__superUpsellScheduleDrawerRemountRetries = scheduleDrawerRemountRetries;
  window.__superUpsellQueueDrawerOfferRefresh = queueDrawerOfferRefresh;

  function syncCartDrawerWidgets() {
    const drawerOffers = window.SUPER_UPSELL_DATA?.cartDrawerOffers;
    const hasDrawerOffers = Array.isArray(drawerOffers) && drawerOffers.length > 0;
    if (!hasDrawerOffers) return;

    if (!document.querySelector('[data-upsell-auto-injected^="cart-drawer-"]')) {
      remountDrawerWidgetsIfMissing();
    }
  }

  function scheduleCartDrawerWidgetRetries(generation) {
    [80, 280].forEach((delay) => {
      window.setTimeout(() => {
        if (generation !== cartDrawerRetryGeneration) return;
        syncCartDrawerWidgets();
      }, delay);
    });
  }

  async function refreshCartPageOffersOnly() {
    if (!window.location.pathname.includes('/cart')) return;

    const root = window.Shopify?.routes?.root || '/';

    try {
      const parsed = await fetchEmbedPayloadFromCartContext();
      if (!parsed) return;

      let pageOffers = filterOffersForRuntime(parsed.offers, AB_SURFACE_PAGE);

      try {
        const cartRes = await fetch(`${root}cart.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (cartRes.ok) {
          const cartJson = await cartRes.json();
          if ((cartJson.item_count ?? 0) === 0) pageOffers = [];
        }
      } catch (_) {
        /* ignore */
      }

      updateSuperUpsellBootstrapData({ offers: pageOffers });
      document.querySelectorAll('[data-upsell-auto-injected^="cart-page-"]').forEach((widget) => {
        widget.remove();
      });

      if (pageOffers.length) {
        window.__superUpsellForceCartRefresh = true;
        initSuperUpsell();
      }
    } catch (error) {
      console.error('Super Upsell: Failed to refresh cart page offers', error);
    }
  }

  async function globalRefreshCartAwareOffers() {
    bootstrapDrawerHost();
    const drawerHost = document.querySelector('super-upsell-drawer[data-super-upsell-drawer]');
    if (drawerHost && typeof drawerHost.refresh === 'function') {
      await drawerHost.refresh();
      remountDrawerWidgetsIfMissing();
      scheduleDrawerRemountRetries();
      if (window.location.pathname.includes('/cart')) {
        await refreshCartPageOffersOnly();
      }
      return;
    }

    if (globalCartRefreshInFlight) {
      globalCartRefreshQueued = true;
      return;
    }
    globalCartRefreshInFlight = true;
    const refreshGeneration = ++cartDrawerRetryGeneration;

    try {
      const root = window.Shopify?.routes?.root || '/';

      // Parallel cart.js + Liquid embed refresh (no artificial wait).
      const cartPromise = fetch(`${root}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(async (cartRes) => {
          if (!cartRes.ok) return null;
          const cartJson = await cartRes.json();
          return cartJson.item_count ?? 0;
        })
        .catch(() => null);

      const parsedPromise = fetchEmbedPayloadFromCartContext();
      const [cartItemCount, parsed] = await Promise.all([cartPromise, parsedPromise]);
      if (!parsed) return;

      let drawerOffers = filterOffersForRuntime(parsed.cartDrawerOffers, AB_SURFACE_DRAWER);
      if (cartItemCount === 0 || isLiveCartEmpty()) {
        drawerOffers = [];
      }

      const pageType = parsed.pageType || window.SUPER_UPSELL_DATA?.pageType || '';
      const onCartPage = pageType === 'cart' || window.location.pathname.includes('/cart');
      let pageOffers = filterOffersForRuntime(parsed.offers, AB_SURFACE_PAGE);
      if (cartItemCount === 0) {
        pageOffers = [];
      }

      const bootstrapPatch = { cartDrawerOffers: drawerOffers };
      if (onCartPage) {
        bootstrapPatch.offers = pageOffers;
      }

      const previousDrawerFingerprint = getDrawerOffersFingerprint(
        window.SUPER_UPSELL_DATA?.cartDrawerOffers
      );
      const nextDrawerFingerprint = getDrawerOffersFingerprint(drawerOffers);
      const hasMountedDrawerWidgets = Boolean(
        document.querySelector('[data-upsell-auto-injected^="cart-drawer-"]')
      );

      updateSuperUpsellBootstrapData(bootstrapPatch);

      if (!drawerOffers.length) {
        clearCartDrawerUpsellUI();
        return;
      }

      if (
        hasMountedDrawerWidgets &&
        previousDrawerFingerprint === nextDrawerFingerprint &&
        !window.__superUpsellForceCartRefresh
      ) {
        remountDrawerWidgetsIfMissing();
        if (isQorumShop()) scheduleQorumDrawerLayoutRefresh();
        return;
      }

      removeCartDrawerWidgets();
      if (onCartPage) {
        document.querySelectorAll('[data-upsell-auto-injected^="cart-page-"]').forEach((widget) => {
          widget.remove();
        });
      }

      window.__superUpsellForceCartRefresh = true;
      initSuperUpsell();
      remountDrawerWidgetsIfMissing();
      scheduleDrawerRemountRetries();

      if (refreshGeneration === cartDrawerRetryGeneration) {
        scheduleCartDrawerWidgetRetries(refreshGeneration);
      }
    } catch (error) {
      console.error('Super Upsell: Failed to globally refresh cart-aware offers', error);
    } finally {
      globalCartRefreshInFlight = false;
      if (globalCartRefreshQueued) {
        globalCartRefreshQueued = false;
        globalRefreshCartAwareOffers();
      }
    }
  }

  // Public entry: remount from cache now, one debounced network refresh later.
  // Direct callers (ATC handlers, etc.) must use this — not globalRefreshCartAwareOffers.
  window.__superUpsellRefreshCartAware = function refreshCartAwareDebounced() {
    remountDrawerWidgetsIfMissing();
    scheduleDrawerRemountRetries();
    queueDrawerOfferRefresh();
  };

  function resolveDrawerHostAnchor() {
    const target = resolveUpsellThemeTarget();
    const drawerRoot =
      queryFirstFromSelectorList(target.drawerRootSelector) ||
      queryFirstFromSelectorList(target.drawerSelector) ||
      findCartDrawerElement();

    // 1) Common: host near cart form when present (all themes).
    const formScope = drawerRoot || document;
    const cartForm = findDrawerCartForm(formScope);
    if (cartForm) {
      return { anchor: cartForm, insertMode: 'beforebegin' };
    }

    // 2) Theme-wise fallback mount.
    if (drawerRoot) {
      const mount =
        queryFirstFromSelectorList(target.drawerUpsellMount, drawerRoot) ||
        queryFirstFromSelectorList(target.drawerUpsellMount, document);
      if (mount) {
        const insertMode = target.drawerUpsellInsert || 'beforebegin';
        if (
          insertMode === 'beforebegin' ||
          insertMode === 'afterend' ||
          insertMode === 'afterbegin' ||
          insertMode === 'beforeend'
        ) {
          return { anchor: mount, insertMode };
        }
        return { anchor: mount, insertMode: 'beforebegin' };
      }

      const header =
        queryFirstFromSelectorList(target.headerSelector, drawerRoot) ||
        queryFirstFromSelectorList(target.headerSelector, document);
      if (header) {
        return { anchor: header, insertMode: target.hostInsertPosition || 'afterend' };
      }
    }

    const tinkerInner =
      document.querySelector('cart-drawer-component .cart-drawer__inner') ||
      document.querySelector('theme-drawer#cart-drawer cart-drawer-component') ||
      document.querySelector('#cart-drawer cart-drawer-component');

    if (tinkerInner) {
      const summary =
        tinkerInner.querySelector('.cart-drawer__summary') ||
        tinkerInner.querySelector('.cart-drawer__checkout') ||
        tinkerInner.querySelector('[ref="checkoutButtons"]');
      if (summary) {
        return { anchor: summary, insertMode: 'afterbegin' };
      }

      const items =
        tinkerInner.querySelector('.cart-drawer__items') ||
        tinkerInner.querySelector('cart-items-component');
      if (items) {
        return { anchor: items, insertMode: 'afterend' };
      }
    }

    const dawnRoot =
      document.querySelector('cart-drawer .drawer__inner') ||
      document.querySelector('cart-drawer #CartDrawer') ||
      document.querySelector('cart-drawer');

    if (dawnRoot) {
      const footer =
        dawnRoot.querySelector('.cart-drawer__footer') ||
        dawnRoot.querySelector('.drawer__footer');
      if (footer) {
        return { anchor: footer, insertMode: 'beforebegin' };
      }

      const drawerItems = dawnRoot.querySelector('cart-drawer-items');
      if (drawerItems) {
        return { anchor: drawerItems, insertMode: 'afterend' };
      }
    }

    // Prestige / Habitat / Impulse / aromaedge fallbacks
    if (drawerRoot) {
      const footerFallback =
        drawerRoot.querySelector(
          '.drawer__footer, .cart-drawer__footer, .side-panel-footer, .ajax-cart__footer, .drawer_footer, [slot="footer"]'
        ) || null;
      if (footerFallback) {
        return { anchor: footerFallback, insertMode: 'beforebegin' };
      }
      const headerFallback =
        drawerRoot.querySelector(
          '.drawer__header, .cart-drawer__header, .side-panel-header, [slot="header"], .drawer_header, .ajax-cart__header'
        ) || null;
      if (headerFallback) {
        return { anchor: headerFallback, insertMode: 'afterend' };
      }
    }

    return null;
  }

  function findDrawerMountParent() {
    const target = resolveUpsellThemeTarget();
    return (
      queryFirstFromSelectorList(target.drawerRootSelector) ||
      queryFirstFromSelectorList(target.drawerSelector) ||
      document.querySelector('cart-drawer-component .cart-drawer__inner') ||
      document.querySelector('theme-drawer#cart-drawer cart-drawer-component') ||
      document.querySelector('#cart-drawer cart-drawer-component') ||
      document.querySelector('cart-drawer .drawer__inner') ||
      document.querySelector('cart-drawer #CartDrawer') ||
      document.querySelector('cart-drawer') ||
      findCartDrawerElement()
    );
  }

  function isDrawerHostCorrectlyPlaced(host, anchor, insertMode) {
    if (!(host instanceof HTMLElement) || !(anchor instanceof HTMLElement)) return false;

    if (insertMode === 'beforebegin') {
      return host.nextElementSibling === anchor;
    }

    if (insertMode === 'afterend') {
      return host.previousElementSibling === anchor;
    }

    if (insertMode === 'afterbegin') {
      return host.parentElement === anchor && anchor.firstElementChild === host;
    }

    if (insertMode === 'beforeend') {
      return host.parentElement === anchor && anchor.lastElementChild === host;
    }

    return host.parentElement === anchor.parentElement;
  }

  function ensureDrawerHostElement() {
    const placement = resolveDrawerHostAnchor();
    if (!placement) {
      suDebug('ensureDrawerHostElement: no anchor', {
        themeFamily: detectUpsellThemeFamily?.() || null,
        hasCartDrawer: Boolean(findCartDrawerElement())
      });
      return null;
    }

    const { anchor, insertMode } = placement;
    let existing = document.querySelector('super-upsell-drawer[data-super-upsell-drawer]');

    if (existing?.isConnected) {
      if (!isDrawerHostCorrectlyPlaced(existing, anchor, insertMode)) {
        anchor.insertAdjacentElement(insertMode, existing);
        suDebug('ensureDrawerHostElement: re-placed host', {
          anchor: anchor.tagName,
          insertMode
        });
      }
      if (
        isLiveCartEmpty() ||
        !filterDrawerOffersForMount(window.SUPER_UPSELL_DATA?.cartDrawerOffers).length
      ) {
        existing.setAttribute('hidden', '');
        existing.style.display = 'none';
        existing.replaceChildren();
      }
      return existing;
    }

    const host = document.createElement('super-upsell-drawer');
    host.setAttribute('data-super-upsell-drawer', '');
    if (
      isLiveCartEmpty() ||
      !filterDrawerOffersForMount(window.SUPER_UPSELL_DATA?.cartDrawerOffers).length
    ) {
      host.setAttribute('hidden', '');
      host.style.display = 'none';
    }
    anchor.insertAdjacentElement(insertMode, host);
    suDebug('ensureDrawerHostElement: created host', {
      anchor: anchor.tagName,
      insertMode,
      build: SUPER_UPSELL_BUILD
    });
    return host;
  }

  class SuperUpsellDrawer extends HTMLElement {
    #refreshing = false;
    #refreshQueued = false;

    connectedCallback() {
      this.classList.add('super-upsell-drawer');

      // Reconnect after morph: restore from cache only (no network, no per-host
      // cart listeners — global debounced queue owns fetches).
      const cached = filterDrawerOffersForMount(window.SUPER_UPSELL_DATA?.cartDrawerOffers);
      if (
        cached.length &&
        window.__superUpsellDrawerApi?.mount &&
        !document.querySelector('[data-upsell-auto-injected^="cart-drawer-"]')
      ) {
        window.__superUpsellDrawerApi.mount(this, cached);
      }
    }

    disconnectedCallback() {
      // Remount is driven by cart events + short DOM retries (no observer).
    }

    getEmbedSectionId() {
      return getGlobalEmbedSectionId();
    }

    fetchDrawerOffers() {
      return fetchCartDrawerOffersFromEmbed();
    }

    async waitForDrawerApi(maxMs = 2000) {
      if (window.__superUpsellDrawerApi?.mount) return;
      const started = Date.now();
      while (!window.__superUpsellDrawerApi?.mount) {
        if (Date.now() - started > maxMs) return;
        await new Promise((resolve) => window.requestAnimationFrame(resolve));
      }
    }

    async refresh() {
      if (this.#refreshing) {
        this.#refreshQueued = true;
        return;
      }

      this.#refreshing = true;

      try {
        const cached = filterDrawerOffersForMount(window.SUPER_UPSELL_DATA?.cartDrawerOffers);

        // After Horizon cart morph, restore from cache before network so UI
        // never stays empty. Network still runs once via the debounced queue.
        if (
          cached.length &&
          this.isConnected &&
          !document.querySelector('[data-upsell-auto-injected^="cart-drawer-"]')
        ) {
          await this.waitForDrawerApi();
          window.__superUpsellDrawerApi?.mount?.(this, cached);
        }

        const offers = await this.fetchDrawerOffers();

        // Fetch failure: keep whatever is currently mounted + retry DOM remount.
        if (offers === null) {
          remountDrawerWidgetsIfMissing();
          scheduleDrawerRemountRetries();
          return;
        }

        updateSuperUpsellBootstrapData({ cartDrawerOffers: offers });

        if (!offers.length || isLiveCartEmpty()) {
          clearCartDrawerUpsellUI();
          return;
        }

        await this.waitForDrawerApi();
        if (!this.isConnected) {
          remountDrawerWidgetsIfMissing();
          scheduleDrawerRemountRetries();
          return;
        }

        // Always remount after cart change so offer list re-renders
        // (even when product IDs match — eligibility / prices can change).
        revealDrawerHost(this);
        window.__superUpsellDrawerApi?.mount?.(this, offers);
        scheduleDrawerRemountRetries();
      } finally {
        this.#refreshing = false;

        if (!this.isConnected) {
          remountDrawerWidgetsIfMissing();
          scheduleDrawerRemountRetries();
        } else if (this.#refreshQueued) {
          this.#refreshQueued = false;
          this.refresh();
        }
      }
    }
  }

  if (!customElements.get('super-upsell-drawer')) {
    customElements.define('super-upsell-drawer', SuperUpsellDrawer);
  }

  function bootstrapDrawerHost() {
    if (ensureDrawerHostElement()) return;

    let attempts = 0;
    const poll = window.setInterval(() => {
      if (ensureDrawerHostElement() || ++attempts >= 24) {
        window.clearInterval(poll);
      }
    }, 100);
  }

  function removeLegacyDrawerWidgets() {
    document.querySelectorAll('[data-upsell-auto-injected^="cart-drawer-"]').forEach((widget) => {
      if (widget.closest('super-upsell-drawer')) return;
      if (widget.closest('.scroll-hint .cart-drawer__items')) {
        widget.remove();
      }
    });
  }

  function bootSuperUpsell() {
    const finishBoot = () => {
      suDebug('finishBoot', {
        build: SUPER_UPSELL_BUILD,
        theme: window.Shopify?.theme || null,
        hasData: Boolean(window.SUPER_UPSELL_DATA),
        cartDrawerOffers: Array.isArray(window.SUPER_UPSELL_DATA?.cartDrawerOffers)
          ? window.SUPER_UPSELL_DATA.cartDrawerOffers.length
          : null
      });
      initSuperUpsell();
      removeLegacyDrawerWidgets();
      remountDrawerWidgetsIfMissing();
      // Drawer markup can settle after first paint (Horizon) — one short DOM retry.
      scheduleDrawerRemountRetries();
      if (isSuperUpsellDebug()) {
        window.__superUpsellDebugDump?.();
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', finishBoot, { once: true });
    } else {
      finishBoot();
    }

    // Theme editor section swaps — one remount + one queued fetch max.
    document.addEventListener('shopify:section:load', () => {
      remountDrawerWidgetsIfMissing();
      queueDrawerOfferRefresh();
    });
  }

  function refreshSuperUpsellFromThemeEditor() {
    window.__superUpsellInitDone = false;
    initSuperUpsell();
  }

  document.addEventListener('super-upsell:data-ready', initSuperUpsell);
  document.addEventListener('shopify:section:load', refreshSuperUpsellFromThemeEditor);
  document.addEventListener('shopify:section:reorder', refreshSuperUpsellFromThemeEditor);
  document.addEventListener('shopify:block:select', refreshSuperUpsellFromThemeEditor);
  bootSuperUpsell();
})();
